<template>
<v-layout row wrap class="centerbox CSChatThai" style="overflow: hidden !important;">
  <offline @detected-condition="handleConnectivityChange"></offline>
  <div class="chatbox">
     <vue-context ref="menu" style="z-index: 1500;">
          <li v-for="list in ListMenuRightClick">
              <a @click="SelectMenuRightClick(list.methods)">{{list.message}}</a>
          </li>
        </vue-context>
    <ShowPDFDialog :dialogshowfile="dialogshowfile" :DetailFile="DetailFile" @closeDialogShowFile="closeDialogShowFile"/>
    <ShowImageDialog :dialogshowimage="dialogshowimage" :DetailImage="DetailImage" @closeDialogShowImage="closeDialogShowImage"/>
    <form ref="fileformChat">
    <div class="chatlogs" id="myscroll" v-on:scroll="scrollFunction" :style="chatlogsFlex">
      <div v-if="listannounce.length != 0">
        <v-btn fab dark small v-if="less" @click="less = !less;show = false;" style="position: fixed; right: 26%;z-index: 2;background: #2562afd4;">
          <v-icon style="font-size: 15px;">fas fa-bullhorn</v-icon>
        </v-btn>
        <v-card style=" position: fixed; width: calc(100vw - calc(50% - -20px)); z-index: 2;    margin-left: -15px;margin-top: -5px; background: none;" v-else id="list_height">
        <v-slide-y-transition>
          <v-card-text v-show="show" style="padding: 0px !important;">
            <v-list style="max-height: 200px;" class="scrolling-wrapper-y">
              <template v-for="(item, index) in listannounce">
                <v-list-tile
                  :key="item.index"
                  avatar
                  @contextmenu.prevent="RightClickDialog($event, ['cancel_announce'], item)"
                  class="list-announce">
                  <v-list-tile-action>
                    <v-icon style="font-size: 18px;">fas fa-bullhorn</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title style="font-size: 13px;"  v-html="convertMention(item.message_info.message)"></v-list-tile-title>
                    <v-list-tile-sub-title style="font-size: 12px;">{{ item.nickname }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="index + 1 < listannounce.length" :key="index"></v-divider>
              </template>
            </v-list>
          </v-card-text>
        </v-slide-y-transition>
        <v-card-actions v-if="!show" style="background: #2562afa6; height: 40px;">
          <v-icon style="font-size: 18px; color: #1b232c;">fas fa-bullhorn</v-icon>
          <p class="mb-0" style="color: black; padding-left: 20px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%; cursor: pointer; font-size: 13px;"
            @contextmenu.prevent="RightClickDialog($event, ['cancel_announce'], listannounce[0])" v-html="convertMentionAnnounce(listannounce[0].message_info.message)"></p>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="show = !show">
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-card-actions>
        <v-card-actions v-if="show" style="color: white;background: #2562af;height: 40px;">
          <p class="p-announce" @click="delete_announce()">{{$t('ChatSide.announce.delete')}}</p>
          |
          <p class="p-announce" @click="less = !less">{{$t('ChatSide.announce.minimize')}}</p>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="show = !show">
            <v-icon style="color: white;">keyboard_arrow_up</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
      </div>


      <div v-if="progressLoadChat">
        <v-progress-linear :indeterminate="progressLoadChat"></v-progress-linear>
      </div>
      <div v-for="(item,i) in items" :key="item.id" v-if="!ForwardState">
        <div v-if="i == 0">
         <!--  <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
            <v-btn round outline color="primary" style="background: #ff000000 !important;text-transform: none;font-size: 13px !important;height: 25px !important;">
              <v-icon left style="font-size: 13px !important;" @click="loadchathistory">refresh</v-icon>  {{$t('ChatSide.loadHistory')}}
            </v-btn>
          </div> -->
          <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect===item.tokenroom">
            <span>{{dateMoment(item.timestamp)}}</span>
          </div>
        </div>
        <div v-else-if="dateMoment(item.timestamp) != dateMoment(items[i-1].timestamp)">
          <br>
          <v-flex xl12 md12 sm12 lg12>
            <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect===item.tokenroom">
              <span>{{dateMoment(item.timestamp)}}</span>
            </div>
          </v-flex>
        </div>
        <p style="text-align:left; margin-left: calc(48px + 1vw);; margin-bottom: 0px; color: #8e8e8e; font-size:10px;" class="text"
          v-if="item.tokenuser != token && tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task'">{{item.nickname}}</p>
        <p style="text-align:left; margin-left: calc(48px + 1vw);; margin-bottom: 0px; color: #8e8e8e; font-size:10px;" class="text"
          v-else-if="item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.tokenuser != token && tokenrooomSelect == item.tokenroom && (dateMoment(item.timestamp) != dateMoment(items[i-1].timestamp) || items[i-1].tokenuser != item.tokenuser)">
          {{item.nickname}}</p>


        <div v-if="item.tokenuser === token && tokenrooomSelect===item.tokenroom" class="chat self">
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
            <p class="boxself_unsend">
              {{$t('ChatSide.system.self.cancelMsg')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
            <p class="boxself_unsend" v-if="item.message == 'edit_name_albums'">
              {{$t('ChatSide.system.self.editNameAlbum')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'create_albums'">
              {{$t('ChatSide.system.self.createAlbum',{name: item.albums_name})}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'delete_albums'">
              {{$t('ChatSide.system.self.deleteAlbum')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'delete_images_albums'">
              {{$t('ChatSide.system.self.deleteImageAlbum')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
            <p class="boxself_unsend" v-if="item.message == 'edit_task'">
              {{$t('ChatSide.system.self.editTask')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'create_project'">
              {{$t('ChatSide.system.self.createProject')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
            <p class="boxself_unsend">
              {{item.message}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
            <p class="boxself_system" >
              <span>{{timeMoment(item.timestamp)}} น.</span>
              <br>
              <span v-if="item.message === 'active'">
                {{$t('ChatSide.system.self.joinGroup')}}
              </span>
              <span v-else-if="item.message === 'kick'">
                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'invite'">
                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'leave'">
               {{$t('ChatSide.system.self.leftGroup')}}
              </span>
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px;" v-else>
            <!-- <v-tooltip left> -->
            <v-layout row wrap justify-end align-end>
              <span class="pr-2" style="font-size: 10px; color: #424242;">{{timeMoment(item.timestamp)}}</span>

            <div v-if="item.typeofmessage === 'message'" id="testTT" ref="testTT" style="height: 100%;" class="boxself" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel', 'announce'], item)">
              <p slot="activator" style="margin: 0 !important;" @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
              </p>
              <!-- <tax>{{name}}</tax> -->
              <!-- {{item.message}} -->
              <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
                <link-prevue :url="x">
                  <template slot-scope="props">
                    <!-- {{props}} -->
                    <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                      <v-flex xl9 lg9 md9 sm9 class="border_website">
                        <p class="title_website" >{{props.title}}  </p>
                        <span class="description_website">{{props.description}}</span>
                      </v-flex>
                      <v-flex xl3 lg3 md3 sm3 class="centerimg_website">
                        <img class="img_website" :src="props.img"  v-if="props.img">
                      </v-flex>
                    </v-layout>
                  </template>
                  <template slot="loading">
                    <span></span>
                  </template>
                </link-prevue>
             </div>
            </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="boxself" @contextmenu.prevent="RightClickDialog($event,['mention'], item)">
                <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                  <v-flex xs1>
                    <v-avatar>
                      <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                      <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs11 style="padding-left: 40px;">
                    <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <span @click="handleClickTest" v-html="convertMention(item.source_message.message)"></span>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.typeofmessage === 'image'">
                          {{$t('ChatSide.image')}}
                        </span>
                        <span v-else>
                        {{$t('ChatSide.sticker')}}
                      </span>
                      </v-flex>
                      <v-flex xs4>
                        <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span>{{$t('ChatSide.file')}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                        <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                      </v-flex>
                    </v-layout>
                    <v-layout column v-else-if="item.source_message.typeofmessage === 'video'">
                      <v-flex xs12>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <!-- <span>วิดีโอ</span> -->
                      </v-flex>
                      <v-flex xs12>
                        <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                          <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                        </video>
                        <div v-else style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 150px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                        <span v-else>{{item.source_message.message}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap style="padding-bottom: 10px;color: #6f6f6f;" v-else>
                  <span>{{$t('ChatSide.noMsg')}}</span>
                </v-layout>
                <v-divider></v-divider>
                <span style="font-weight: 500;" @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
              </p>

              <div v-else-if="item.typeofmessage === 'official_template'" class="boxselfquestion" style="overflow: hidden;display: -webkit-inline-box; background: none;">
                <div>
                  <v-card style="border-radius: 10px; width: 200px; margin-right: 10px; background: #b4d1f5 !important;">
                    <h3 class="mb-0" style="color: #2562af; padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                    <v-img :src="item.element.image" v-if="item.element.image" style="height: 160px;" contain></v-img>
                    <v-card-title primary-title style="padding-top: 15px !important;">
                      <div style="    width: 176px;">
                        <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="color:#343433;"></read-more>
                        <v-divider light v-if="!item.element.image"></v-divider>
                        <div v-for="(choice, index) in item.element.choice">
                          <!-- <v-btn flat style="text-transform: none; width: 100%;margin: 0;font-size: 13px; border-radius: 20px;">
                            {{choice.label}}
                          </v-btn> -->
                          <v-btn flat :style="checkbutton(choice.color,choice.background)" @click="btn_official_template(choice, item.tokenuser, item.tokenmessage)" :disabled="(choice.disable == '0')? false: true">
                            {{choice.label}}
                          </v-btn>
                        </div>
                      </div>
                    </v-card-title>
                  </v-card>
                </div>
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'image'" style="width: 250px;" class="boxselffile" @contextmenu.prevent="RightClickDialog($event,['albums', 'mention', 'cancel', 'sendmail'], item)">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card style="background: none; border-radius: 10px;display: flex; justify-content: center; cursor: pointer;" class="white--text">
                      <v-card-media class="white--text " height="200px" :src="item.message" @click="zoom(item)">
                      </v-card-media>
                    </v-card>
                  </v-flex>
                </v-layout>
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'sticker'" class="boxselfsticker" @contextmenu.prevent="RightClickDialog($event,['mention', 'cancel'], item)">
                <img :src="item.file_name" style="width: 150px; cursor: pointer;">
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="display: none;">
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 240px;" class="boxself_createablums" @click="detailAlbums(item.file_name)">
                <h3 class="mb-1" v-if="item.message !== 'addimage_albums'" style="color:#3a506d !important;">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                <h3 class="mb-1" v-else style="color:#3a506d !important;">
                  {{$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})}}
                </h3>
                <v-layout row wrap justify-center align-center>
                  <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                </v-layout>
                <p class="mt-1 mb-0" style="color: #3a506d91 !important;">
                  {{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}
                </p>
                <v-divider style="border-color: #31394121 !important;"></v-divider>
                <v-layout row wrap justify-center align-center class="mt-2">
                  <h4 v-if="item.albums_name != ''" style="color:#4c6281 !important;">{{item.albums_name}}</h4>
                  <h4 v-else style="color:#4c6281 !important;">{{dateMoment(item.create_date)}}</h4>
                  <v-spacer></v-spacer>
                  <v-icon style="font-size: 16px;color:#4c6281 !important;">fas fa-chevron-right</v-icon>
                </v-layout>
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'web'" class="boxself">
                <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'note'" style="width: 200px;cursor: pointer;" class="boxselffile" @click="detailNote(item.note_id)">
                <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <p style="color: black;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                      <p v-if="item.message.length == 20"> ...</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light style="border-color: #31394121 !important;"></v-divider>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #4c6281 !important; "> {{$t('ChatSide.note')}} </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #4c6281 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

              <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="boxselffile" @click="open_detail_task(item.task_id, item.tokenroom)">
                <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 xl11>
                      <v-layout column wrap>
                        <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                        <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                  <v-layout column wrap align-start>
                    <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                    <div style="margin-bottom: 5px; text-align: left;">
                      <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="profile" :src="profile" class="alligator-turtle">
                          <span v-else style="color: white;">{{name[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{name}}</span>
                      </v-chip>
                      <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                          <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{assign.nickname}}</span>
                      </v-chip>
                      <v-chip label color="#e6ecf3" outline text-color="#3a506d">
                        {{item.task_info.state.name}}
                      </v-chip>
                    </div>
                  </v-layout>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #6981a1 !important;">
                      {{$t('ChatSide.Task.viewDetail')}}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

               <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="boxselffile" @click="open_detail_task(item.task_id, item.tokenroom)">
                <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 xl11>
                      <v-layout column wrap>
                        <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                        <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                  <v-layout column wrap align-start>
                    <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                    <div style="margin-bottom: 5px; text-align: left;">
                      <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="profile" :src="profile" class="alligator-turtle">
                          <span v-else style="color: white;">{{name[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{name}}</span>
                      </v-chip>
                      <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                          <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{assign.nickname}}</span>
                      </v-chip>
                    </div>
                  </v-layout>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #6981a1 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'contact'" style="font-weight: 500; cursor: pointer; border-radius: 15px !important;" class="boxself" @click="detailFriend(item.message)">
                <v-avatar class="user-photo">
                  <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                  <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                  <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                  <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                </v-avatar>
                <p class="textchat" style="margin-right: 15px;">{{item.nickname_contact}}</p>
                <span style=" position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); right: 0;">
                  <v-icon>navigate_next</v-icon>
                </span>
              </div>
              <p slot="activator" v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" style="width: 300px;" class="boxselffile" @contextmenu.prevent="RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)">
                <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px;width: 100%;">
                  <v-card-media height="200px" style="border-radius: 10px;cursor: pointer; " v-if="extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media'" @click="zoomfile(item, true)"
                    @contextmenu.prevent="RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)">
                    <pdf :src="item.message" :page="1" ref="myPdfComponent" v-if="extension(item.file_name) === 'pdf'"></pdf>
                    <video controls style=" border-radius: 10px; height: 190px; cursor: pointer;" v-else-if="extension(item.file_name) === 'media'" >
                      <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                    </video>
                  </v-card-media>
                  <v-card-media height="55px" style="width: 280px; border-radius: 10px; cursor: pointer;" v-else-if="extension(item.file_name) === 'audio'" >
                    <audio controls style=" border-radius: 10px; width: 260px;display: flex;">
                      <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                    </audio>
                  </v-card-media>
                  <v-card-title primary-title style="padding-top: 10px;padding-left: 0px;padding-bottom: 10px; cursor: pointer;" v-if="extension(item.file_name) !== 'audio'" >
                    <div style="text-align:left; word-break: break-all !important; font-size:14px;color: white;">({{item.file_name}})
                    </div>
                  </v-card-title>
                </v-card>
              </p>


              <p slot="activator" v-else-if="item.typeofmessage === 'file'" style="width: 300px; cursor: pointer;" class="boxselffile" @contextmenu.prevent="RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)">
                <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs4 sm4 md4 lg4 xl4>
                      <v-icon style="color: white; font-size: 70px !important; display: flex; justify-content: center;">{{extension(item.file_name)}}
                      </v-icon>
                    </v-flex>
                    <v-flex xs8 sm8 md8 lg8 xl8>
                      <v-card-title primary-title style="text-align: left;">
                        <div>
                          <div style="width: 160px; word-break: break-all !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <v-btn slot="activator" flat icon color="white" @click="zoomfile(item, false)" style="margin-right: 10px;">
                        <v-icon>file_download</v-icon>
                      </v-btn>
                      <span>{{$t('AnswerQuestion.download')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn slot="activator" flat icon color="white" @click="sendimgonebox(item.tokenmessage)">
                        <v-icon>cloud_upload</v-icon>
                      </v-btn>
                      <span>{{$t('AnswerQuestion.sendOnebox')}}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </p>

              <div v-else-if="item.typeofmessage === 'video'" style="max-height: 250px; cursor: pointer;" class="boxselffile" slot="activator" @click="zoomfile(item, true)" @contextmenu.prevent="RightClickDialog($event, ['mention', 'cancel', 'sendmail'], item)">
                <video width="100%" height="250" slot="activator" v-if="extension(item.message) === 'media'" controls>
                  <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                </video>
                <vplayer
                  v-else
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                  @onplay="play"
                />
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'location'" style="max-width: 250px; min-width: 150px; cursor: pointer;" class="boxselffile" @click="openlocation(item)" @contextmenu.prevent="RightClickDialog($event, ['mention', 'cancel'], item)">
                <v-card style=" background: #b4d1f5 !important;border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" >
                  <v-layout style="text-align: left;" raw wrap>
                    <v-flex xs2 sm2 md2 lg2 xl2>
                      <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                    </v-flex>
                    <v-flex xs10 sm10 md10 lg10 xl10 style="color: black; padding-left: 10px;">
                      <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                      <span v-else> somewhere</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </div>

              <!-- get quickreply date-->
              <p slot="activator" v-else-if="item.typeofmessage === 'date'" class="boxself">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
              </p>
              <!-- get quickreply datetime-->
              <p slot="activator" v-else-if="item.typeofmessage === 'datetime'" class="boxself">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
                <br>
                <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; เวลา {{item.message.split('T')[1]}} น.
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'call'" class="boxself" style="text-align: center;width: 100px;font-weight: 500 !important;">
                <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
                <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                <br>
                <span v-if="item.message =='cancel' || item.message =='decline'">
                  {{checktypeCall(item.message)}}
                </span>
                <span v-else>{{secondsToHms(item.time_count)}}</span>
              </div>

              <!-- call agora -->
              <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="boxself" style="text-align: center;width: 100px;font-weight: 500 !important;">
                <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
                <br>
                <span v-if="item.message =='cancel'">
                  {{checktypeCall(item.message)}}
                </span>
                <span v-else>{{item.time}}</span>
              </div>

                <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="boxself" style="text-align: center;font-weight: 500 !important;">
                <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                <br>
                <v-btn class="joinBtn" @click="backCall_conference_msg(item.information)">{{$t('ChatSide.conference.joinCall')}} </v-btn>
                </div>

              <p slot="activator" v-else class="boxself" style="color: #6d6d6d !important;">
                {{$t('ChatSide.notSupportVersion')}}
              </p>
                <!-- <span>{{timeMoment(item.timestamp)}}</span> -->
              </v-layout>
            <!-- </v-tooltip> -->

            <v-tooltip top v-if="item.status=='no' && item.typeofmessage == 'message'">
              <span style="text-align:right; margin-bottom: 0px; color: #616161; font-size:10px;margin-left: 10vw;float: right;" @click="resendMessage(item)" slot="activator">
                <v-icon style="font-size:7px !important; cursor: pointer; ">autorenew</v-icon>
              </span>
              <span class="CSChatThai">{{$t('ChatSide.resend')}} </span>
            </v-tooltip>
            <v-tooltip top v-else-if="item.status=='no' && item.typeofmessage == 'contact'">
              <span style="text-align:right; margin-bottom: 0px; color: #616161; font-size:10px;margin-left: 10vw;float: right;" @click="resendContact(item)" slot="activator">
                <v-icon style="font-size:7px !important; cursor: pointer; ">autorenew</v-icon>
              </span>
              <span class="CSChatThai">{{$t('ChatSide.resend')}} </span>
            </v-tooltip>
          </v-flex>
        </div>
        <!-- ================================================ -->

        <div v-if="item.tokenuser !== token && tokenrooomSelect === item.tokenroom" class="chat friend">
          <v-flex xl1 lg1 md1 sm1 style="cursor: pointer; margin-top: 1vh;" v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task'">
            <v-avatar class="user-photo" @click="detailFriend(item.tokenuser)" v-if="(item.typeofmessage != 'albums_message' || item.image_add.length != 0)">
              <img v-if="item.path_pic" :src="item.path_pic" class="alligator-turtle">
              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
            </v-avatar>
          </v-flex>

          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
            <p class="boxother_unsend">
              {{$t('ChatSide.system.other.cancelMsg', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
            <p class="boxother_unsend" v-if="item.message == 'edit_name_albums'">
              {{$t('ChatSide.system.other.editNameAlbum', {name: item.nickname})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'create_albums'">
              {{$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'delete_albums'">
              {{$t('ChatSide.system.other.deleteAlbum', {name: item.nickname})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'delete_images_albums'">
              {{$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
            <p class="boxother_unsend" v-if="item.message == 'edit_task'">
              {{$t('ChatSide.system.other.editTask', {name: item.nickname})}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'create_project'">
              {{$t('ChatSide.system.other.createProject', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
            <p class="boxother_system">
              {{item.message}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
            <p class="boxother_system">
              <span>{{timeMoment(item.timestamp)}} น.</span>
              <br>
              <span v-if="item.message === 'active'">
                {{$t('ChatSide.system.other.joinGroup', {name: item.nickname})}}
              </span>
              <span v-else-if="item.message === 'kick'">
                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'invite'">
                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'leave'">
                 {{$t('ChatSide.system.other.leftGroup', {name: item.nickname})}}
              </span>
            </p>

          </v-flex>
          <v-flex xl8 lg8 md8 sm8 style="padding-right: 0px; margin-left: 1vw;" v-else>
            <!-- <v-tooltip right> -->
            <v-layout row wrap align-end justify-start>
              <div v-if="item.typeofmessage === 'message'" class="boxfriend" @contextmenu.prevent="RightClickDialog($event,['mention', 'announce'], item)">
              <p slot="activator" style="margin: 0 !important;" @click="handleClickTest" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')">
              </p>
              <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
              <link-prevue :url="x">
                <template slot-scope="props">
                  <!-- {{props}} -->
                  <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                    <v-flex xl9 lg9 md9 sm9 class="border_website">
                      <p class="title_website" >{{props.title}}</p>
                      <span class="description_website">{{props.description}}</span>
                    </v-flex>
                    <v-flex xl3 lg3 md3 sm3 class="centerimg_website">
                      <img class="img_website" :src="props.img"  v-if="props.img">
                    </v-flex>
                  </v-layout>
                </template>
                <template slot="loading">
                  <span></span>
                </template>
              </link-prevue>
            </div>
            </div>


              <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="boxfriend" @contextmenu.prevent="RightClickDialog($event,['mention'], item)">
                <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                  <v-flex xs1>
                    <v-avatar>
                      <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                      <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs11 style="padding-left: 40px;">
                    <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <span @click="handleClickTest" v-html="convertMention(item.source_message.message)"></span>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                        <span v-else>{{$t('ChatSide.sticker')}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span>{{$t('ChatSide.file')}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                        <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                      </v-flex>
                    </v-layout>
                    <v-layout column v-else-if="item.source_message.typeofmessage === 'video'">
                      <v-flex xs12>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <!-- <span>วิดีโอ</span> -->
                      </v-flex>
                      <v-flex xs12>
                        <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                          <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                        </video>
                        <div v-else style="height: 150px; width: 100%; justify-content: center; align-items: center;">
                          <vplayer
                            style="height: 150px !important;"
                            :playerOptions="{
                              type: 'application/x-mpegURL',
                              src: item.source_message.message,
                              preload: true,
                              autoplay: false,
                              isLoop: false,
                              playsinline: false,
                              poster: '',
                              controls: 'progress,current,durration,volume',
                              crossOrigin: false
                            }"
                            @onplay="play"
                          />
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                      <v-flex xs8>
                        <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                        <br>
                        <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                        <span v-else>{{item.source_message.message}}</span>
                      </v-flex>
                      <v-flex xs4>
                        <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-layout row wrap style="padding-bottom: 10px;color: #6f6f6f;" v-else>
                  <span>{{$t('ChatSide.noMsg')}}</span>
                </v-layout>
                <v-divider></v-divider>
                <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="display: none;">
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length != 0" style="width: 240px;" class="boxother_createablums" @click="detailAlbums(item.file_name)">
                <h3 class="mb-1" v-if="item.message !== 'addimage_albums'" style="color: #444444 !important;">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
                <h3 class="mb-1" v-else style="color: #444444 !important;">{{$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})}}</h3>
                <v-layout row wrap justify-center align-center>
                  <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
                </v-layout>
                <p class="mt-1 mb-0" style="color: #848484 !important;">{{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}</p>
                <v-divider></v-divider>
                <v-layout row wrap justify-center align-center class="mt-2">
                  <h4 v-if="item.albums_name != ''" style="color: #737373 !important;">{{item.albums_name}}</h4>
                  <h4 v-else style="color: #737373 !important;">{{dateMoment(item.create_date)}}</h4>
                  <v-spacer></v-spacer>
                  <v-icon style="font-size: 16px;color: #737373 !important;">fas fa-chevron-right</v-icon>
                </v-layout>
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'image'" style="width: 250px;" class="boxfriendfile" @contextmenu.prevent="RightClickDialog($event, ['albums','mention', 'sendmail'], item)">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card style="background: none; border-radius: 10px;display: flex; justify-content: center; cursor: pointer;" class="white--text">
                       <v-card-media class="white--text " height="200px" :src="item.message" @click="zoom(item)">
                      </v-card-media>
                    </v-card>
                  </v-flex>
                </v-layout>
              </p>

              <div slot="activator" v-else-if="item.typeofmessage == 'web'" class="boxfriendfile">
                <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'note'" style="width: 200px; cursor: pointer;" class="boxfriendfile" @click="detailNote(item.note_id)">
                <v-card style="background-color: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <p style="color: black;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                      <p v-if="item.message.length == 20"> ...</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions style="padding-left: 0px !important;">

                    <span style=" color: #737373 !important;"> {{$t('ChatSide.note')}} </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #737373 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

              <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="boxfriendfile" @click="open_detail_task(item.task_id, item.tokenroom)">
                <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 xl11>
                      <v-layout column wrap>
                        <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                        <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                  <v-layout column wrap align-start>
                    <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                    <div style="margin-bottom: 5px; text-align: left;">
                      <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="profile" :src="profile" class="alligator-turtle">
                          <span v-else style="color: white;">{{name[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{name}}</span>
                      </v-chip>
                      <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                          <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{assign.nickname}}</span>
                      </v-chip>
                      <v-chip label color="#dcd9d9" outline text-color="#3a506d">
                        {{item.task_info.state.name}}
                      </v-chip>
                    </div>
                  </v-layout>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #818181 !important;">
                      {{$t('ChatSide.Task.viewDetail')}}
                    </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

               <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="boxfriendfile" @click="open_detail_task(item.task_id, item.tokenroom)">
                <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                    </v-flex>
                    <v-flex xs11 sm11 md11 lg11 xl11>
                      <v-layout column wrap>
                        <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                        <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                  <v-layout column wrap align-start>
                    <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                    <div style="margin-bottom: 5px; text-align: left;">
                      <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="profile" :src="profile" class="alligator-turtle">
                          <span v-else style="color: white;">{{name[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{name}}</span>
                      </v-chip>
                      <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                        <v-avatar left color="#2662af" >
                          <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                          <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                        </v-avatar>
                        <span class="test-overflow-chip">{{assign.nickname}}</span>
                      </v-chip>
                    </div>
                  </v-layout>
                  <v-card-actions style="padding-left: 0px !important;">
                    <span style=" color: #818181 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>


              <div slot="activator" v-else-if="item.typeofmessage === 'sticker'" class="boxfriendsticker" @contextmenu.prevent="RightClickDialog($event, ['mention'], item)">
                <img :src="item.file_name" style="width: 150px;">
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" style="width: 300px;" class="boxfriendfile" @contextmenu.prevent="RightClickDialog($event, ['mention', 'sendmail'], item)">
                <v-card style="background-color: #4a4a4a; border-radius: 10px;padding: 10px;width: 100%;">
                  <v-card-media height="200px" style="border-radius: 10px;cursor: pointer; " v-if="extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media'" @click="zoomfile(item, true)">
                    <pdf :src="item.message" :page="1" ref="myPdfComponent" v-if="extension(item.file_name) === 'pdf'"></pdf>
                    <video controls style=" border-radius: 10px; height: 190px;" v-else-if="extension(item.file_name) === 'media'">
                      <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                    </video>
                  </v-card-media>
                  <v-card-media height="55px" style="width: 280px; border-radius: 10px;" v-else-if="extension(item.file_name) === 'audio'">
                    <audio controls style=" border-radius: 10px; width: 260px;display: flex;">
                      <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                    </audio>
                  </v-card-media>
                  <v-card-title primary-title style="padding-top: 10px;padding-left: 0px;padding-bottom: 10px; cursor: pointer;" v-if="extension(item.file_name) !== 'audio'">
                    <div style="text-align:left; word-break: break-all !important; font-size:14px;color: white;">({{item.file_name}})
                    </div>
                  </v-card-title>
                </v-card>
              </p>

              <p slot="activator" v-else-if="item.typeofmessage === 'file'" style="width: 300px;" class="boxfriendfile" @contextmenu.prevent="RightClickDialog($event, ['mention', 'sendmail'], item)">
                <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs4 sm4 md4 lg4 xl4>
                      <v-icon style="color: white; font-size: 70px !important; display: flex; justify-content: center;">{{extension(item.file_name)}}
                      </v-icon>
                    </v-flex>
                    <v-flex xs8 sm8 md8 lg8 xl8>
                      <v-card-title primary-title style="text-align: left;">
                        <div>
                          <div style="width: 160px; word-break: break-all !important;">{{item.file_name}}</div>
                        </div>
                      </v-card-title>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                      <v-btn slot="activator" flat icon color="white" @click="zoomfile(item, false)" style="margin-right: 10px;">
                        <v-icon>file_download</v-icon>
                      </v-btn>
                      <span>{{$t('AnswerQuestion.download')}}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <v-btn slot="activator" flat icon color="white" @click="sendimgonebox(item.tokenmessage)">
                        <v-icon>cloud_upload</v-icon>
                      </v-btn>
                      <span>{{$t('AnswerQuestion.sendOnebox')}}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-card>
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'video'" style="max-height: 250px; cursor: pointer;" class="boxfriendfile" @click="zoomfile(item, true)" @contextmenu.prevent="RightClickDialog($event, ['mention', 'sendmail'], item)">
                <video width="100%" height="250" slot="activator" v-if="extension(item.message) === 'media'" controls>
                  <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                </video>
                <vplayer
                  v-else
                  :playerOptions="{
                    type: 'application/x-mpegURL',
                    src: item.message,
                    preload: true,
                    autoplay: false,
                    isLoop: false,
                    playsinline: false,
                    poster: item.thumbnail,
                    controls: 'progress,current,durration,volume',
                    crossOrigin: false
                  }"
                  @onplay="play"
                />
              </div>

              <p slot="activator" v-else-if="item.typeofmessage === 'location'" style="max-width: 250px;min-width: 150px;  cursor: pointer;" class="boxfriendfile" @click="openlocation(item)" @contextmenu.prevent="RightClickDialog($event, ['mention'], item)">
                <v-card style="background-color: #efefef; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                  <v-layout style="text-align: left;">
                    <v-flex xs2 sm2 md2 lg2 xl2>
                      <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                    </v-flex>
                    <v-flex xs10 sm10 md10 lg10 xl10 style="color: black; padding-left: 10px;">
                      <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                      <span v-else> somewhere</span>
                    </v-flex>
                  </v-layout>
                </v-card>
              </p>

              <!-- get quickreply date friend-->
              <p slot="activator" v-else-if="item.typeofmessage === 'date'" class="boxfriend">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
              </p>
              <!-- get quickreply datetime friend-->
              <p slot="activator" v-else-if="item.typeofmessage === 'datetime'" class="boxfriend">
                <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
                <br>
                <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; เวลา {{item.message.split('T')[1]}} น.
              </p>

              <div slot="activator" v-else-if="item.typeofmessage === 'contact'" style="font-weight: 500; cursor: pointer; border-radius: 15px !important;" class="boxfriend" @click="detailFriend(item.message)">
                <v-avatar class="user-photo">
                  <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                  <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                  <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                  <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                </v-avatar>
                <p class="textchat" style="margin-right: 15px;">{{item.nickname_contact}}</p>
                <span style=" position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); right: 0;">
                  <v-icon>navigate_next </v-icon>
                </span>
              </div>

              <div slot="activator" v-else-if="item.typeofmessage === 'template'" class="boxfriendquestion scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden;display: -webkit-inline-box; background: none;">
                <div v-for="(info_ans, index) in item.info_ans">
                  <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;">
                    <v-img :src="info_ans.image" aspect-ratio="2.75" v-if="info_ans.image" style="height: 120px;"></v-img>

                    <v-card-title primary-title style="padding-top: 15px !important;">
                      <div style="width: 176px;">
                        <h3 class="mb-0" style="color: #2562ae;">{{info_ans.title}}</h3>
                        <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="margin-bottom: 0px !important;"></read-more>
                        <v-divider light v-if="!info_ans.image"></v-divider>
                        <div v-for="(choice, index) in info_ans.choice">
                          <v-btn v-if="choice.type=='file'" flat color="primary" style="text-transform: none; width: 100%;margin: 0; font-size: 13px;" @click="btn_answer_question(choice, item.tokenmessage)">
                            <v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp; <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                            <!-- {{choice.label}} -->
                          </v-btn>
                          <v-btn v-else flat color="primary" style="text-transform: none; width: 100%;margin: 0;font-size: 13px;" @click="btn_answer_question(choice, item.tokenmessage)">
                            <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                            <!-- {{choice.label}} -->
                          </v-btn>
                        </div>
                      </div>
                    </v-card-title>
                  </v-card>
                </div>
              </div>

               <div slot="activator"  v-else-if="item.typeofmessage === 'official_template'" class="boxfriendquestion" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
              <div>
                <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;background: #efefef !important;">
                  <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                  <v-img :src="item.element.image" v-if="item.element.image" style="height: 160px; cursor: pointer;" @click="btn_img_official_template(item.element.onclick_img, item.tokenuser)" contain></v-img>
                  <v-card-title primary-title style="padding-top: 15px !important;">
                    <div style="    width: 176px;">
                      <!-- {{choice.url}} -->
                      <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="color:#343433;"></read-more>
                      <v-divider light v-if="!item.element.image"></v-divider>
                      <div v-for="(choice, index) in item.element.choice">
                        <v-btn flat :style="checkbutton(choice.color,choice.background)" @click="btn_official_template(choice, item.tokenuser, item.tokenmessage)" :disabled="(choice.disable == '0')? false: true">
                          <!-- {{choice.url}} -->
                          {{choice.label}}
                        </v-btn>
                      </div>
                    </div>
                  </v-card-title>
                </v-card>
              </div>
            </div>



              <p slot="activator" v-else-if="item.typeofmessage === 'approve_message' && item.disable === 'false'" style="width: 200px; cursor: pointer;" class="boxfriendfile" @click="openapprove(item)">
                <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <h3 style="color: #2562ae !important;">{{item.info_ans[0].title}}</h3>
                      <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions>
                    <span style=" color: #2562ae !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                    <v-spacer></v-spacer>
                    <v-icon style=" color: #2562ae !important;   right: 0;position: absolute;">navigate_next </v-icon>
                  </v-card-actions>
                </v-card>
              </p>

              <p slot="activator" v-else-if="item.typeofmessage === 'approve_message'  && item.disable === 'true'" style="width: 200px;" class="boxfriendfile">
                <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                  <v-layout>
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                      <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions>
                    <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                  </v-card-actions>
                </v-card>
              </p>
              <div slot="activator" v-else-if="item.typeofmessage === 'call'" class="boxfriend" style="text-align: center;width: 100px;font-weight: 500 !important;">
                <v-icon style="font-size: 30px; color:#676767;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
                <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
                <br>
                <span v-if="item.message =='cancel' || item.message =='decline'">
                  {{checktypeCall(item.message)}}
                </span>
                <span v-else>{{secondsToHms(item.time_count)}}</span>
              </div>
              <!-- call agora -->
              <div slot="activator" v-else-if="item.typeofmessage === 'agora_call'" class="boxfriend" style="text-align: center;width: 100px;font-weight: 500 !important;">
                <v-icon style="font-size: 30px; color:#676767;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
                <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
                <br>
                <span v-if="item.message =='cancel'">
                  {{checktypeCall(item.message)}}
                </span>
                <span v-else>{{item.time}}</span>
              </div>


              <div slot="activator" v-else-if="item.typeofmessage === 'conference_msg'" class="boxfriend" style="text-align: center;font-weight: 500 !important;">
                <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#676767;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#676767;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                <br>
                <v-btn class="joinBtn" @click="joinCall_conference_msg(item.information)">{{$t('ChatSide.conference.joinCall')}} </v-btn>
              </div>

              <!-- type carousel image -->
              <div v-else-if="item.typeofmessage === 'carousel'" class="boxfriendcarousel scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden; display: -webkit-inline-box; background: none;">
                <div v-for="(info_carousel, index) in item.elements">
                  <v-card style="border-radius: 20px; width: 250px; margin-right: 10px;">
                    <v-img
                      @click="btn_answer_carousel(info_carousel)"
                      :src="info_carousel.image"
                      :aspect-ratio="16/9"
                      v-if="info_carousel.image"
                      style="height: 250px; cursor: pointer;"
                    >
                      <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 250px;">
                        <v-btn v-if="info_carousel.button" round color="#0000009c" dark>
                          <span class="text-transform">{{info_carousel.button}}</span>
                        </v-btn>
                      </v-layout>
                    </v-img>
                  </v-card>
                </div>
              </div>

              <p slot="activator" v-else class="boxfriend" style="color: #757575 !important;">
                {{$t('ChatSide.notSupportVersion')}}
              </p>
              <!-- <span>{{timeMoment(item.timestamp)}}</span> -->
              <span class="pl-2" style="font-size: 10px; color: #424242;">{{timeMoment(item.timestamp)}}</span>
            <!-- </v-tooltip> -->
            </v-layout>
          </v-flex>

          <v-flex xl1 lg1 md1 sm1>
          </v-flex>
          <v-flex xl2 lg2 md2 sm2>
          </v-flex>
        </div>
      </div>
      <!-- ------------------------------------------------------------- -->

      <div v-for="(item,i) in items" :key="item.id" v-if="ForwardState">
        <div v-if="i == 0">
     <!--           <div class="text-xs-center" @click="loadchathistory" v-if="statusload">
            <v-btn round outline color="primary" style="background: #ff000000 !important;text-transform: none;font-size: 13px !important;height: 25px !important;">
              <v-icon left style="font-size: 13px !important;" @click="loadchathistory">refresh</v-icon>
              {{$t('ChatSide.loadHistory')}}
            </v-btn>
          </div> -->

          <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect == item.tokenroom">
            <span>{{dateMoment(item.timestamp)}}</span>
          </div>
        </div>
        <div v-else-if="dateMoment(item.timestamp) !== dateMoment(items[i-1].timestamp)">
          <br>
          <v-flex xl12 md12 sm12 lg12>
            <div class="conversation-start" style="text-align:center;" v-if="tokenrooomSelect == item.tokenroom">
              <span>{{dateMoment(item.timestamp)}}</span>
            </div>
          </v-flex>
        </div>
        <p style="text-align:left; margin-left: calc(48px + 1vw); margin-bottom: 0px; color: #8e8e8e; font-size:10px;" class="text"
          v-if="item.tokenuser != token && tokenrooomSelect == item.tokenroom && i == 0 && item.typeofmessage != 'unsend_message' && item.typeofmessage != 'system' && item.typeofmessage != 'system_action' && item.typeofmessage !='system_action_albums' && item.typeofmessage !='system_action_task'">{{item.nickname}}</p>
        <p style="text-align:left; margin-left: calc(48px + 1vw); margin-bottom: 0px; color: #8e8e8e; font-size:10px;" class="text"
          v-else-if="item.typeofmessage != 'system_action_albums' && item.typeofmessage != 'system_action_task' && item.typeofmessage != 'system_action' && item.typeofmessage != 'system' && item.typeofmessage != 'unsend_message' && item.tokenuser != token && tokenrooomSelect == item.tokenroom && (dateMoment(item.timestamp) != dateMoment(items[i-1].timestamp) || items[i-1].tokenuser != item.tokenuser)">
          {{item.nickname}}</p>

        <!-- ================================================ -->

        <div v-if="item.tokenuser == token && tokenrooomSelect == item.tokenroom" class="chat self">
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
            <p class="boxself_unsend">
              {{$t('ChatSide.system.self.cancelMsg')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
              <p class="boxself_unsend" v-if="item.message == 'edit_name_albums'">
              {{$t('ChatSide.system.self.editNameAlbum')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'create_albums'">
              {{$t('ChatSide.system.self.createAlbum',{name: item.albums_name})}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'delete_albums'">
              {{$t('ChatSide.system.self.deleteAlbum')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'delete_images_albums'">
              {{$t('ChatSide.system.self.deleteImageAlbum')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
            <p class="boxself_unsend" v-if="item.message == 'edit_task'">
              {{$t('ChatSide.system.self.editTask')}}
            </p>
            <p class="boxself_unsend" v-else-if="item.message == 'create_project'">
              {{$t('ChatSide.system.self.createProject')}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
            <p class="boxself_unsend">
              {{item.message}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
            <p class="boxself_system">
              <span>{{timeMoment(item.timestamp)}} น.</span>
              <br>
              <span v-if="item.message === 'active'">
                {{$t('ChatSide.system.self.joinGroup')}}
              </span>
              <span v-else-if="item.message === 'kick'">
                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'invite'">
                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'leave'">
                 {{$t('ChatSide.system.self.leftGroup')}}
              </span>
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; " v-else>
            <!-- <v-tooltip left > -->
            <v-checkbox v-model="selectedForward" :value="item.tokenmessage" style="float: right;"
              v-if="(item.typeofmessage === 'message' || item.typeofmessage == 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status != 'no'"></v-checkbox>


            <div v-if="item.typeofmessage === 'message'" style="height: 100%;" class="boxself">
              <p slot="activator" style="margin: 0 !important;"  v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" >
              </p>
              <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
              <link-prevue :url="x">
                <template slot-scope="props">
                  <!-- {{props}} -->
                  <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                    <v-flex xl9 lg9 md9 sm9 class="border_website">
                      <p class="title_website" >{{props.title}}</p>
                      <span class="description_website">{{props.description}}</span>
                    </v-flex>
                    <v-flex xl3 lg3 md3 sm3 class="centerimg_website">
                      <img class="img_website" :src="props.img"  v-if="props.img">
                    </v-flex>
                  </v-layout>
                </template>
                <template slot="loading">
                  <span></span>
                </template>
              </link-prevue>
            </div>
            </div>

            <div v-else-if="item.typeofmessage === 'official_template'" class="boxselfquestion" style="overflow: hidden;display: -webkit-inline-box; background: none;">
              <div>
                <v-card style="border-radius: 10px; width: 200px; margin-right: 10px; background: #b4d1f5 !important;">
                  <h3 class="mb-0" style="color: #2562af; padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                  <v-img :src="item.element.image" v-if="item.element.image" style="height: 160px;" contain></v-img>
                  <v-card-title primary-title style="padding-top: 15px !important;">
                    <div style="width: 176px;">
                      <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="color:#343433;"></read-more>
                      <v-divider light v-if="!item.element.image"></v-divider>
                      <div v-for="(choice, index) in item.element.choice">
                        <v-btn flat disabled :style="checkbutton(choice.color,choice.background)">
                          {{choice.label}}
                        </v-btn>
                      </div>
                    </div>
                  </v-card-title>
                </v-card>
              </div>
            </div>


            <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="boxself" @contextmenu.prevent="RightClickDialog($event,['mention'], item)">
              <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                <v-flex xs1>
                  <v-avatar>
                    <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                    <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                  </v-avatar>
                </v-flex>
                <v-flex xs11 style="padding-left: 40px;">
                  <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                    <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                    <span>{{item.source_message.message}} ooooooooooooooooooooo</span>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span v-if="item.source_message.typeofmessage === 'image'">รูปภาพ</span>
                      <span v-else>{{$t('ChatSide.sticker')}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span>{{$t('ChatSide.file')}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                      <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout column v-else-if="item.source_message.typeofmessage === 'video'">
                    <v-flex xs12>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <!-- <span>วิดีโอ</span> -->
                    </v-flex>
                    <v-flex xs12>
                      <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                        <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                      </video>
                      <div v-else style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                        <vplayer
                          style="height: 150px !important;"
                          :playerOptions="{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }"
                          @onplay="play"
                        />
                      </div>

                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                      <span v-else>{{item.source_message.message}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-bottom: 10px;color: #6f6f6f;" v-else>
                <span>{{$t('ChatSide.noMsg')}}</span>
              </v-layout>
              <v-divider></v-divider>
              <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
            </p>

            <div  v-else-if="item.typeofmessage == 'albums_message' && item.image_add.length == 0" style="display: none;">
            </div>

            <div  v-else-if="item.typeofmessage == 'albums_message' && item.image_add.length != 0" style="width: 240px;" class="boxself_createablums">
              <h3 class="mb-1" v-if="item.message != 'addimage_albums'" style="color: #3a506d !important;">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
              <h3 class="mb-1" v-else style="color: #3a506d !important;">{{$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})}}</h3>
              <v-layout row wrap justify-center align-center>
                <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
              </v-layout>
              <p class="mt-1 mb-0" style="color: #3a506d91 !important;">{{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}</p>
              <v-divider style="border-color: #31394121 !important;"></v-divider>
              <v-layout row wrap justify-center align-center class="mt-2">
                <h4 v-if="item.albums_name != ''" style=" color: #4c6281 !important;">{{item.albums_name}}</h4>
                <h4 v-else style=" color: #4c6281 !important;">{{dateMoment(item.create_date)}}</h4>
                <v-spacer></v-spacer>
                <v-icon color="black" style="font-size: 16px;color: #4c6281 !important;">fas fa-chevron-right</v-icon>
              </v-layout>
            </div>


            <p v-else-if="item.typeofmessage === 'image'" style="width: 250px;" class="boxselffile">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card style="background: none; border-radius: 10px;display: flex; justify-content: center;" class="white--text">
                    <v-card-media class="white--text " height="200px" :src="item.message"></v-card-media>
                  </v-card>
                </v-flex>
              </v-layout>
            </p>

            <div v-else-if="item.typeofmessage === 'sticker'" class="boxselfsticker">
              <img :src="item.file_name" style="width: 150px;">
            </div>


            <div v-else-if="item.typeofmessage === 'web'" class="boxself">
              <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
            </div>

            <p v-else-if="item.typeofmessage === 'note'" style="width: 200px;" class="boxselffile">
              <v-card style="background: #b4d1f5 !important; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <p style="color: black;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p v-if="item.message.length == 20"> ...</p>
                  </v-flex>
                </v-layout>
                <v-divider light style="border-color: #31394121 !important;"></v-divider>
                <v-card-actions style="padding-left: 0px !important;">
                  <span style=" color: #4c6281 !important;"> {{$t('ChatSide.note')}} </span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #4c6281 !important;   right: 0;position: absolute;">navigate_next</v-icon>
                </v-card-actions>
              </v-card>
            </p>

            <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="boxselffile" @click="open_detail_task(item.task_id, item.tokenroom)">
              <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs11 sm11 md11 lg11 xl11>
                    <v-layout column wrap>
                      <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                      <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                <v-layout column wrap align-start>
                  <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                  <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                  <div style="margin-bottom: 5px; text-align: left;">
                    <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="profile" :src="profile" class="alligator-turtle">
                        <span v-else style="color: white;">{{name[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{name}}</span>
                    </v-chip>
                    <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                        <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{assign.nickname}}</span>
                    </v-chip>
                    <v-chip label color="#e6ecf3" outline text-color="#3a506d">
                      {{item.task_info.state.name}}
                    </v-chip>
                  </div>
                </v-layout>
                <v-card-actions style="padding-left: 0px !important;">
                  <span style=" color: #6981a1 !important;">
                    {{$t('ChatSide.Task.viewDetail')}}
                  </span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
              </v-card>
            </p>

             <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="boxselffile" @click="open_detail_task(item.task_id, item.tokenroom)">
              <v-card style="background: #b4d1f5;border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs11 sm11 md11 lg11 xl11>
                    <v-layout column wrap>
                      <h2 style="margin-right: 15px; color: #3a506d;">{{item.project_name}}</h2>
                      <h3 style="margin-right: 15px; color: #3a506db3;">{{item.task_info.title}}</h3>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                <v-layout column wrap align-start>
                  <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                  <p style=" color: #6981a1 !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                  <div style="margin-bottom: 5px; text-align: left;">
                    <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #cde1f9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="profile" :src="profile" class="alligator-turtle">
                        <span v-else style="color: white;">{{name[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{name}}</span>
                    </v-chip>
                    <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #cde1f9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                        <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{assign.nickname}}</span>
                    </v-chip>
                  </div>
                </v-layout>
                <v-card-actions style="padding-left: 0px !important;">
                  <span style=" color: #6981a1 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #6981a1 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
              </v-card>
            </p>

            <div v-else-if="item.typeofmessage === 'contact'" style="font-weight: 500; border-radius: 15px !important;" class="boxself">
              <v-avatar class="user-photo">
                <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
              </v-avatar>
              <p class="textchat" style="margin-right: 15px;">{{item.nickname_contact}}</p>
              <span style=" position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); right: 0;">
                <v-icon>navigate_next </v-icon>
              </span>
            </div>

            <p v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" style="width: 300px;" class="boxselffile">

              <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px;width: 100%;">
                <v-card-media height="200px" style="border-radius: 10px;" v-if="extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media'">
                  <pdf :src="item.message" :page="1" ref="myPdfComponent" v-if="extension(item.file_name) === 'pdf'"></pdf>
                  <video controls style=" border-radius: 10px; height: 190px;" v-else-if="extension(item.file_name) === 'media'">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                </v-card-media>
                <v-card-media height="55px" style="width: 280px; border-radius: 10px;" v-else-if="extension(item.file_name) === 'audio'">
                  <audio controls style=" border-radius: 10px; width: 260px;display: flex;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                </v-card-media>
                <v-card-title primary-title style="padding-top: 10px;padding-left: 0px;padding-bottom: 10px;" v-if="extension(item.file_name) !== 'audio'">
                  <div style="text-align:left; word-break: break-all !important; font-size:14px;color: white;">({{item.file_name}})
                  </div>
                </v-card-title>
              </v-card>
            </p>

            <p v-else-if="item.typeofmessage === 'file'" style="width: 300px;" class="boxselffile">
              <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout>
                  <v-flex xs4 sm4 md4 lg4 xl4>
                    <v-icon style="color: white; font-size: 70px !important; display: flex; justify-content: center;">{{extension(item.file_name)}}
                    </v-icon>
                  </v-flex>
                  <v-flex xs8 sm8 md8 lg8 xl8>
                    <v-card-title primary-title style="text-align: left;">
                      <div>
                        <div style="width: 160px; word-break: break-all !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat icon color="white" disabled style="margin-right: 10px;">
                    <v-icon>file_download</v-icon>
                  </v-btn>
                  <v-btn flat icon color="white" disabled>
                    <v-icon>cloud_upload</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </p>

            <div v-else-if="item.typeofmessage === 'video'" style="max-height: 250px;" class="boxselffile">
              <video width="100%" height="250" v-if="extension(item.message) === 'media'" controls>
                <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
              </video>
              <vplayer
                v-else
                :playerOptions="{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }"
                @onplay="play"
              />
            </div>

            <p v-else-if="item.typeofmessage === 'location'" style="max-width: 250px; min-width: 150px;" class="boxselffile">
              <v-card style="background: #b4d1f5 !important;border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs2 sm2 md2 lg2 xl2>
                    <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                  </v-flex>
                  <v-flex xs10 sm10 md10 lg10 xl10 style="color: black; padding-left: 10px;">
                    <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                    <span v-else> somewhere</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </p>

            <!-- get quickreply date-->
            <p v-else-if="item.typeofmessage === 'date'" class="boxself">
              <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
            </p>
            <!-- get quickreply datetime-->
            <p v-else-if="item.typeofmessage === 'datetime'" class="boxself">
              <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
              <br>
              <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; เวลา {{item.message.split('T')[1]}} น.
            </p>

            <div v-else-if="item.typeofmessage === 'call'" class="boxself" style="text-align: center;width: 100px;font-weight: 500 !important;">
              <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
              <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
              <br>
              <span v-if="item.message =='cancel' || item.message =='decline'">
                {{checktypeCall(item.message)}}
              </span>
              <span v-else>{{secondsToHms(item.time_count)}}</span>
            </div>

            <div v-else-if="item.typeofmessage === 'agora_call'" class="boxself" style="text-align: center;width: 100px;font-weight: 500 !important;">
              <v-icon style="font-size: 30px; color:#4065b4;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
              <v-icon style="font-size: 30px; color:#4065b4;" v-else>phone_in_talk</v-icon>
              <br>
              <span v-if="item.message =='cancel'">
                {{checktypeCall(item.message)}}
              </span>
              <span v-else>{{item.time}}</span>
            </div>

            <div v-else-if="item.typeofmessage === 'conference_msg'" class="boxself" style="text-align: center;font-weight: 500 !important;">
                <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#4065b4;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
                <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#4065b4;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
                <br>
                <v-btn class="joinBtn" disabled>{{$t('ChatSide.conference.joinCall')}} </v-btn>
                </div>


            <p v-else class="boxself" style="color: #6d6d6d !important;">
              {{$t('ChatSide.notSupportVersion')}}
            </p>
          </v-flex>
        </div>

        <div v-if="item.tokenuser !== token && tokenrooomSelect === item.tokenroom" class="chat friend">
          <!-- <v-container>
            <v-layout row wrap> -->
           <v-flex xl1 lg1 md1 sm1 style="cursor: pointer; margin-top: 1vh;" v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task'">

            <v-avatar class="user-photo"  v-if="(item.typeofmessage != 'albums_message' || item.image_add.length != 0)">
              <img v-if="item.path_pic" :src="item.path_pic" class="alligator-turtle">
              <img v-else-if="item.type === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
              <img v-else-if="item.type === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
              <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
            </v-avatar>
          </v-flex>

          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-if="item.typeofmessage === 'unsend_message'">
            <p class="boxother_unsend">
              {{$t('ChatSide.system.other.cancelMsg', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_albums'">
            <p class="boxother_unsend" v-if="item.message == 'edit_name_albums'">
              {{$t('ChatSide.system.other.editNameAlbum', {name: item.nickname})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'create_albums'">
              {{$t('ChatSide.system.other.createAlbum', {name: item.nickname, albums_name:item.albums_name})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'delete_albums'">
              {{$t('ChatSide.system.other.deleteAlbum', {name: item.nickname})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'delete_images_albums'">
              {{$t('ChatSide.system.other.deleteImageAlbum', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action_task'">
            <p class="boxother_unsend" v-if="item.message == 'edit_task'">
              {{$t('ChatSide.system.other.editTask', {name: item.nickname})}}
            </p>
            <p class="boxother_unsend" v-else-if="item.message == 'create_project'">
              {{$t('ChatSide.system.other.createProject', {name: item.nickname})}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system'">
            <p class="boxother_system">
              {{item.message}}
            </p>
          </v-flex>
          <v-flex xl12 lg12 md12 sm12 style="padding-right: 0px; margin-top: 2vh; margin-bottom: 0; justify-content: center; display: flex;" v-else-if="item.typeofmessage === 'system_action'">
            <p class="boxother_system">
              <span>{{timeMoment(item.timestamp)}} น.</span>
              <br>
              <span v-if="item.message === 'active'">
                {{$t('ChatSide.system.other.joinGroup', {name: item.nickname})}}
              </span>
              <span v-else-if="item.message === 'kick'">
                {{$t('ChatSide.system.default.kickMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'invite'">
                {{$t('ChatSide.system.default.inviteMemberGroup', {name_active: item.nickname, name_passive:item.file_name})}}
              </span>
              <span v-else-if="item.message === 'leave'">
               {{$t('ChatSide.system.other.leftGroup', {name: item.nickname})}}
              </span>
            </p>
          </v-flex>

          <v-flex xl8 lg8 md8 sm8 style="padding-right: 0px; padding-left: 1vw; " v-else>
            <div v-if="item.typeofmessage === 'message'" class="boxfriend">
              <p slot="activator" style="margin: 0 !important;"  v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')" >
              </p>
              <div v-for="x in convertURL(item.message)" v-if="convertURL(item.message)">
              <link-prevue :url="x">
                <template slot-scope="props">
                  <!-- {{props}} -->
                  <v-layout row wrap style="margin-top: 10px;" @click="clicklink_website(props.url)">
                    <v-flex xl9 lg9 md9 sm9 class="border_website">
                      <p class="title_website" >{{props.title}}</p>
                      <span class="description_website">{{props.description}}</span>
                    </v-flex>
                    <v-flex xl3 lg3 md3 sm3 class="centerimg_website">
                      <img class="img_website" :src="props.img"  v-if="props.img">
                    </v-flex>
                  </v-layout>
                </template>
                <template slot="loading">
                  <span></span>
                </template>
              </link-prevue>
            </div>
            </div>



            <p slot="activator" v-else-if="item.typeofmessage === 'mention_message'" class="boxfriend" @contextmenu.prevent="RightClickDialog($event,['mention'], item)">
              <v-layout row wrap style="padding-bottom: 10px;" v-if="item.source_message.typeofmessage !== 'unsend_message'">
                <v-flex xs1>
                  <v-avatar>
                    <img :src="item.source_message.owner_source_message.path_pic" v-if="item.source_message.owner_source_message.path_pic" class="alligator-turtle" style="width: 40px; height: 40px;">
                    <img src="/static/img/default_profile/man-white.png" class="alligator-turtle" v-else style="width: 40px; height: 40px;">
                  </v-avatar>
                </v-flex>
                <v-flex xs11 style="padding-left: 40px;">
                  <v-layout column v-if="item.source_message.typeofmessage === 'mention_message' || item.source_message.typeofmessage === 'message'">
                    <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                    <span>{{item.source_message.message}}</span>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'image' || item.source_message.typeofmessage === 'sticker'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span v-if="item.source_message.typeofmessage === 'image'">{{$t('ChatSide.image')}}</span>
                      <span v-else>{{$t('ChatSide.sticker')}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <img :src="item.source_message.message" style="width: 40px; height: 40px; border-radius: 10px; float: right;">
                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'file'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span>{{$t('ChatSide.file')}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon v-if="extension(item.source_message.message) === 'pdf'" style="color: black; width: 40px; height: 40px; float: right;">fas fa-file-pdf</v-icon>
                      <v-icon v-else style="color: black; width: 40px; height: 40px; float: right;">{{extension(item.source_message.message)}}</v-icon>
                    </v-flex>
                  </v-layout>
                  <v-layout column v-else-if="item.source_message.typeofmessage === 'video'">
                    <v-flex xs12>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <!-- <span>วิดีโอ</span> -->
                    </v-flex>
                    <v-flex xs12>
                      <video v-if="extension(item.source_message.message) === 'media'" width="150" height="150" controls style="justify-content: center; align-items: center;">
                        <source :src="item.source_message.message" :type="'video/' + item.source_message.message.split('.')[item.source_message.message.split('.').length - 1]">
                      </video>
                      <div v-else style="width: 100%; height: 150px; justify-content: center; align-items: center;">
                        <vplayer
                          style="height: 150px !important;"
                          :playerOptions="{
                            type: 'application/x-mpegURL',
                            src: item.source_message.message,
                            preload: true,
                            autoplay: false,
                            isLoop: false,
                            playsinline: false,
                            poster: '',
                            controls: 'progress,current,durration,volume',
                            crossOrigin: false
                          }"
                          @onplay="play"
                        />
                      </div>

                    </v-flex>
                  </v-layout>
                  <v-layout row v-else-if="item.source_message.typeofmessage === 'location'">
                    <v-flex xs8>
                      <span style="font-weight: 500;">{{item.source_message.owner_source_message.nickname}}</span>
                      <br>
                      <span v-if="item.source_message.address !== ''">{{item.source_message.address}}</span>
                      <span v-else>{{item.source_message.message}}</span>
                    </v-flex>
                    <v-flex xs4>
                      <v-icon style="color: black; width: 40px; height: 40px; float: right;">fas fa-map-marker-alt</v-icon>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="padding-bottom: 10px;color: #6f6f6f;" v-else>
                <span>{{$t('ChatSide.noMsg')}}</span>
              </v-layout>
              <v-divider></v-divider>
              <span style="font-weight: 500;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
            </p>

            <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length === 0" style="display: none;">
            </div>

            <div v-else-if="item.typeofmessage === 'albums_message' && item.image_add.length !== 0" style="width: 240px;" class="boxother_createablums">
              <h3 class="mb-1" v-if="item.message !== 'addimage_albums'" style="color: #444444 !important;">{{$t('ChatSide.Album.createAlbumHeader')}}</h3>
              <h3 class="mb-1" v-else style="color: #444444 !important;">
              {{$t('ChatSide.Album.insertImageAlbum', {name: item.albums_name})}}
            </h3>
              <v-layout row wrap justify-center align-center>
                <img :src="item.image_add[0].link" height="150px" width="130px" style="border-radius: 10px;" v-if="item.image_add.length!=0">
              </v-layout>
              <p class="mt-1 mb-0" style="color: #848484 !important;">{{$t('ChatSide.Album.numberImage', {count: item.image_add.length})}}</p>
              <v-divider></v-divider>
              <v-layout row wrap justify-center align-center class="mt-2">
                <h4 v-if="item.albums_name != ''" style="color: #737373 !important;">{{item.albums_name}}</h4>
                <h4 v-else style="color: #737373 !important;">{{dateMoment(item.create_date)}}</h4>
                <v-spacer></v-spacer>
                <v-icon style="font-size: 16px;color: #737373 !important;">fas fa-chevron-right</v-icon>
              </v-layout>
            </div>

            <p v-else-if="item.typeofmessage === 'image'" style="width: 250px;" class="boxfriendfile">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card style="background: none; border-radius: 10px;display: flex; justify-content: center;" class="white--text">
                    <v-card-media class="white--text " height="200px" :src="item.message"></v-card-media>
                  </v-card>
                </v-flex>
              </v-layout>
            </p>

            <div v-else-if="item.typeofmessage == 'web'" class="boxfriendfile">
              <iframe width="300" height="400" style="visibility:visible;" frameborder='0' :src="item.message"></iframe>
            </div>

            <p v-else-if="item.typeofmessage === 'note'" style="width: 200px;" class="boxfriendfile">
              <v-card style="background-color: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <p style="color: black;" v-html="convert(item.message).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                    <p v-if="item.message.length == 20"> ...</p>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions style="padding-left: 0px !important;">

                  <span style=" color: #5a616b !important;"> {{$t('ChatSide.note')}} </span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #5a616b !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
              </v-card>
            </p>

            <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'create_task'" style="width: 200px;cursor: pointer;" class="boxfriendfile" @click="open_detail_task(item.task_id, item.tokenroom)">
              <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs11 sm11 md11 lg11 xl11>
                    <v-layout column wrap>
                      <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                      <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                <v-layout column wrap align-start>
                  <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                  <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                  <div style="margin-bottom: 5px; text-align: left;">
                    <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="profile" :src="profile" class="alligator-turtle">
                        <span v-else style="color: white;">{{name[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{name}}</span>
                    </v-chip>
                    <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                        <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{assign.nickname}}</span>
                    </v-chip>
                    <v-chip label color="#dcd9d9" outline text-color="#3a506d">
                      {{item.task_info.state.name}}
                    </v-chip>
                  </div>
                </v-layout>
                <v-card-actions style="padding-left: 0px !important;">
                  <span style=" color: #818181 !important;">
                    {{$t('ChatSide.Task.viewDetail')}}
                  </span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
              </v-card>
            </p>

             <p slot="activator" v-else-if="item.typeofmessage === 'task_message' && item.message === 'assign_task'" style="width: 200px;cursor: pointer;" class="boxfriendfile" @click="open_detail_task(item.task_id, item.tokenroom)">
              <v-card style="background: #efefef; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs1 sm1 md1 xl1 lg1 v-if="item.task_info.priority == '1'" style="background-color: rgb(179, 73, 61); border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '2'" style="background-color: #fcbe54; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs1 sm1 md1 xl1 lg1 v-else-if="item.task_info.priority == '3'" style="background-color:  #a0a1a3; border-radius: 10px; height: 50px; margin-right: 10px;">
                  </v-flex>
                  <v-flex xs11 sm11 md11 lg11 xl11>
                    <v-layout column wrap>
                      <h2 style="margin-right: 15px; color: #444444;">{{item.project_name}}</h2>
                      <h3 style="margin-right: 15px; color: #444444c2;">{{item.task_info.title}}</h3>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-2" light style="border-color: #31394121 !important;"></v-divider>
                <v-layout column wrap align-start>
                  <p class="text-task-detail" v-html="convert(item.task_info.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                  <p style=" color: #7c7c7c !important; margin-bottom: 0;" v-if="item.task_info.assign"> {{$t('ChatSide.Task.assign')}}:</p>
                  <div style="margin-bottom: 5px; text-align: left;">
                    <v-chip pill v-if="checkuserinassign(item.task_info.assign)" style="background: #dcd9d9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="profile" :src="profile" class="alligator-turtle">
                        <span v-else style="color: white;">{{name[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{name}}</span>
                    </v-chip>
                    <v-chip pill v-for="assign in item.task_info.assign" v-if="assign.tokenuser != token" style="background: #dcd9d9 !important;">
                      <v-avatar left color="#2662af" >
                        <img v-if="assign.path_pic" :src="assign.path_pic" class="alligator-turtle">
                        <span v-else style="color: white;">{{assign.nickname[0]}}</span>
                      </v-avatar>
                      <span class="test-overflow-chip">{{assign.nickname}}</span>
                    </v-chip>
                  </div>
                </v-layout>
                <v-card-actions style="padding-left: 0px !important;">
                  <span style=" color: #818181 !important; ">{{$t('ChatSide.Task.editAssign')}}</span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #818181 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
              </v-card>
            </p>



            <div v-else-if="item.typeofmessage === 'sticker'" class="boxfriendsticker">
              <img :src="item.file_name" style="width: 150px;">
            </div>

            <p v-else-if="item.typeofmessage === 'file' && (extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media' || extension(item.file_name) === 'audio')" style="width: 300px;" class="boxfriendfile">
              <v-card style="background-color: #4a4a4a; border-radius: 10px;padding: 10px;width: 100%;">
                <v-card-media height="200px" style="border-radius: 10px;" v-if="extension(item.file_name) === 'pdf' || extension(item.file_name) === 'media'">

                  <pdf :src="item.message" :page="1" ref="myPdfComponent" v-if="extension(item.file_name) === 'pdf'"></pdf>
                  <video controls style=" border-radius: 10px; height: 190px;" v-else-if="extension(item.file_name) === 'media'">
                    <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </video>
                </v-card-media>
                <v-card-media height="55px" style="width: 280px; border-radius: 10px;" v-else-if="extension(item.file_name) === 'audio'">
                  <audio controls style=" border-radius: 10px; width: 260px;display: flex;">
                    <source :src="item.message" :type="'audio/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
                  </audio>
                </v-card-media>
                <v-card-title primary-title style="padding-top: 10px;padding-left: 0px;padding-bottom: 10px;" v-if="extension(item.file_name) !== 'audio'">
                  <div style="text-align:left; word-break: break-all !important; font-size:14px;color: white;">({{item.file_name}})
                  </div>
                </v-card-title>
              </v-card>
            </p>

            <p v-else-if="item.typeofmessage === 'file'" style="width: 300px;" class="boxfriendfile">
              <v-card style="background-color: #404d63; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout>
                  <v-flex xs4 sm4 md4 lg4 xl4>
                    <v-icon style="color: white; font-size: 70px !important; display: flex; justify-content: center;">{{extension(item.file_name)}}
                    </v-icon>
                  </v-flex>
                  <v-flex xs8 sm8 md8 lg8 xl8>
                    <v-card-title primary-title style="text-align: left;">
                      <div>
                        <div style="width: 160px; word-break: break-all !important;">{{item.file_name}}</div>
                      </div>
                    </v-card-title>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn flat icon color="white" disabled style="margin-right: 10px;">
                    <v-icon>file_download</v-icon>
                  </v-btn>
                  <v-btn flat icon color="white" disabled>
                    <v-icon>cloud_upload</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </p>

            <div v-else-if="item.typeofmessage === 'video'" style="max-height: 250px;" class="boxfriendfile">
              <video width="100%" height="250" v-if="extension(item.typeofmessage) === 'media'" controls>
                <source :src="item.message" :type="'video/' + item.file_name.split('.')[item.file_name.split('.').length - 1]">
              </video>
              <vplayer
                v-else
                :playerOptions="{
                  type: 'application/x-mpegURL',
                  src: item.message,
                  preload: true,
                  autoplay: false,
                  isLoop: false,
                  playsinline: false,
                  poster: item.thumbnail,
                  controls: 'progress,current,durration,volume',
                  crossOrigin: false
                }"
                @onplay="play"
              />
            </div>

            <p v-else-if="item.typeofmessage === 'location'" style="max-width: 250px; min-width: 150px;" class="boxfriendfile">
              <v-card style="background-color: #efefef; border-radius: 20px; padding: 10px; padding-bottom: 10px; width: 100%;" class="white--text">
                <v-layout style="text-align: left;">
                  <v-flex xs2 sm2 md2 lg2 xl2>
                    <v-icon style="position: absolute; top: 50%; transform: translateY(-50%);">place</v-icon>
                  </v-flex>
                  <v-flex xs10 sm10 md10 lg10 xl10 style="color: black; padding-left: 10px;">
                    <span v-if="item.file_name != ''"> {{item.file_name}}</span>
                    <span v-else> somewhere</span>
                  </v-flex>
                </v-layout>
              </v-card>
            </p>

            <!-- get quickreply date friend-->
            <p v-else-if="item.typeofmessage === 'date'" class="boxfriend">
              <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
            </p>
            <!-- get quickreply datetime friend-->
            <p v-else-if="item.typeofmessage === 'datetime'" class="boxfriend">
              <v-icon style="font-size: 18px; color:#4065b4;"> far fa-calendar-alt</v-icon> &nbsp; {{momentday(item.message)}}
              <br>
              <v-icon style="font-size: 16px;"> far fa-clock</v-icon> &nbsp; เวลา {{item.message.split('T')[1]}} น.
            </p>

            <div v-else-if="item.typeofmessage === 'contact'" style="font-weight: 500; border-radius: 15px !important;" class="boxfriend">
              <v-avatar class="user-photo">
                <img v-if="item.pic_contact" :src="item.pic_contact" class="alligator-turtle">
                <img v-else-if="item.type_contact === 'business'" src='/static/img/default_profile/business-white.png' class="alligator-turtle">
                <img v-else-if="item.type_contact === 'bot'" src='/static/img/default_profile/bot-white.png' class="alligator-turtle">
                <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
              </v-avatar>
              <p class="textchat" style="margin-right: 15px;">{{item.nickname_contact}}</p>
              <span style=" position: absolute; top: 50%; -ms-transform: translateY(-50%); transform: translateY(-50%); right: 0;">
                <v-icon>navigate_next </v-icon>
              </span>
            </div>


            <div v-else-if="item.typeofmessage === 'template'" class="boxfriendquestion scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden;display: -webkit-inline-box; background: none;">
              <div v-for="(info_ans, index) in item.info_ans">
                <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;">
                  <v-img :src="info_ans.image" aspect-ratio="2.75" v-if="info_ans.image" style="height: 120px;"></v-img>

                  <v-card-title primary-title style="padding-top: 15px !important;">
                    <div style="    width: 176px;">
                      <h2 class="mb-0" style="color: #61666d;">{{info_ans.title}}</h2>
                      <!-- <p style="font-size: 12px;color: #464c53;">{{info_ans.detail}}</p> -->
                      <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(info_ans.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100"></read-more>
                      <!-- // <br  v-if="!info_ans.image"> -->
                      <v-divider light v-if="!info_ans.image"></v-divider>
                      <div v-for="(choice, index) in info_ans.choice">
                        <v-btn v-if="choice.type=='file'" flat disabled style="text-transform: none;width: 100%;margin: 0; font-size: 13px;">
                          <v-icon style="font-size: 12px;">fas fa-download</v-icon> &nbsp;&nbsp; <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                          <!-- {{choice.label}} -->
                        </v-btn>
                        <v-btn v-else flat disabled style="text-transform: none; width: 100%;margin: 0;font-size: 13px;">
                          <!-- {{choice.label}} -->
                          <p class="mb-0" v-html="convert(choice.label).replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                        </v-btn>
                      </div>
                    </div>
                  </v-card-title>
                </v-card>
              </div>
            </div>

            <div  v-else-if="item.typeofmessage === 'official_template'" class="boxfriendquestion" style="overflow: hidden;display: -webkit-inline-box; background: none; ">
              <div>
                <v-card style="border-radius: 10px; width: 200px;margin-right: 10px;background: #efefef !important;">
                  <h3 class="mb-0" style="color: #2562af;padding-left: 12px;padding-top: 10px;padding-bottom: 10px;">{{item.element.title}}</h3>

                  <v-img :src="item.element.image" v-if="item.element.image" style="height: 160px;" contain></v-img>
                  <v-card-title primary-title style="padding-top: 15px !important;">
                    <div style="    width: 176px;">
                      <read-more class="mb-0" :more-str="$t('ChatSide.Read.readmore')" :text="convert(item.element.detail).replace(/(?:\r\n|\r|\n)/g, '<br>')" link="#" :less-str="$t('ChatSide.Read.readless')" :max-chars="100" style="color:#343433;"></read-more>
                      <v-divider light v-if="!item.element.image"></v-divider>
                      <div v-for="(choice, index) in item.element.choice">
                        <v-btn flat disabled style="text-transform: none; width: 100%;margin: 0;font-size: 13px; border-radius: 20px;">
                          {{choice.label}}
                        </v-btn>
                      </div>
                    </div>
                  </v-card-title>
                </v-card>
              </div>
            </div>


            <p v-else-if="item.typeofmessage === 'approve_message'" style="width: 200px;" class="boxfriendfile">
              <v-card style="background-color: white; border-radius: 10px;padding: 10px; padding-bottom: 0px;width: 100%;" class="white--text">
                <v-layout>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <h3 style="color: #757575 !important;">{{item.info_ans[0].title}}</h3>
                    <p style="color: #9d9d9d !important;">{{item.info_ans[0].short_detail}}</p>
                  </v-flex>
                </v-layout>
                <v-divider light></v-divider>
                <v-card-actions v-if="item.disable === 'false'">
                  <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.viewDetail')}} </span>
                  <v-spacer></v-spacer>
                  <v-icon style=" color: #757575 !important;   right: 0;position: absolute;">navigate_next </v-icon>
                </v-card-actions>
                <v-card-actions v-else>
                  <span style=" color: #757575 !important;"> {{$t('ChatSide.approve_message.receiveAns')}} </span>
                </v-card-actions>
              </v-card>
            </p>

            <div v-else-if="item.typeofmessage === 'call'" class="boxfriend" style="text-align: center;width: 100px;font-weight: 500 !important;">
              <v-icon style="font-size: 30px; color:#676767;" v-if="item.message =='cancel' || item.message =='decline'">phone</v-icon>
              <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
              <br>
              <span v-if="item.message =='cancel' || item.message =='decline'">
                {{checktypeCall(item.message)}}
              </span>
              <span v-else>{{secondsToHms(item.time_count)}}</span>
            </div>
            <!-- call agora -->
            <div v-else-if="item.typeofmessage === 'agora_call'" class="boxfriend" style="text-align: center;width: 100px;font-weight: 500 !important;">
              <v-icon style="font-size: 30px; color:#676767;" v-if="item.message =='cancel' || item.message =='end'">phone</v-icon>
              <v-icon style="font-size: 30px; color:#676767;" v-else>phone_in_talk</v-icon>
              <br>
              <span v-if="item.message =='cancel'">
                {{checktypeCall(item.message)}}
              </span>
              <span v-else>{{item.time}}</span>
            </div>

            <div v-else-if="item.typeofmessage === 'conference_msg'" class="boxfriend" style="text-align: center;font-weight: 500 !important;">
              <span v-if="item.information.option == 'voice'"><v-icon style="font-size: 30px; color:#676767;" >phone_in_talk</v-icon> <br>{{$t('ChatSide.conference.startCall')}}</span>
              <span v-else-if="item.information.option == 'video'"><v-icon style="font-size: 30px; color:#676767;" >videocam</v-icon> <br>{{$t('ChatSide.conference.startVideo')}}</span>
              <br>
              <v-btn class="joinBtn" disabled>{{$t('ChatSide.conference.joinCall')}}</v-btn>
            </div>

            <!-- type carousel image -->
            <div v-else-if="item.typeofmessage === 'carousel'" class="boxfriendcarousel scrolling-wrapper-template" style="overflow-x: scroll;overflow-y: hidden; display: -webkit-inline-box; background: none;">
              <div v-for="(info_carousel, index) in item.elements">
                <v-card style="border-radius: 20px; width: 250px;margin-right: 10px;">
                  <v-img :src="info_carousel.image" aspect-ratio="2.75" v-if="info_carousel.image" style="height: 250px;">
                    <v-layout v-if="info_carousel.type !== 'image'" row wrap align-end justify-center style="height: 250px;">
                      <v-btn v-if="info_carousel.button" round color="#0000009c" dark disabled>
                        <span class="text-transform">{{info_carousel.button}}</span>
                      </v-btn>
                    </v-layout>
                  </v-img>
                </v-card>
              </div>
            </div>

            <p v-else class="boxfriend" style="color: #757575 !important;">
              {{$t('ChatSide.notSupportVersion')}}
            </p>
          </v-flex>

          <v-flex xl3 lg3 md3 sm3 v-if="item.typeofmessage !== 'unsend_message' && item.typeofmessage !== 'system' && item.typeofmessage !== 'system_action' && item.typeofmessage !== 'system_action_albums' && item.typeofmessage !== 'system_action_task'">
            <v-checkbox v-model="selectedForward" :value="item.tokenmessage" style="float: right;"
              v-if="(item.typeofmessage === 'message' || item.typeofmessage === 'image' || item.typeofmessage === 'file' || item.typeofmessage === 'video' || item.typeofmessage === 'location') && item.status!='no'"></v-checkbox>
            <v-checkbox disabled style="float: right;" v-else></v-checkbox>
          </v-flex>
        </div>
      </div>

      <!-- ------------------------------------------------ -->

      <!-- quick reply -->
      <v-date-picker v-model="dateselect" v-if="datepicker" :max="maxdate" :min="mindate" :landscape="true">
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="datepicker = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="senddate()">OK</v-btn>
      </v-date-picker>

      <v-time-picker v-model="timeselect" v-if="timepicker" :max="maxtime" :min="mintime" format="24hr" :landscape="true">
        <v-spacer></v-spacer>
        <v-btn flat color="primary" @click="timepicker = false">Cancel</v-btn>
        <v-btn flat color="primary" @click="sendtime()">OK</v-btn>
      </v-time-picker>

   <!--    <div class="scrolling-wrapper" v-if="ForwardState === false">
        <a v-for="(item,index) in Quickreply.quick_reply" style="">
          <v-btn v-if="item.type == 'text'" round small class="quick_reply" @click="ans_quickreply(item, 'text')">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-if="item.type == 'ocr'" round small class="quick_reply" @click="ocropen(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-if="item.type == 'file'" round small class="quick_reply" @click="selectfile_quickreply(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-if="item.type == 'image'" round small class="quick_reply" @click="selectfile_quickreply(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_reply" @click="setpicker(item)">
            <v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp;<span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>
          <v-btn v-else-if="item.type == 'link'" round small class="quick_reply" @click="openlink(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'webview'" round small class="quick_reply" @click="openwebview(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'link_market'" round small class="quick_reply" @click="openlink_market(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
        </a>
      </div> -->
    <!--   <div class="scrolling-wrapper" v-if="ForwardState === true">
        <a v-for="(item,index) in Quickreply.quick_reply" style="">
          <v-btn v-if="item.type == 'text'" round small class="quick_replydis" disabled><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_replydis" disabled>
            <v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp;<span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>
          <v-btn v-else-if="item.type == 'link'" round small class="quick_replydis" disabled><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'webview'" round small class="quick_replydis" disabled><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'link_market'" round small class="quick_replydis" disabled><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
        </a>
      </div> -->
    </div>






<!-- {{Quickreply}} -->
    <v-flex lg12 md12 sm12 xl12 style="margin: 0;" v-if="ForwardState === false &&Quickreply" >
      <div class="chat-messages clearfix scrolling-wrapper" :style="quickreplyStyle + 'background: none !important;margin-left: 20px;overflow-y: hidden;display: flex;height: 50px; width: 45% !important;overflow-x:scroll !important;'" >
        <a v-for="(item,index) in Quickreply.quick_reply" style="">
          <v-btn v-if="item.type == 'text'" round small class="quick_reply" @click="ans_quickreply(item, 'text')">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'ocr'" round small class="quick_reply" @click="ocropen(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'file'" round small class="quick_reply" @click="selectfile_quickreply(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'image'" round small class="quick_reply" @click="selectfile_quickreply(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'location'" round small class="quick_reply" @click="sendlocation_quickreply(item)">
            <span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>

          <v-btn v-else-if="item.type == 'datepicker' || item.type == 'datetimepicker'" round small class="quick_reply" @click="setpicker(item)">
            <v-icon style="font-size: 12px;">fas fa-calendar-alt</v-icon> &nbsp;&nbsp;<span class="text-overflow-quickreply">{{item.label}}</span>
          </v-btn>
          <v-btn v-else-if="item.type == 'link'" round small class="quick_reply" @click="openlink(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'webview'" round small class="quick_reply" @click="openwebview(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'link_market'" round small class="quick_reply" @click="openlink_market(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
          <v-btn v-else-if="item.type == 'ekyc'" round small class="quick_reply" @click="ans_ekyc(item)"><span class="text-overflow-quickreply">{{item.label}}</span></v-btn>
        </a>
      </div>
    </v-flex>




    <v-flex lg12 md12 sm12 xl12 style="margin: 0;" v-if="ForwardState">
      <div class="chat-messages clearfix" style="width: 100%">
        <p style="color: white;">{{$t('ChatSide.numberMsgSent')}} ({{selectedForward.length}})</p>
        <v-btn @click="dialogForward = true;" style="text-transform: none;" :disabled="(selectedForward.length==0)">{{$t('AnswerQuestion.forward')}}</v-btn>
        <v-btn @click="dialogForward = false; ForwardState = false; selectedForward = []" style="text-transform: none;">
          {{$t('AnswerQuestion.cancel')}}
        </v-btn>
      </div>
    </v-flex>

    <!-- rich menu -->
    <v-flex lg12 md12 sm12 xl12 style="margin: 0;" v-if="RichmenuState">
      <div class="chat-messages-richmenu clearfix" v-if="!sheetrichmenu">
        <v-layout row wrap align-center justify-center style="height: 100%;">
          <v-flex xs1 md1 sm1 xl1 lg1 style="border-right-style: solid; border-right-color: white; border-right-width: thin;">
            <v-layout row wrap justify-center align-center>
              <v-btn @click="RichmenuState = false; sheetrichmenu = false" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
                <v-icon style="color: white; font-size: 18px !important;">fas fa-keyboard</v-icon>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs11 md11 sm11 xl11 lg11 class="pl-2 pr-2">
            <v-layout row wrap justify-center align-center>
              <v-btn block flat color="white" style="text-transform: none;" @click="sheetrichmenu = true">{{richmenu_label}}</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <!-- rich menu 2 row -->
        <div class="chat-messages-richmenu-sheet clearfix" v-if="type_richmenu <= 7">
          <v-layout row wrap align-start justify-center style="height: 89%; width: 375px; margin: auto;">
            <v-flex xs12 md12 sm12 lg12 xl12 style="height: 100%;">
              <Richmenudialog :type_richmenu="type_richmenu" :inforrichmenu="inforrichmenu" :Richmenudialog="Richmenudialog" @emitrichmenu="emitrichmenu"></Richmenudialog>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-end justify-center style="bottom: 0; position: fixed; width: 50%; padding-right: 10px;">
            <v-flex xs1 md1 sm1 xl1 lg1 style="border-right-style: solid; border-right-color: white; border-right-width: thin; margin-bottom: 7px;">
              <v-layout row wrap justify-center align-center>
                <v-btn @click="RichmenuState = false; sheetrichmenu = false" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
                  <v-icon style="color: white; font-size: 18px !important;">fas fa-keyboard</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs11 md11 sm11 xl11 lg11 class="pl-2 pr-2">
              <v-layout column wrap justify-center align-center>
                <v-btn block flat color="white" style="text-transform: none;" @click="sheetrichmenu = false">
                  <v-layout column wrap justify-center align-center>
                    <v-icon style="color: white; font-size: 18px !important;">fas fa-sort-down</v-icon>
                    <span>{{richmenu_label}}</span>
                  </v-layout>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <!-- rich menu 1 row -->
        <div class="chat-messages-richmenu-sheet-row clearfix" v-else>
          <v-layout row wrap align-start justify-center style="width: 375px; margin: auto;">
            <v-flex xs12 md12 sm12 lg12 xl12 style="height: 100%;">
              <Richmenudialog :type_richmenu="type_richmenu" :inforrichmenu="inforrichmenu" :Richmenudialog="Richmenudialog" @emitrichmenu="emitrichmenu"></Richmenudialog>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-end justify-center>
            <v-flex xs1 md1 sm1 xl1 lg1 style="border-right-style: solid; border-right-color: white; border-right-width: thin; margin-bottom: 7px;">
              <v-layout row wrap justify-center align-center>
                <v-btn @click="RichmenuState = false; sheetrichmenu = false" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
                  <v-icon style="color: white; font-size: 18px !important;">fas fa-keyboard</v-icon>
                </v-btn>
              </v-layout>
            </v-flex>
            <v-flex xs11 md11 sm11 xl11 lg11 class="pl-2 pr-2">
              <v-layout column wrap justify-center align-center>
                <v-btn block flat color="white" style="text-transform: none;" @click="sheetrichmenu = false">
                  <v-layout column wrap justify-center align-center>
                    <v-icon style="color: white; font-size: 18px !important;">fas fa-sort-down</v-icon>
                    <span>{{richmenu_label}}</span>
                  </v-layout>
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </v-flex>

    <v-flex lg12 md12 sm12 xl12 style="margin: 0;" v-else-if="!ForwardState">
      <div class="listfile" v-if="files.length > 0">
        <div class="borderfile" v-for="(file, key) in files" v-if="files.length > 0" style="justify-content: center; margin-left: 10px;">
          <a class="close-classic" @click="removeFile( key )"></a>
          <div style="text-align: center; display: grid; justify-content: center;padding-top: 15px;">
            <img class="preview" v-bind:ref="'preview'+parseInt( key )" :src="file.filebase64" style="height: 60px !important; width:60px !important;display: flex;justify-content: center; object-fit: cover; object-position: center;" />
            <!-- <b class="text2">{{ file.file.name }}</b> -->
          </div>
        </div>
      </div>



      <div v-if="progressLoadChatBox" class="chat-messages clearfix" style="width: 100%">
        <v-progress-linear :indeterminate="progressLoadChatBox"></v-progress-linear>
      </div>
      <div class="chat-messages clearfix" style="width: 100%" v-else>
        <textarea
          v-if="statemember == 'active' && online" :placeholder="$t('ChatSide.textarea.normal')"
          class="textareabg CSChatThai"
          rows="3"
          v-model="sendmsg"
          @input="filterlistfriend()"
          @keyup.enter.exact="sendMessage(sendmsg)"
          id="textareaChat"
          ref="textareaChat"
          @paste="onPaste"
        >
          </textarea>
        <textarea v-else-if="statemember !='active' && online" disabled :placeholder="$t('ChatSide.textarea.inactive')" rows="3" class="textareabg CSChatThai" style="background-color: #1a222c !important;" id="textareaChat">
          </textarea>
        <textarea v-else disabled placeholder="Network error" rows="3" class="textareabg CSChatThai" style="background-color: #1a222c !important;" id="textareaChat">
          </textarea>

        <!-- btn add-->
        <div v-if="statemember=='active' && online" style="margin-top: -2px;">
          <!-- btn rich menu -->
          <v-btn v-if="list_richmenu.length !== 0" @click="chsheetrichmenu" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 18px !important;">fas fa-list</v-icon>
          </v-btn>
          <!-- btn sheet other -->
          <v-btn @click="chsheetother" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 18px !important;">fas fa-plus</v-icon>
          </v-btn>
          <!-- btn photo-->
          <v-btn @click="uppic" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 23px !important;">insert_photo</v-icon>
          </v-btn>
          <!-- btn sticker -->
          <v-btn @click="chsheetsticker" icon dark class="iconchat" style="font-size: 16px; color: gray; cursor: pointer; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 23px !important;">face</v-icon>
          </v-btn>
        </div>
        <div v-else style="margin-top: -2px;">
          <!-- btn rich menu -->
          <v-btn v-if="list_richmenu.length !== 0" disabled icon dark class="iconchat" style="font-size: 16px; color: gray; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 18px !important;">fas fa-list</v-icon>
          </v-btn>
          <v-btn disabled icon dark class="iconchat" style="font-size: 16px; color: gray; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 18px !important;">fas fa-plus</v-icon>
          </v-btn>
          <v-btn disabled icon dark class="iconchat" style="font-size: 16px; color: gray; margin: 0; margin-left: -2px;">
            <v-icon style="color: gray; font-size: 23px !important;">insert_photo</v-icon>
          </v-btn>
          <v-btn disabled icon dark class="iconchat" style="font-size: 16px; color: gray; margin: 0; margin-left: -2px;">
            <v-icon style="color: white; font-size: 23px !important;">face</v-icon>
          </v-btn>
        </div>




          <v-card tile style=" margin-left: -9px;margin-right: -9px; bottom: 196px  !important; height: 78px; background: #062e63;box-shadow: none;" v-if="statemember=='active' && online && sheetother" id="menu-chat">
            <div class="sidebar-menu">
              <ul>
                <li >
                  <a @click="upfile" title="File" style="padding-top: 3px;">
                    <v-icon style="font-size: 20px !important; background: #2662af; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white;">attach_file</v-icon>
                    <span style="text-transform: none;">{{$t('ChatSide.file')}}</span>
                  </a>
                </li>
                <li>
                  <a title="Account" @click="dialogAccount = true; sheetother = false" style="padding-top: 3px;">
                    <v-icon style="font-size: 20px !important; background: #23ad54; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white;" class="acount">mdi-account</v-icon>
                    <span style="text-transform: none;">{{$t('ChatSide.friend')}}</span>
                  </a>
                </li>
                <li>
                  <a title="Location" @click="openmap()" style="padding-top: 3px;">
                    <v-icon style="font-size: 20px !important; background: #cd2b01; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white;" class="acount">location_on</v-icon>
                    <span style="text-transform: none;">{{$t('ChatSide.location')}}</span>
                  </a>
                </li>
                <li>
                  <a title="Forward" @click="ForwardState = true; sheetother = false" style="padding-top: 3px;">
                    <v-icon style="font-size: 20px !important; background: #d02788; border-radius: 50%; display: flex; justify-content: center; align-items: center; color: white;" class="acount">far fa-share-square </v-icon>
                    <span style="text-transform: none;">{{$t('ChatSide.forward')}}</span>
                  </a>
                </li>
              </ul>
            </div>
          </v-card>


          <v-card tile style=" margin-left: -9px;margin-right: -9px;bottom: 248px !important; background: #062e63;    height: 130px;" v-if="statemember=='active' && online && sheetsticker" id="menu-sticker">
            <v-card-text style="padding-top:  0vh; text-transform: none;">
              <v-tabs centered v-model="activetapEmo" style="background: #062e63 !important; text-transform: none;" slot="extension">
                <v-tab style="font-size: 13px; text-transform: none !important; overflow-y: hidden;background: #062e63 !important;" href="#tab-Emo">
                  <p class="textemo">{{$t('ChatSide.emoji')}}</p>
                </v-tab>
                <v-tab style="font-size: 13px; text-transform: none !important; overflow-y: hidden;background: #062e63 !important;" href="#tab-Stick">
                  <p class="textemo">{{$t('ChatSide.sticker')}}</p>
                </v-tab>
              </v-tabs>
              <v-tabs-items style="margin-top: 0.2vh;background: #062e63 !important;" v-model="activetapEmo">
                <v-tab-item id="tab-Emo" style="height: 105px; text-transform: none;background: #062e63 !important;" class="scrolling-wrapper-y">
                  <div style="background: #062e63 !important;">
                    <v-tabs centered v-model="activeEmoji" style="background: #062e63 !important;" slot="extension">
                      <v-tab v-for="(emojiGroup, category) in emojiGroups" style="font-size: 20px;" :href="'#tab-'+ category">
                        {{emojiGroup['smile']}}
                        {{emojiGroup['bear']}}
                        {{emojiGroup['soccer']}}
                        {{emojiGroup['house_with_garden']}}
                        {{emojiGroup['heart_decoration']}}
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items style="margin-top: 0.2vh;" v-model="activeEmoji">
                      <v-tab-item v-for="(emojiGroup, category) in emojiGroups" :id="'tab-'+category" style="height: 75px;" class="scrolling-wrapper-y">
                        <div class="emojis">
                          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName" @click="append(emoji)" :title="emojiName">{{ emoji }}</span>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-tab-item>
                <v-tab-item id="tab-Stick" style="height: 105px; text-transform: none;" class="scrolling-wrapper-y">
                  <div style="background: #062e63 !important;">
                    <v-tabs centered style="background: #062e63 !important;" v-model="activeSticker" slot="extension">
                      <v-tab style="font-size: 20px;" :href="'#tabsticker-'+item.token_sticker" v-for="(item,index) in sticker" :key="item.token_sticker">
                        <img style="width: 30px;" :src="item.path_title">
                      </v-tab>
                    </v-tabs>
                    <v-tabs-items style="margin-top: 0.2vh; background: #062e63;" v-model="activeSticker">
                      <v-tab-item v-for="(item,index) in sticker" :id="'tabsticker-'+item.token_sticker" style="height: 75px;" class="scrolling-wrapper-y">
                        <v-container wrap style="padding: 0;">
                          <v-layout wrap>
                            <v-flex sm2 md2 lg2 xl2 style=" justify-content: center;" v-for="(items,index) in item.list_sticker">
                              <v-layout style=" justify-content: center;display: flex;text-align: center;">
                                <img style="width: 70px; height: 70px; cursor: pointer;" :src="items.s3_name" @click="pushSticker(items.message)">
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-tab-item>
                    </v-tabs-items>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-card-text>
          </v-card>

    <v-flex lg12 md12 sm12 xl12 style="margin: 0; bottom: 170px; position: fixed; width: 50%; height: 4vh; padding: 5px !important; cursor: pointer;" @click="lookmessage" v-if="showmessagebottom">
      <v-layout justify-center>
        <v-chip close v-model="chip" @click="chip = false;" style="cursor: pointer;">
          <v-avatar>
            <img :src="picturechip" v-if="picturechip" class="alligator-turtle">
            <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" v-else>
          </v-avatar>
          <span class="text2">{{showmessage}}</span>
        </v-chip>
      </v-layout>
    </v-flex>
    <!-- tab show mention -->
    <v-flex lg12 md12 sm12 xl12 class="showmention" v-if="showmention">
      <v-layout row align-center>
        <v-flex xs1>
          <v-avatar>
            <img style="height: 40px; width: 40px;" :src="SelectedMessageDetail.path_pic" v-if="SelectedMessageDetail.path_pic !== ''" class="alligator-turtle">
            <img style="height: 40px; width: 40px;" src="/static/img/default_profile/man-white.png" v-else class="alligator-turtle">
          </v-avatar>
        </v-flex>
        <v-flex xs10 style="margin-left: 10px;">
          <v-layout column v-if="SelectedMessageDetail.typeofmessage == 'message' || SelectedMessageDetail.typeofmessage == 'mention_message'">
            <span style="color: ghostwhite; white-space: nowrap; width: 30vw; overflow: hidden;text-overflow: ellipsis;">{{SelectedMessageDetail.nickname}}</span>
            <span style="color: ghostwhite; white-space: nowrap; width: 30vw; overflow: hidden; text-overflow: ellipsis;" v-if="SelectedMessageDetail.message" v-html="convertMention(SelectedMessageDetail.message)"></span>
          </v-layout>
          <v-layout row v-else-if="SelectedMessageDetail.typeofmessage === 'image' || SelectedMessageDetail.typeofmessage === 'sticker' || SelectedMessageDetail.typeofmessage === 'file'">
            <span style="color: ghostwhite; white-space: nowrap; width: 30vw; overflow: hidden;text-overflow: ellipsis;">{{SelectedMessageDetail.nickname}}</span>
            <v-spacer></v-spacer>
            <img style="height: 40px; width: 40px; border-radius: 10px;" :src="SelectedMessageDetail.message" v-if="SelectedMessageDetail.typeofmessage === 'image'">
            <img style="height: 40px; width: 40px; border-radius: 10px;" :src="SelectedMessageDetail.file_name" v-else-if="SelectedMessageDetail.typeofmessage === 'sticker'">
            <v-icon v-else-if="extension(SelectedMessageDetail.file_name) === 'pdf'" style="color: white; font-size: 35px;">fas fa-file-pdf</v-icon>
            <v-icon v-else style="color: white; font-size: 35px;">{{extension(SelectedMessageDetail.file_name)}}</v-icon>
          </v-layout>
          <v-layout row v-else-if="SelectedMessageDetail.typeofmessage === 'video'">
            <span style="color: ghostwhite; white-space: nowrap; width: 30vw; overflow: hidden;text-overflow: ellipsis;">{{SelectedMessageDetail.nickname}}</span>
              <v-spacer></v-spacer>
              <video v-if="extension(SelectedMessageDetail.message) === 'media'" width="40" height="40" style="justify-content: center; align-items: center;" controls>
                <source :src="SelectedMessageDetail.message" :type="'video/' + SelectedMessageDetail.message.split('.')[SelectedMessageDetail.message.split('.').length - 1]">
              </video>
              <img v-else :src="SelectedMessageDetail.thumbnail" style="width: 40px; height: 40px; justify-content: center; align-items: center;"/>
          </v-layout>
          <v-layout row v-else-if="SelectedMessageDetail.typeofmessage === 'location'">
            <span style="color: ghostwhite; white-space: nowrap; width: 50vw; overflow: hidden;text-overflow: ellipsis;">{{SelectedMessageDetail.nickname}}</span>
            <v-spacer></v-spacer>
            <v-icon style="color: white; font-size: 35px;">fas fa-map-marker-alt</v-icon>
          </v-layout>
        </v-flex>
        <v-flex xs1 style="padding-left: 15px; padding-bottom: 20px;">
          <v-icon color="white" @click="showmention = false;">close</v-icon>
        </v-flex>
      </v-layout>
    </v-flex>



        <!-- btn send msg -->
        <v-btn class="buttonsend" small flat @click="sendMessage(sendmsg)" v-if="checksen(sendmsg)" style="bottom: 4px; position: fixed; margin-left: 66vw;">
          <v-icon style="color: white; font-size: 15px !important;">send</v-icon>&nbsp;Send
        </v-btn>

      </div>

    </v-flex>
          <v-card v-if="status_tag === true" class="friendList">
            <div>
            <v-list v-for="(item,index) in listfriend_filter" :key="index" >
              <v-list-tile  @click="tagFriend(item.name)">
                  <v-list-tile-avatar>
                    <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle">
                    <img v-else src='/static/img/default_profile/man-white.png' class="alligator-turtle">
                  </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
        </div>
      </v-card>
    <div style="display:none;">
      <input type="file" id="uploadpic_ocr" @change="onimgSelected_ocr($event)" @click="clearImage()" accept="image/*" />
      <input multiple type="file" id="uploadpic" @change="onimgSelected($event)" accept="image/*" />
      <input type="file" id="uploadpic_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" accept="image/*" />
      <input type="file" id="uploadfile_quickreply" @change="onimgSelected_quickreply($event)" @click="clearImage()" />
      <input multiple type="file" id="uploadfileChat" @change="onFileSelected"/>

    </div>
</form>
  </div>
  </div>
   <LoginDialog :dialogLogin="dialogLogin" @closeLoginDialog="closeLoginDialog"></LoginDialog>
  <AccountDialog :dialogAccount="dialogAccount" @closeAccount="closeAccount" @pushcontact="pushcontact"></AccountDialog>
  <MapDialog :dialogSendMap="dialogSendMap" @closeSendMap="closeSendMap" @send_location="send_location"></MapDialog>
  <NoteDialog :dialogNote="dialogNote" :note_id="note_id" :statemember="statemember" @closeNote="closeNote"></NoteDialog>
  <AlbumsDialog :dialogAlbums="dialogAlbums" :albums_id="albums_id" @closeAlbums="closeAlbums"></AlbumsDialog>
  <AddImageDialog :dialogAddImage="dialogAddImage" @closeAddImage="closeAddImage" :path_pic_albums="SelectedMessageDetail.message" :file_name="SelectedMessageDetail.file_name"></AddImageDialog>
  <CreatemailDialog :dialogCreatemail="dialogCreatemail" @closeCreatemail="closeCreatemail" :message="SelectedMessageDetail"></CreatemailDialog>

<!--   <WebviewDialog :dialogWebview="dialogWebview" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewDialog> -->
   <WebviewBigDialog :token="token" :tokenrooomSelect="tokenrooomSelect" :dialogWebviewbig="dialogWebviewbig" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialog>
    <WebviewBigOcrDialog :token="token" :tokenrooomSelect="tokenrooomSelect" :dialogWebviewbig_ocr="dialogWebviewbig_ocr" :Webview_item="Webview_item_ocr" @closeWebview="closeWebview"></WebviewBigOcrDialog>
  <!-- <ModalImg :modalImg="imgShow" @closeModalimg="closeDialognote"></ModalImg> -->
  <ApproveDialog :dialogApprove="dialogApprove" :ApproveDetail="ApproveDetail" @sendansApprove="sendansApprove" @closeApprove="closeApprove"></ApproveDialog>
  <ForwardDialog :dialogForward="dialogForward" :selectedForward="selectedForward" @closeForward="closeForward"></ForwardDialog>
  <Openwebsite :dialogopenwebsite="dialogopenwebsite" :id="id" :type="type" @closeDialog="closeDialog"></Openwebsite>
  <DetailTask :dialogDetailTask="dialogDetailTask" @closeDetailTask="closeDetailTask" :taskid="taskid" :roomid="roomid"></DetailTask>
  <SaveOnebox :dialogSaveOnebox="dialogSaveOnebox" @closeSaveOnebox="closeSaveOnebox" :tokenmessage_savebox="tokenmessage_savebox"></SaveOnebox>
  <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" @closeCheckBrowser="closeCheckBrowser" :checkBrowserInfor="checkBrowserInfor"></CheckBrowserDialog>
  <QrcodeDialog :QrcodeInfor="QrcodeInfor" :typemenu="typemenu" :dialogShowQRCode="dialogShowQRCode" :tokenroom="tokenrooomSelect" @closeShowQRCodeUser="closeShowQRCodeUser"></QrcodeDialog>
  <AgoraCallDialog :AgoraCallDialog="AgoraCallDialog" :AgoraOption="AgoraOption" :infor_call="infor_call" :tokenuser="token" @decline_call="decline_call" @closeAgoraDialog="closeAgoraDialog"></AgoraCallDialog>
  <v-dialog v-model="dialogMap" fullscreen>
    <v-toolbar card style="background: #1a222c !important;">
      <v-toolbar-title class="white--text" v-if="locationName.file_name != ''"> 🚩&nbsp;&nbsp;{{locationName.file_name}} </v-toolbar-title>
      <v-toolbar-title class="white--text" v-else> 🚩&nbsp;&nbsp;somewhere </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn dark icon flat @click="dialogMap = false">
        <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
      </v-btn>
    </v-toolbar>
<!--     <div id="map" style="height: 100%; width: 100%;">
    </div> -->

    <gmap-map
      :center="center_markermap"
      :zoom="15"
      style="width:100%;  height: calc(100vh - 64px);"
    >
      <gmap-marker
        :position="center_markermap"
      ></gmap-marker>
    </gmap-map>



  </v-dialog>


</v-layout>
</template>
<script>
import pdf from 'vue-pdf'
import offline from 'v-offline'
import { Momenttime, Decode } from '@/services'
import NoteDialog from '@/components/chat/dialog/notes/NoteDialog'
import AccountDialog from '@/components/chat/dialog/manage_chat/AccountDialog'
import LoginDialog from '@/components/chat/dialog/LoginDialog'
import ForwardDialog from '@/components/chat/dialog/manage_chat/ForwardDialog'
import MapDialog from '@/components/chat/dialog/manage_chat/MapDialog'
// import WebviewDialog from '@/components/chat/dialog/manage_chat/WebviewDialog'
import ApproveDialog from '@/components/chat/dialog/manage_chat/ApproveDialog'
import AlbumsDialog from '@/components/chat/dialog/albums/AlbumsDialog'
import AddImageDialog from '@/components/chat/dialog/albums/AddImageDialog'
import Openwebsite from  '@/components/chat/dialog/settings/Openwebsite'
import ShowImageDialog from '@/components/chat/dialog/ShowImageDialog'
import ShowPDFDialog from '@/components/chat/dialog/ShowPDFDialog'
import CreatemailDialog from '@/components/chat/dialog/mail/CreatemailDialog'
import WebviewBigDialog from '@/components/chat/dialog/manage_chat/WebviewBigDialog'
import WebviewBigOcrDialog from '@/components/chat/dialog/manage_chat/WebviewBigOcrDialog'
import DetailTask from '@/components/chat/manage_task/detail_task_dialog'
import SaveOnebox from '@/components/chat/dialog/saveonebox/SaveoneboxDialog'
import Richmenudialog from '@/components/chat/dialog/richmenu/Richmenudialog'
import CheckBrowserDialog from '@/components/chat/dialog/CheckBrowserDialog'
import QrcodeDialog from '@/components/chat/dialog/settings/ShowQRCodeUserDialog'
import AgoraCallDialog from '@/components/chat/agora_call/ans_call'
import LinkPrevue from 'link-prevue'
import { VueContext } from 'vue-context';
import { vplayer } from 'vue-hls-player'
// Vue.use(VueCoreVideoPlayer)
import HighlightableInput from "vue-highlightable-input"
// import ModalImg from '@/components/chat/modal/ModalImg'
import At from 'vue-at'
import AtTa from 'vue-at/dist/vue-at-textarea'
import {
  sync
} from 'vuex-pathify'
import { Encode } from '@/services'
const emojiGroups = require('../../../../static/json/emoji')
var _ = require('lodash')
import { Mentionable } from 'vue-mention'
import Vue from 'vue'
import VueHighlights, { autoLink, autoHighlight } from 'vue-highlights'
Vue.component(VueHighlights.name, VueHighlights)

window.EventBus = new Vue({
  methods: {
    emit(payload) {
      this.$emit('$EventBusEvent', payload);
    }
  }
});

export default {
  components: {
    AgoraCallDialog,
    vplayer,
    QrcodeDialog,
    CheckBrowserDialog,
    LoginDialog,
    pdf,
    // ModalImg,
    offline,
    MapDialog,
    NoteDialog,
    AccountDialog,
    ForwardDialog,
    // WebviewDialog,
    WebviewBigDialog,
    WebviewBigOcrDialog,
    ApproveDialog,
    AlbumsDialog,
    AddImageDialog,
    Openwebsite,
    VueContext,
    ShowImageDialog,
    ShowPDFDialog,
    CreatemailDialog,
    DetailTask,
    SaveOnebox,
    Richmenudialog,
    LinkPrevue,
    HighlightableInput,
    Mentionable,
    At,
    AtTa
    // shareContactDialog
  },
  props:{
    extractUrlsWithoutProtocol: {
      type: Boolean,
      default: true
    },
    caretColor: {
      type: String,
      default: '#ccc'
    },
    placeholder: {
      type: String,
      default: `What's Happening?`
    },
    value: String
  },
  data: () => ({
    AgoraCallDialog: false,
    AgoraOption: '',
    infor_call: {},
    typeroom: '',
    typemenu: 'richmenu',
    QrcodeInfor: '',
    dialogShowQRCode: false,
    ocr_detailItem: '',
    checkBrowserInfor: {},
    checkBrowserDialog: false,
    center_markermap: {},
    quickreplyStyle: 'position: absolute !important;top: calc(98vh - 160px);',
    itemdetail_quickreply: {},
    bot_id_richmenu: '',
    default_behavior: 0,
    richmenu_label: '',
    list_richmenu: [],
    tokenuser_friend: '',
    type_richmenu: 0,
    Richmenudialog: false,
    inforrichmenu: {},
    sheetrichmenu: false,
    RichmenuState: false,
    tokenmessage_savebox: '',
    extionfile: '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
    taskid: '',
    files: [],
    nameFile: 'picture.png',
    dialogDetailTask: false,
    SelectedMessageDetail: {},
    rightclickdialog: false,
    showmention: false,
    picturechip: '',
    chip: false,
    Webview_item: {},
    Webview_item_ocr: {},
    selectedForward: [],
    DetailFile: {},
    DetailImage: {},
    progressLoadChatBox: false,
    showloc: '',
    ForwardState: false,
    dialogSaveOnebox: false,
    dialogshowimage: false,
    dialogshowfile: false,
    dialogForward: false,
    dialogApprove: false,
    dialogAccount: false,
    dialogMap: false,
    dialogSendMap: false,
    dialogNote: false,
    dialogWebview: false,
    dialogWebviewbig: false,
    dialogWebviewbig_ocr: false,
    dialogAlbums: false,
    dialogAddImage: false,
    dialogCreatemail: false,
    dialogopenwebsite: false,
    dialogLogin: false,
    id: '',
    type: '',
    statemember: '',
    imgShow: false,
    // messageQuickreply: true,
    Quickreply: {},
    datepicker: false,
    timepicker: false,
    dateselect: '',
    maxdate: '',
    mindate: '',
    timeselect: '',
    maxtime: '',
    mintime: '',
    typepicker: '',
    infodata: '',
    box_height: '',
    note_id: '',
    tabs: ['tab-1', 'tab-2', 'tab-3'],
    model: 'tab-2',
    filepdf: '',
    // shareContact: false,
    currentPage: 1,
    pageCount: 0,
    scrollMaxOld: 0,
    // firsttime: true,
    statePage: '',
    profile: '',
    offsetTop: 0, // test scroll
    // dialog: false,
    tokenrooomSelect: '',
    // alert: true,
    items: [],
    sendmsg: '',
    name: '',
    selectFile: null,
    statusload: false,
    place: null,
    sheet: false,
    lat: '',
    lng: '',
    address: '',
    nicknameSend: '',
    filenameSend: '',
    timeSend: '',
    picSend: '',
    dateSend: '',
    tokenmsgSend: '',
    pathSend: '',
    typeuserSend: '',
    activeEmoji: null,
    activeSticker: null,
    activetapEmo: null,
    sheetother: false,
    sheetsticker: false,
    chatlogsFlex: '',
    showmessagebottom: false,
    showmessage: '',
    sticker: [{
      'list_sticker': []
    }],
    typeuser: '',
    progressLoadChat: false,
    emojiGroups,
    map: '',
    x: 15,
    y: 30,
    locationArray: [],
    locationName: '',
    sendmap: '',
    windowWidth: '',
    temp: [],
    online: true,
    ApproveDetail: {},
    albums_id: '',
    ListMenuRightClick: [],
    listannounce: [],
    show: false,
    less: false,
    announcedialog: false,
    announce_message: {},
    dragAndDropCapable: false,
    roomid: '',
    imageData: '',
    RichmenuState_first: false,
    listfriend_filter: [],
    listfriend: [],
    status_tag: false,
    msg: '',
    bot_id: '',
    highlight:[],
    highlightEnabled: true,
    mentionUsers: '',
    length_listfreind: 0,
    text_search: '',
    content: null,
    item_freind: [],
    one_id: '',
    block:'',
    tokenuser: '',
    token: '',
  }),
  computed: {
    ...sync('*')

  },
  mounted() {
    // this.map = new longdo.Map({
    //   placeholder: document.getElementById('map'),
    //   lastView: true
    // })
    EventBus.$on('$EventBusEvent', this.handleEventBusEvent);

    this.dragAndDropCapable = this.determineDragAndDropCapable()

    if (this.dragAndDropCapable) {
      // console.log('this.dragAndDropCapable->' + this.dragAndDropCapable)
      ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach(function (evt) {
        this.$refs.fileformChat.addEventListener(evt, function (e) {
          // console.log(e)
          e.preventDefault()
          e.stopPropagation()
        })
      }.bind(this))
      // this.$refs.fileformChat.addEventListener('dragover', function (e) {
      //   // console.log('dragover')
      // }.bind(this))
      // this.$refs.fileformChat.addEventListener('dragleave', function (e) {
      //   // console.log('dragleave')
      // }.bind(this))
      this.$refs.fileformChat.addEventListener('drop', function (e) {
        this.onFileDrag(e.dataTransfer.files)
      }.bind(this))
    }
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
    var me = this
    $(document).click(function(event) {
      var target = $(event.target);
      if(!target.closest('#menu-chat').length && $('#menu-chat').is(":visible")) {
        me.sheetother = false
        // $('#menu-chat').fadeOut(1600);
      } else if(!target.closest('#menu-sticker').length && $('#menu-sticker').is(":visible")) {
        me.sheetsticker = false
        // $('#menu-sticker').fadeOut(1600);
      }
    })
  },
  watch: {
    block_friend (data) {
      // console.log(data)
      if (data.event === 'unblock_friend') {
        this.statemember = 'active'
      } else {
        this.statemember = 'block'
      }
    },
    // items () {
    //   console.log(this.items)
    // },
    // sendmsg () {

    // },
    showmention () {
      if(this.showmention == true){
        this.status_tag = false
        // console.log('eeeee')
      }
    },
    files () {
      if (this.files.length != 0) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 275px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 245px);'
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        }
      }
    },
    socket_close_webview (data) {
      console.log('socket_close_webview')
      // console.log(data)
      if (data.tokenroom === this.$route.params.roomid) {
        this.Webview_item = {}
        this.dialogWebviewbig = false
      }
      // this.Webview_item = {}
      // this.dialogWebviewbig = false
    },
    socketexpire_login (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.dialogLogin = true
      }
    },
    socket_official_template (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // console.log(data)
        var index_target = data.target_index
        var index = _.findIndex(this.items, function(o) { return o.tokenmessage == data.tokenmessage })
        this.items[index].element.choice[index_target].disable = '1'
        // console.log(index_target)
      }
    },
    chat_wallpaper () {
      // console.log(this.chat_wallpaper.info)
      var room = this.$route.params.roomid
      var index = _.findIndex(this.chat_wallpaper.info, function (o) { return o.room === room })
      // console.log(index)
      if (index === -1) {
        this.imageData = ''
      } else {
        this.imageData = this.chat_wallpaper.info[index].background
      }
      this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
      this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
      // console.log(this.imageData)
    },
    less() {
      if (this.less) {
        this.$cookie.set(this.$route.params.roomid, 'less')
      } else {
        this.$cookie.delete(this.$route.params.roomid)
      }
    },
    socket_announce(data) {
      this.axios.post(process.env.APIpub + '/v1/user/get_announce_room_by_id', {
        tokenuser: this.token,
        token_announce: data.token_announce,
        tokenroom: this.tokenrooomSelect
      }).then((response) => {
        this.listannounce.unshift(response.data.data)
      })
    },
    box_height() {
      if (this.imageData === '') {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;'
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
      } else {
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
      }
    },
    selectedForward() {
      if (this.selectedForward.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.Chat.maxMessage'),
          'error'
        )
        _.pullAt(this.selectedForward, [5])
      }
    },
    windowWidth() {
      if (this.windowWidth <= 960) {
        // this.$router.push('/mobile/room/' + this.$route.params.roomid)
        this.$router.push('/mobile/progress/' + this.$route.params.roomid)
      }
    },
    dialogMap() {
      if (this.dialogMap) {
        // this.initmapShow()
      }
    },
    sheetrichmenu () {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      if (this.type_richmenu <= 7) {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-color: #fdfdfd;'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);'
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 370px) !important; background-image: url(' + this.imageData + ');'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 351px);'
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
          }
        }
      } else {
        if (this.sheetrichmenu) {
          setTimeout(this.scrollDown, 1)
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-color: #fdfdfd;'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);'
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 245px) !important; background-image: url(' + this.imageData + ');'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 215px);'
          }
        } else {
          if (this.imageData === '') {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
          } else {
            this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');'
            this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
          }
        }
      }
    },
    RichmenuState () {
      // console.log(this.RichmenuState)
      // console.log(this.sheetrichmenu)
      // console.log(this.type_richmenu <= 7)
      setTimeout(this.scrollDown, 1)
      if (!this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 195px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 165px);'
        }
      } else if (this.RichmenuState && !this.sheetrichmenu) {
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(100vh - 135px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 105px);'
        }
      }
    },
    sheetsticker () {
      if (this.sheetsticker) {
        // this.chatlogsFlex = 'height:calc(98vh - 310px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 310px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 280px);'
        }
      } else {
        // this.chatlogsFlex = 'height:calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        }
      }
    },
    sheetother() {
      if (this.sheetother) {
        // this.chatlogsFlex = 'height:calc(98vh - 260px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 260px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 230px);'
        }
      } else {
        // this.chatlogsFlex = 'height: calc(98vh - 185px) !important;'
        if (this.imageData === '') {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        } else {
          this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
          this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
        }
      }
    },
    myprofile() {
      this.profile = localStorage.getItem('profilepicture')
    },
    layout() {
      this.tokenrooomSelect = this.$route.params.roomid
    },
    '$route.params.roomid'() {
      this.less = false
      this.scrollMaxOldSet()
      this.statusload = false
      this.ForwardState = false
      this.selectedForward = []
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.tokenrooomSelect = this.$route.params.roomid
      this.items = []
      this.Quickreply = []
      this.RichmenuState = false
      this.sheetrichmenu = false
      this.inforrichmenu = {}
      this.type_richmenu = 0
      this.sendmsg = ''
      this.status_tag = false
      this.getlistfriend()
      this.getroom()
      // this.get_list_richmenu(this.$route.params.roomid)
      this.getOldMessage('')
      this.getreply()
      this.getlistannounce()
      var announce = this.$cookie.get(this.$route.params.roomid)
      // console.log(announce)
      if(announce !== null) {
        this.less = true
      }
      this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
      // console.log(this.chat_wallpaper)
      var room = this.tokenrooomSelect
      var index = _.findIndex(this.chat_wallpaper.info, function(o) { return o.room === room })
      // console.log(index)
      if (index === -1) {
        this.imageData = ''
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-color: #fdfdfd;'
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
      } else {
        this.imageData = this.chat_wallpaper.info[index].background
        this.chatlogsFlex = 'background-position: center; background-repeat: no-repeat; background-size: cover; height:calc(98vh - 185px) !important; background-image: url(' + this.imageData + ');'
        this.quickreplyStyle = 'position: absolute !important;top: calc(98vh - 160px);'
      }
    },
    socketmessage() {
      // console.log(this.socketmessage)
      // if (this.socketmessage.typeofmessage === 'agora_call' && this.socketmessage.tokenuser !== this.token) {
      //   console.log(`open dialog call`)
      //   this.infor_call = this.socketmessage
      //   var me = this
      //   setTimeout(function() {
      //     me.AgoraOption = me.typeAgoraCall
      //     me.AgoraCallDialog = true
      //     console.log(me.AgoraCallDialog)
      //   }, 1000);
      // }
      // this.Quickreply = []
      this.getMessageSocket(this.socketmessage)
    },
    typeAgoraCall (data) {
      this.typeAgoraCall = data
      console.log(this.typeAgoraCall)
    },
    socket_accept_call (data) {
      console.log(`acctpt call`)
      // console.log(data)
      // if (data.status === 'success') {
      //   this.infor_call = {}
      //   this.AgoraCallDialog = false
      // }
      // this.infor_call = {}
      this.AgoraCallDialog = false
    },
    socket_update_agora (data) {
      console.log(`update agora`)
      // console.log(data)
      if (data.status === 'end' || data.status === 'cancel') {
        this.infor_call = {}
        this.AgoraCallDialog = false
      }
    },
    socketremove_friend(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.statemember = 'unfriend'
      }
    },
    socket_kickmember(data) {
      var self = this
      data.listkick.forEach(function(item) {
        if (self.token === item) {
          self.statemember = 'leave'
        }
      })
    },
    socketactive_group(data) {
      if (this.token === data.tokenuser) {
        this.statemember = 'active'
      }
    },
    socketquickreply(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        this.getreply()
      }
    },
    socketdisablequickreply(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        // this.Quickreply = ''
        this.getreply()
      }
    },
    socket_unsendmessage (data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function(o) { return o.tokenmessage === data.tokenmessage })
        var mentiontokenmessage = this.items[indexid].tokenmessage
        var indexmentionmsg = _.findIndex(this.items, function(o) { return o.file_name === mentiontokenmessage })
        if (indexmentionmsg === -1) {
          this.items[indexid].typeofmessage = 'unsend_message'
        } else {
          this.items[indexid].typeofmessage = 'unsend_message'
          this.items[indexmentionmsg].source_message.typeofmessage = 'unsend_message'
        }
      } else {

      }
    },
    socketdisableapprove(data) {
      if (data.tokenroom === this.$route.params.roomid) {
        var indexid = _.findIndex(this.items, function(o) {
          return o.tokenmessage === data.tokenmessage && o.typeofmessage === 'approve_message'
        })
        this.items[indexid].disable = 'true'
      }
    }
  },
  created() {
    this.box_height = (screen.height - 64.0) - 120.0
    // this.statemember = 'active'
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    this.tokenrooomSelect = this.$route.params.roomid
    this.profile = localStorage.getItem('profilepicture')
    this.typeuser = localStorage.getItem('type_user')
    this.name = localStorage.getItem('name')
    this.getlistfriend()
    this.getroom()
    this.getOldMessage('')
    this.getreply()
    this.getlistannounce()
    this.axios.post(process.env.APIimage + '/sticker/gettitleallsticker', {
      tokenuser: this.token
    }).then((responsed) => {
      this.sticker = responsed.data['data']
    })
    var announce = this.$cookie.get(this.$route.params.roomid)
    if(announce !== null) {
      this.less = true
    }
    this.chat_wallpaper = JSON.parse(localStorage.getItem('wallpaperInfo'))
    var room = this.tokenrooomSelect
    var index = _.findIndex(this.chat_wallpaper.info, function(o) { return o.room === room })
    if (index === -1) {
      this.imageData = ''
    } else {
      this.imageData = this.chat_wallpaper.info[index].background
    }
  },
  methods: {
    closeAgoraDialog (value) {
      this.AgoraCallDialog = value
    },
    decline_call (item) {
      this.axios.post(process.env.APIalpine + `/api/v1/update-agora`, {
        tokenuser: this.token,
        tokenroom: item.tokenroom,
        time: '',
        message: 'cancel'
      }).then((response) => {
        console.log(response)
        // if (response.data.status === 'success') {
        //   this.one_id = response.data.one_id
        // }
      })
    },
    get_oneid () {
      this.axios.get(process.env.APIgo_api + `/v1/getOneID/${this.token}`).then((response) => {
        if (response.data.status === 'success') {
          this.one_id = response.data.one_id
        }
      })
    },
    ans_ekyc (item) {
      // console.log(item)
      this.ans_quickreply(item, 'ekyc')
      this.axios.post(process.env.APIimage + '/api/v1/get_shared_token',
      { user_id: this.one_id }).then((response) => {
        if (response.data.status === 'success') {
          var url = `${process.env.urlEkyc}${response.data.data.shared_token}`
          this.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
          }
          // this.dialogWebviewbig = true
          this.checkBrowser(url, this.Webview_item)
        }
      }).catch(error => {
        console.log(error)
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
    ans_ekyc_template (item) {
      this.axios.post(process.env.APIimage + '/api/v1/get_shared_token',
      { user_id: this.one_id }).then((response) => {
        if (response.data.status === 'success') {
          var url = `${process.env.urlEkyc}${response.data.data.shared_token}`
          this.Webview_item = {
            label: item.label,
            url: url,
            size: 'full',
            type: 'ekyc',
            payload: ''
          }
          // this.dialogWebviewbig = true
          this.checkBrowser(url, this.Webview_item)
        }
      }).catch(error => {
        console.log(error)
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
    handleEventBusEvent(payload) {
      console.log(payload)
      // alert(payload);
    },
    // handleClick(e) {
    //   console.log(e.target.innerHTML)
    // },
    handleClickTest(e){
      const username = e.target.innerHTML.substring(1)
      const myUser = localStorage.name
      // console.log(myUser)
      if(username != myUser){
        // const item = this.listfriend.filter(friend =>
        //   (friend.name.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        //       .includes(username.toLowerCase().replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`))
        // )
        // console.log(item)

          this.listfriend.forEach(freind =>{
            // var item = []
            const rex = /[\u{1f300}-\u{1f5ff}\u{1f900}-\u{1f9ff}\u{1f600}-\u{1f64f}\u{1f680}-\u{1f6ff}\u{2600}-\u{26ff}\u{2700}-\u{27bf}\u{1f1e6}-\u{1f1ff}\u{1f191}-\u{1f251}\u{1f004}\u{1f0cf}\u{1f170}-\u{1f171}\u{1f17e}-\u{1f17f}\u{1f18e}\u{3030}\u{2b50}\u{2b55}\u{2934}-\u{2935}\u{2b05}-\u{2b07}\u{2b1b}-\u{2b1c}\u{3297}\u{3299}\u{303d}\u{00a9}\u{00ae}\u{2122}\u{23f3}\u{24c2}\u{23e9}-\u{23ef}\u{25b6}\u{23f8}-\u{23fa}]/ug;
            var x = username.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
            var y = freind.name.replace(rex, match => `[e-${match.codePointAt(0).toString(16)}]`)
            // console.log(x)
            // console.log(y)
            // console.log(x.includes(y))
            if(x.includes(y)){
              // console.log(freind)
              const tokenUser = freind.tokenuser
              this.detailFriend(tokenUser)
            }
          })
      }else{
        var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
        this.detailFriend(decoded.tokenuser)
      }

    },
    getlistfriend(){
      const tokenUser = JSON.parse(Decode.decode(localStorage.Authenrization)).tokenuser
      const me = localStorage.name
      const body = {
        tokenuser: tokenUser,
        tokenroom: this.$route.params.roomid
      }
      this.axios.post(process.env.APImanage + '/getroom' , body).then((response)=>{
        if (response.status === 200){
            const listfriend = response.data.data_room
            // console.log('length listfreind' , listfriend.length)
            this.listfriend = listfriend.filter(friend =>
              friend.type == 'user'
              && friend.tokenuser !== tokenUser
              && friend.statemember === 'active'
            )
            // console.log(this.listfriend)
            // this.length_listfreind = this.listfriend
            // if(listfriend.length == 1){
            //   this.status_tag = false
            // }
        }
      })
    },
    getroom () {
      const body = {
        tokenuser: this.token,
        tokenroom: this.$route.params.roomid
      }
      this.axios.post(process.env.APImanage + '/getroom' , body).then((response)=>{
        if (response.status === 200){
          this.block = response.data.statemember
          // console.log(response.data.data_room)
          this.typeroom = response.data.type
          var me = this
          this.listfriend = _.filter(response.data.data_room, function(o) { return o.tokenuser !== me.token && o.type === 'user' && o.statemember === 'active' })
          if (response.data.data_room.length == 1 && response.data.data_room[0].type == 'bot') {
            var bot_id = response.data.data_room[0].tokenuser
            // console.log(this.bot_id)
            this.get_list_richmenu(bot_id)
          } else {
            this.list_richmenu = []
          }
        }
      })
      this.get_oneid()
    },
    play (e) {
      console.log(e)
    },
    closeShowQRCodeUser (value) {
      this.dialogShowQRCode = value
      // this.checktype = ''
      // this.tokenrooomSelect = ''
    },
    closeCheckBrowser (value) {
      this.checkBrowserDialog = value
      this.checkBrowserInfor = {}
    },
    btn_answer_carousel (item) {
      // console.log(item)
      // if (item.type === 'text' || item.type === 'postback') {
      //   this.ans_carousel(item)
      // } else if (item.type === 'webview' || item.type === 'link') {
      //   var infor = {
      //     sign: item.sign,
      //     url: item.action,
      //     type: item.type,
      //     label: item.button,
      //     onechat_token: item.onechat_token,
      //     size: 'full'
      //   }
      //   this.check_get_accesstoken(infor)
      // } else {
      //   console.log(item.type)
      // }
      if (item.type === 'webview' || item.type === 'link') {
        var infor = {
          sign: item.sign,
          url: item.action,
          type: item.type,
          label: item.button,
          onechat_token: item.onechat_token,
          payload: item.payload,
          size: 'full'
        }
        this.check_get_accesstoken(infor)
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      } else {
        this.ans_carousel(item)
      }
    },
    saveLogNews (item) {
      // console.log(item)
      this.axios.get(process.env.APIgo_api + '/v1/getOneID/' + this.token).then((response) => {
        var one_id = response.data.one_id
        // console.log(one_id)
        this.axios.post(process.env.Savelognews, {
          'one_id': one_id,
          'news_id': item.payload.news_id,
          'news_index': item.payload.news_index.toString(),
          'page_name': item.payload.page_name
        }).then((response) => {
          // console.log(response)
        }).catch(error => {
          console.log(error)
        })
      }, (error) => {
        console.log(error)
      })
    },
    ans_carousel (item) {
      var payload = {}
      if (item.payload !== undefined) {
        payload = item.payload
      }
      var body = {
        tokenuser: this.token,
        tokenroom: this.tokenrooomSelect,
        action: item.action,
        type: item.type,
        payload: payload
      }
      // console.log(body)
      this.axios.post(process.env.APIalpine + '/api/v1/ansCarousel', body).then((response) => {
        // console.log(response.data)
      }).catch(error => {
        console.log(error)
      })
    },
    emitrichmenu (item) {
      // console.log(item)
      var expireddate = Date.parse(item.expired_date)
      var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
      var url = ''
      if (_.includes(item.infor.url, ['?'])) {
        url = '&'
      } else {
        url = '?'
      }
      var weburl = item.infor.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate
      if (item.infor.type === 'text') {
        this.sendMessage(item.infor.message)
      } else if (item.infor.type === 'link') {
        if (item.infor.sign_share === 'true') {
          // window.open(weburl, '_blank')
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu)
        } else if (item.infor.sign === 'true') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else {
          // window.open(item.infor.url, '_blank')
          this.checkBrowser(item.infor.url, item)
        }
      } else if (item.infor.type === 'webview') {
        if (item.infor.sign_share === 'true') {
          // var infor_webview = {
          //   message: item.infor.message,
          //   picture: item.infor.picture,
          //   sign: item.infor.sign,
          //   size: item.infor.size,
          //   type: item.infor.type,
          //   url: weburl
          // }
          // this.Webview_item = infor_webview
          // this.dialogWebviewbig = true
          this.getSign(item.infor.url, item.infor, this.bot_id_richmenu)
        } else if (item.infor.sign === 'true') {
          var infor_webview = {
            message: item.infor.message,
            picture: item.infor.picture,
            sign: item.infor.sign,
            size: item.infor.size,
            type: item.infor.type,
            url: weburl
          }
          this.Webview_item = infor_webview
          this.dialogWebviewbig = true
          // console.log(this.Webview_item)
        } else {
          this.Webview_item = item.infor
          this.dialogWebviewbig = true
        }
      } else if (item.infor.type === 'link_market') {
        // console.log(item)
        // this.linkmarket = item.infor.url
        // this.$router.push('/chat/service/market?goto=link_market')
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      } else if (item.infor.type === 'location') {
        // console.log('rich menu type location')
        this.sendlocation_quickreply()
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'false') {
        console.log('rich menu type qrcode')
        this.dialogShowQRCode = true
        this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' }
      } else if (item.infor.type === 'qrcode' && item.infor.location_status === 'true') {
        console.log('rich menu qrcode location')
        this.dialogShowQRCode = true
        if (window.navigator.geolocation) {
          window.navigator.geolocation.getCurrentPosition((position) => {
            this.QrcodeInfor = { status: item.infor.location_status, lat: position.coords.latitude, lng: position.coords.longitude, address: '' }
          })
        } else {
          console.log('error geo')
          this.QrcodeInfor = { status: item.infor.location_status, lat: '', lng: '', address: '' }
        }
      } else {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      }
    },
    chsheetrichmenu () {
      this.RichmenuState = true
      this.Richmenudialog = true
      this.sheetrichmenu = this.RichmenuState_first
      // console.log(this.Richmenudialog)
      // console.log('click sheetrichmenu')
    },
    removeFile (key) {
      this.files.splice(key, 1)
    },
    onPaste (evt) {
      var items = (evt.clipboardData || evt.originalEvent.clipboardData).items
      var index = 0
      var me = this
      this.nameFile = 'picture.png'
      for (index in items) {
        var item = items[index]
        if (item.kind === 'string') {
          this.nameFile = evt.clipboardData.getData('text/plain')
        } else if (item.kind === 'file') {
          var blob = item.getAsFile()
          var reader = new FileReader()
          reader.onload = function (evt) {
            me.sendmsg = me.sendmsg.replace(me.nameFile, '')
            me.files.push({
              file: blob,
              filebase64: evt.target.result,
              status: 'waiting',
              name: me.nameFile
            })
          }
          reader.readAsDataURL(blob)
        }
      }
    },
    determineDragAndDropCapable () {
      console.log('determineDragAndDropCapable')
      var div = document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    },
    open_detail_task (taskid, tokenroom) {
      this.taskid = taskid
      this.roomid = tokenroom
      this.dialogDetailTask = true
    },
    checkuserinassign (item) {
      var tokenuser = this.token
      var index = _.findIndex(item, function (o) { return o.tokenuser === tokenuser })
      if (index >= 0) {
        return true
      } else {
        return false
      }
    },
    checkbutton (color, bng) {
      var  text = {
        'text-transform': 'none',
        'width': '100%',
        'margin': '0',
        'font-size': '13px',
        'border-radius': '20px'
      }
      // [choice.color]? ('color': choice.color):('color':'black')
      if (color) {
        text['color']= color
      } else {
        text['color']= 'black'
      }
      if (bng) {
        text['background']= bng
      } else {
        text['background']= 'none'
      }
      return text
    },
    cancel_announce () {
      this.rightclickdialog = false
      var token_announce = this.SelectedMessageDetail._id
      this.$swal({
        text: this.$t('Alert.Chat.announce.cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/disable_single_announce_room', {
          tokenuser: this.token,
          tokenroom: this.tokenrooomSelect,
          token_announce: token_announce}).then((responsed) => {
            if (responsed.data.status == 'success') {
              var index = _.findIndex(this.listannounce, function (o) { return o._id === token_announce })
              if (index >= 0) {
                this.listannounce.splice(index, 1)
              }
            } else {
              this.listannounce = []
            }
          })
        }
      })
    },
    delete_announce () {
      this.$swal({
        text: this.$t('Alert.Chat.announce.deleteAll'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIpub + '/v1/user/disable_announce_room', {tokenuser: this.token, tokenroom: this.tokenrooomSelect}).then((responsed) => {
            if (responsed.data.status == 'success') {
              this.listannounce = []
            } else {
            }
          })
        }
      })
    },
    announce_msg () {
      this.rightclickdialog = false
      this.axios.post(process.env.APIpub + '/v1/user/announce_room', {
        tokenuser: this.token,
        tokenmessage: this.SelectedMessageDetail.tokenmessage,
        tokenroom: this.SelectedMessageDetail.tokenroom
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.$swal(
            '',
            this.$t('Alert.Success.announce'),
            'success'
          )
        }
        this.show = false
      })
    },
    getlistannounce () {
      this.axios.post(process.env.APIpub + '/v1/user/get_announce_room', {tokenuser: this.token, tokenroom: this.tokenrooomSelect}).then((responsed) => {
        if (responsed.data.status == 'success') {
          this.listannounce = responsed.data.data
          this.listannounce = _.reverse(this.listannounce)
        } else {
          this.listannounce = []
        }
      }, () => {})
    },
    closeDialog () {
      this.dialogopenwebsite = false
    },
    add_image_albums () {
      this.dialogAddImage = true
      this.rightclickdialog = false
    },
    secondsToHms(d) {
      d = Number(d)
      var hours = Math.floor(d / 3600)
      var minutes = Math.floor((d - (hours * 3600)) / 60)
      var seconds = d - (hours * 3600) - (minutes * 60)
      var time = ''

      if (hours !== 0) {
        time = hours + ':'
      }
      if (minutes !== 0 || time !== '') {
        minutes = (minutes < 10 && time !== '') ? '0' + minutes : String(minutes)
        time += minutes + ':'
      }
      if (time === '') {
        time = seconds + 's'
      } else {
        time += (seconds < 10) ? '0' + seconds : String(seconds)
      }
      return time
    },
    checktypeCall (call) {
      if (call === 'cancel') {
        return this.$t('AnswerQuestion.cancel')
      } else if (call === 'decline') {
        return this.$t('LeftSide.chat.call.missed')
      } else if (call === 'end') {
        return this.$t('LeftSide.chat.call.end')
      } else {
        return ''
      }
    },
    RightClickDialog ($event, list, item) {
      this.ListMenuRightClick = []
      if (this.statemember === 'active') {
        if (list.includes("albums")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.addImageAlbum'), methods:'add_albums'})
        }
        if (list.includes("mention")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.mention'), methods:'mention'})
        }
        if (list.includes("sendmail")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.sendmail'), methods:'sendmail'})
        }
        if (list.includes("cancel")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.cancelMsg'), methods:'cancel'})
        }
        if (list.includes("announce")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.announce'), methods:'announce'})
        }
        if (list.includes("cancel_announce")) {
          this.ListMenuRightClick.push({message: this.$t('ChatSide.RightClickMenu.cancelAnnounce'), methods:'cancel_announce'})
        }
        this.rightclickdialog = true
        this.$refs.menu.open($event)
        this.SelectedMessageDetail = item
      }
    },
    SelectMenuRightClick (selected) {
      // console.log(selected)
      if (selected == 'add_albums') {
        this.add_image_albums()
      } else if (selected == 'mention') {
        this.mention_message()
      } else if (selected == 'cancel') {
        this.unsendmessage()
      } else if (selected == 'sendmail') {
         this.sendemail()
      } else if (selected == 'announce') {
        this.announce_msg()
      } else if (selected == 'cancel_announce') {
        this.cancel_announce()
      }
    },
    sendemail () {
      this.dialogCreatemail = true
    },
    closeCreatemail (value) {
      this.dialogCreatemail = value
    },
    mention_message() {
      if (this.statemember === 'active') {
        this.rightclickdialog = false
        this.showmention = true
        if (this.SelectedMessageDetail.path_pic === '') {
          if (this.SelectedMessageDetail.type === 'business') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/business-white.png'
          } else if (this.SelectedMessageDetail.type === 'bot') {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/bot-white.png'
          } else {
            this.SelectedMessageDetail.path_pic = '/static/img/default_profile/man-white.png'
          }
        }
      }
    },
    unsendmessage() {
      this.rightclickdialog = false
      this.$swal({
        text: this.$t('Alert.Chat.unsent'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#2562af',
        cancelButtonColor: '#9f9f9f',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.axios.post(process.env.APIimage + '/delete_message', {
            tokenuser: this.token,
            tokenmessage: this.SelectedMessageDetail.tokenmessage
          }).then((response) => {
            if (response.data['status'] === 'success') {
              this.$swal(
                '',
                this.$t('Alert.Success.unsent'),
                'success'
              )
            }
          })
        }
      })
    },
    backCall_conference_msg (detail) {
      window.open(detail.urlroom)
    },
    joinCall_conference_msg (detail) {
      // console.log(detail)
      this.axios.post(process.env.APIimage + '/join_room_conference', {
        meetingid: detail.meetingid,
        name: localStorage.getItem('name'),
        option: detail.option,
        key: detail.key
      }).then((response) => {
        if (response.data['status'] === 'success') {
          window.open(response.data.data.urlroom)
        }
      })
    },
    openapprove(item) {
      this.ApproveDetail = item
      this.dialogApprove = true
    },
    checkBrowser (url, item) {
      // console.log(item)
      if (_.includes(url, 'https://chat.one.th/qrcode/friend?id=')) {
        var link = _.split(url, '?id=', 2)
        // console.log(link[1])
        // console.log(atob(link[1]))
        this.detailFriend(atob(link[1]))
      } else {
        // Get the user-agent string
        let userAgentString = navigator.userAgent;
        // Detect Chrome
        let chromeAgent = userAgentString.indexOf("Chrome") > -1;
        // Detect Internet Explorer
        let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
        // Detect Firefox
        let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
        // Detect Safari
        let safariAgent = userAgentString.indexOf("Safari") > -1;
        // Discard Safari since it also matches Chrome
        let operaAgent = userAgentString.indexOf("OP") > -1;
        // console.log('firefox = > ' + firefoxAgent)
        // console.log('ie = > ' + IExplorerAgent)
        // console.log('chrome = > ' + chromeAgent)
        // console.log('opera = > ' + operaAgent)
        // console.log('safari = > ' + safariAgent)
         if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
           if (item.payload !== undefined) {
             if (item.payload.news_id !== undefined) {
               this.checkBrowserInfor = {
                 url: url,
                 payload: item.payload
               }
             } else {
               this.checkBrowserInfor = {
                 url: url
               }
             }
           } else {
             this.checkBrowserInfor = {
               url: url,
               payload: ''
             }
           }
          this.checkBrowserDialog = true
         } else if (safariAgent === true && chromeAgent === true) {
             console.log('savelog')
             window.open(url, '_blank')
             if (item.payload.news_id !== undefined) {
               this.saveLogNews(item)
             }
         } else if (safariAgent === true) {
           // this.checkBrowserInfor =
           if (item.payload !== undefined) {
             if (item.payload.news_id !== undefined) {
               this.checkBrowserInfor = {
                 url: url,
                 payload: item.payload
               }
             } else {
               this.checkBrowserInfor = {
                 url: url
               }
             }
           } else {
             this.checkBrowserInfor = {
               url: url,
               payload: ''
             }
           }
           this.checkBrowserDialog = true
        } else {
          console.log('savelog')
          window.open(url, '_blank')
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item)
          }
        }
      }
    },
    check_get_accesstoken (item) {
      // console.log(item)
      if (item.sign === 'true') {
        var body = {
         "tokenuser": this.token,
         "url": item.url
        }
        this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
          // console.log(response.data)
          if (response.data.data) {
            var new_url = response.data.data.url
            if (item.type === 'link') {
              // item.url = response.data.data.url
              // window.open(new_url, '_blank')
              this.checkBrowser(new_url, item)
            } else if (item.type === 'webview') {
              this.Webview_item = {
                label: item.label,
                url: new_url,
                size: item.size,
                type: item.type
              }
              this.dialogWebviewbig = true
              if (item.payload.news_id !== undefined) {
                this.saveLogNews(item)
              }
            }
          } else {
            this.dialogLogin = true
          }
        }, (error) => {
          console.log(error)
        })
      } else if (item.onechat_token === 'true') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        // console.log(expireddate)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate


        if (item.type === 'link') {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item)
          }
        }
      } else {
        if (item.type === 'link') {
          // window.open(item.url, '_blank')
          // console.log('Carousel')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
          // check payload news
          if (item.payload.news_id !== undefined) {
            this.saveLogNews(item)
          }
        }
      }
    },
    openlink_market (item) {
      var message = {
        message: '',
        payload: ''
      }
      if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        this.ans_quickreply(message, 'link_market')
        // this.clearQuickreply()
      }
    },
    openlink (item) {
      var message = {
        message: '',
        payload: ''
      }
      this.ans_quickreply(message, 'link')
      this.check_get_accesstoken(item)
    },
    openwebview (item) {
      // console.log(item)
      // console.log('openwebview')
      var message = {
        message: '',
        payload: ''
      }
      // this.Webview_item = item
      // this.dialogWebviewbig = true
      this.ans_quickreply(message, 'webview')
      this.check_get_accesstoken(item)
    },
    sendansApprove(item, tokenmessage) {
      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
      }
      var indexid = _.findIndex(this.items, function(o) {
        return o.tokenmessage === tokenmessage && o.typeofmessage === 'approve_message'
      })
      this.items[indexid].disable = 'true'
      this.axios.post(process.env.APIimage + '/answer_approve', body).then((response) => {
        // console.log(response.data)
        if (_.find(this.items, function(o) {
            return o.tokenmessage === response.data.data.tokenmessage
          }) === undefined) {
          this.items.push(response.data.data)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
        }
        setTimeout(this.scrollDown, 1)
      }, () => {})
    },
    ans_quickreply (item, type) {
      var body = {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        type_reply: type,
        message: item.message,
        info_data: item.payload
      }
      this.axios.post(process.env.APIalpine + '/api/v1/answer_quickreply', body).then((response) => {
        // console.log(response.data.data)
        if (_.find(this.items, function(o) {
            return o.tokenmessage === response.data.tokenmessage
          }) === undefined) {
          if(response.data.data !== undefined) {
            this.items.push(response.data.data)
          }
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
        }
        setTimeout(this.scrollDown, 1)
      }, () => {})
    },
    selectfile_quickreply (item) {
      if (item.type == 'image') {
        $('#uploadpic_quickreply').click()
      } else {
        $('#uploadfile_quickreply').click()
      }
      this.itemdetail_quickreply = item
    },
    sendlocation_quickreply () {
      // console.log(navigator.geolocation)
      if (window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition((position) => {
          // console.log(position.coords.latitude, position.coords.longitude)
          this.send_location(position.coords.latitude, position.coords.longitude, '')
        })
      } else {
        console.log('error geo')
      }
    },
    btn_answer_question (item, tokenmessage) {
      // console.log(item)
      this.ans_question(item, tokenmessage)
      if (item.type === 'link' || item.type === 'webview') {
        this.check_get_accesstoken(item)
      } else if (item.type === 'file') {
        this.downloadFileMenu(item)
      } else if (item.type === 'link_market') {
        this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
      } else if (item.type === 'ekyc') {
        this.ans_ekyc_template(item)
      }
    },
    btn_official_template (item, tokenuserBot, tokenmessage) {
      // console.log(item)
      // if (item.type === 'link') {
      //   window.open(item.url, '_blank')
      // } else if (item.type === 'webview') {
      //   this.Webview_item = item
      //   this.dialogWebviewbig = true
      // }
      if (item.sign == 'true' && item.type !== 'text') {
        this.getSign(item.url, item, tokenuserBot)
      } else if (item.onechat_token === 'true' && item.type !== 'text') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)

        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
        } else if (item.type === 'text') {
          this.ans_question(item, tokenmessage)
        } else if (item.type === 'file') {
          this.ans_question(item, tokenmessage)
          this.downloadFileMenu(item)
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }
    },
    btn_img_official_template (item, tokenuserBot) {
      // console.log(item)
      if (item.sign === 'true') {
        this.getSignImg(item.url, item, tokenuserBot)
      } else if (item.onechat_token === 'true') {
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var hour = String(today.getHours() + 1).padStart(2, '0')
        var minute = String(today.getMinutes()).padStart(2, '0')
        var seconds = String(today.getSeconds()).padStart(2, '0')
        var milsec = today.getMilliseconds()
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        // เช็คเวลาช่วงเที่ยงคืน ให้บวกค่าวันไปด้วย
        if (hour === '24') {
          hour = '00'
          dd = String(today.getDate() + 1).padStart(2, '0')
          var date_of_month = new Date(yyyy, mm + 1, 0).getDate()
          // เช็ควันที่บวกว่าเป็นวันสุดท้ายของเดือน?
          if (parseInt(dd) === date_of_month) {
            // ถ้าเป็นวันสุดท้ายของเดือนในเซตวันเป็นวันที่ 1
            dd = '1'
            // เช็คเดือนว่าเป็นเดือนสุดท้ายของปี?
            if (mm === '12') {
              // ถ้าเป็นเดือนสุดท้ายในเซตเป็นเดือน 1แล้วก็บวกปีเพิ่ม
              mm = '1'
              yyyy = today.getFullYear() + 1
            } else {
              // ไม่ใช่เดือนสุดท้ายก็บวกเดือนเพิ่มมา 1 เดือน (+2 เพราะว่าเดือนมันเริ่มที่ 0 getMonth ล่่าสุดมาแล้ว คือ +1 แล้วบวกไปอีก 1 เลยเป็น +2)
              mm = String(today.getMonth() + 2).padStart(2, '0')
              // console.log(mm)
            }
          }
        }
        today = yyyy + '-' + mm + '-' + dd + 'T' + hour + ':' + minute + ':' + seconds + '.' + milsec + 'Z'
        // console.log(today)
        var expireddate = Date.parse(today)
        var body = Encode.encodeRichmenu({ 'userid': this.token, 'expired_date': expireddate })
        // var url = '?onechat_token=' + body + '&' + 'expired_date=' + expireddate
        // var weburl = item.url + url
        var url = ''
        if (_.includes(item.url, ['?'])) {
          url = '&'
        } else {
          url = '?'
        }
        var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate

        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(weburl, '_blank')
          this.checkBrowser(weburl, item)
        } else if (item.type === 'webview') {
          this.Webview_item = {
            label: item.label,
            url: weburl,
            size: item.size,
            type: item.type
          }
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      } else {
        if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
          // window.open(item.url, '_blank')
          this.checkBrowser(item.url, item)
        } else if (item.type === 'webview') {
          this.Webview_item = item
          this.dialogWebviewbig = true
        } else if (item.type === 'link_market') {
          this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
        }
      }
    },
    getSignImg (url, item, tokenuserBot) {
      var body = {
       "tokenuser": this.token,
       "url": url
      }
      this.axios.post(process.env.APIpub + '/old/api/v1/getAccesstoken', body).then((response) => {
        if (response.data.data) {
          var new_url = ''
          // console.log(response.data.data)
          new_url = response.data.data.url
          // console.log(response.data.data.url)
          if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
            // window.open(new_url, '_blank')
            this.checkBrowser(new_url, item)
          } else if (item.type === 'webview') {
            this.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            }
            this.dialogWebviewbig = true
          } else if (item.type === 'link_market') {
            this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
          }
        } else {
          this.dialogLogin = true
        }
      }, () => {})
    },
    getSign (url,item, tokenuserBot) {
      // console.log('getSign')
      var body = {
       "tokenuser": this.token,
       "url": url
      }
      // console.log(tokenuserBot)
      this.axios.post(process.env.APInew_getaccesstoken, body).then((response) => {
        // console.log(response.data.data)
        if (response.data.data) {
          var new_url = ''
          new_url = response.data.data.url
          if (item.type === 'link' || (item.type === 'webview' && tokenuserBot === process.env.Bot_idPaperless)) {
            // window.open(new_url, '_blank')
            this.checkBrowser(new_url, item)
          } else if (item.type === 'webview') {
            this.Webview_item = {
              label: item.label,
              url: new_url,
              size: item.size,
              type: item.type
            }
            this.dialogWebviewbig = true
          } else if (item.type === 'link_market') {
            this.$swal('', this.$t('Alert.Warning.link_market'), 'warning')
          }
        } else {
          this.dialogLogin = true
        }
      }, () => {})
    },
    downloadFileMenu(item) {
      var name = item.file.split('/')[item.file.split('/').length - 1]
      this.axios.get(item.file, {
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', name)
        document.body.appendChild(link)
        link.click()
      })
    },
    ans_question(item, tokenmessage) {
      if (item.payload === undefined) {
        item.payload = ''
      }
      var body = {
        tokenmessage: tokenmessage,
        tokenuser: this.token,
        answer: item
      }
      // console.log(item)
      this.axios.post(process.env.APIimage + '/answer_question', body).then((response) => {
        // console.log(response.data)
        if (item.type === 'text') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
          }
          setTimeout(this.scrollDown, 1)
        }
      }).catch(error => {
        console.log(error)
      })
    },
    handleConnectivityChange(status) {
      this.online = status
    },
    initmapShow() {
      this.map = new longdo.Map({
        placeholder: document.getElementById('map'),
        lastView: true
      })
      this.map.Ui.Keyboard.enable(true)
      var control3 = new longdo.TagPanel()
      this.map.Ui.add(control3)
      // this.map.Ui.Crosshair.visible(false)
      this.map.Ui.LayerSelector.visible(false)
      var location = this.locationName.message.split(',')
      var marker = new longdo.Marker({
        lat: location[0],
        lon: location[1]
      }, {
        icon: {
          url: '../../../../static/img/icons/pin.png',
          offset: {
            x: this.x,
            y: this.y
          }
        },
        clickable: true
      })
      this.map.Overlays.add(marker)
      // this.GeometryOptions()
      // console.log(parseFloat(location[0]) - 1)
      // console.log(parseFloat(location[0]) + 1)
      this.map.bound({
        minLon: parseFloat(location[0]) - 1,
        minLat: parseFloat(location[1]) - 1,
        maxLon: parseFloat(location[0]) + 1,
        maxLat: parseFloat(location[1]) + 1
      }, {
        lat: location[0],
        lon: location[1]
      })
      // this.showloc = this.map.bound()
      this.map.zoom(15, true)
      // longdo.Search(this.map, true)
    },
    openlocation(item) {
      // console.log(item)
      this.center_markermap = {
        lat: parseFloat(item.message.split(',')[0]),
        lng: parseFloat(item.message.split(',')[1])
      }
      this.sheetother = false
      this.dialogMap = true
      this.locationName = item
    },
    openmap() {
      this.sheetother = false
      // this.dialogMap = true
      this.dialogSendMap = true
    },
    senddate() {
      // var _ = require('lodash')
      if (this.typepicker === 'datepicker') {
        // api
        this.datepicker = false
        this.$swal({
          title: this.$t('Alert.Chat.sendDatetime'),
          html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + '</div>',
          confirmButtonColor: '#3085d6',
          confirmButtonText: this.$t('AnswerQuestion.ok'),
          cancelButtonColor: '#d33',
          cancelButtonText: this.$t('AnswerQuestion.cancel'),
          buttonsStyling: true,
          showCloseButton: true,
          showCancelButton: true,
          reverseButtons: true
        }).then((result) => {
          if (result.value) {
            var item = {
              message: this.dateselect,
              payload: this.infodata
            }
            this.ans_quickreply(item, 'datepicker')
          }
        })
      } else if (this.typepicker === 'datetimepicker') {
        this.datepicker = false
        this.timepicker = true
        if (this.dateselect === this.mindate) {
          this.maxtime = '24:00'
        } else if (this.dateselect === this.maxdate) {
          this.mintime = '00:00'
        } else {
          this.maxtime = '24:00'
          this.mintime = '00:00'
        }
      }
    },
    sendtime() {
      this.$swal({
        title: this.$t('Alert.Chat.sendDatetime'),
        html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.dateselect) + ' เวลา ' + this.timeselect + '</div>',
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        buttonsStyling: true,
        showCloseButton: true,
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          var item = {
            message: this.dateselect + 'T' + this.timeselect,
            payload: this.infodata
          }
          this.timepicker = false
          this.ans_quickreply(item, 'datetimepicker')
        }
      })
    },
    setpicker(data) {
      // console.log(data)
      setTimeout(this.scrollDown, 1)
      if (data.type === 'datepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max
        this.mindate = data.min
        this.dateselect = data.initial
        this.infodata = data.payload
      } else if (data.type === 'datetimepicker') {
        this.typepicker = data.type
        this.datepicker = true
        this.maxdate = data.max.split('T')[0]
        this.mindate = data.min.split('T')[0]
        this.maxtime = data.max.split('T')[1]
        this.mintime = data.min.split('T')[1]
        this.dateselect = data.initial.split('T')[0]
        this.timeselect = data.initial.split('T')[1]
        this.infodata = data.payload
      }
    },
    getreply() {
      this.datepicker = false
      this.timepicker = false
      this.maxdate = ''
      this.mindate = ''
      this.maxtime = ''
      this.mintime = ''
      this.dateselect = ''
      this.timeselect = ''
      this.infodata = ''
      this.axios.post(process.env.APIalpine + '/api/v1/get-quickreply', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.Quickreply = response.data.data
          setTimeout(this.scrollDown, 1)
          // console.log(this.Quickreply)
        }
      })
    },
    momentday(data) {
      return Momenttime.momentdatetimethai(data)
    },
    checkShowmessagwBottom(data) {
      var scroll = this.$el.querySelector('#myscroll')
      if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
        setTimeout(this.scrollDown, 1)
      } else {
        this.showmessagebottom = true
        this.chip = true
        this.picturechip = data.path_pic
        if (data.typeofmessage !== 'message') {
          // this.showmessage = data.nickname + ': Send ' + data.typeofmessage + ' to you'
          this.showmessage = 'Send ' + data.typeofmessage + ' to you'
        } else {
          // this.showmessage = data.nickname + ':  ' + data.message
          this.showmessage = data.message
        }
        // setTimeout(this.scrollDown, 1)
      }
    },
    lookmessage() {
      this.chip = false
      this.showmessagebottom = false
      setTimeout(this.scrollDown, 1)
    },
    scrollFunction() {
      this.$refs.menu.close()
      var scroll = this.$el.querySelector('#myscroll')
      // console.log(scroll.scrollTop)
      // console.log(scroll.scrollHeight)
      if (scroll.scrollTop == 0 && this.progressLoadChat == false) {
        this.getOldMessage(this.items[0].timestamp)
      }
      // console.log(scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0)))
      if (scroll.scrollTop >= ((scroll.scrollHeight - this.box_height - 70.0))) {
        // เห็นข้อความแล้ว ไม่ต้องทำอะไร
        // setTimeout(this.scrollDown, 1)
        this.chip = false
        this.showmessagebottom = false
      }
    },
    chsheetother() {
      // console.log(this.sheetother + '   ch')
      // this.sheetother = !this.sheetother
      if ($('#menu-chat').is(":visible")) {
        this.sheetother = false
        // $('#menu-chat').fadeOut(1600);
        // this.sheetother = false
      } else {
        this.sheetother = true
        // $('#menu-chat').fadeOut(1600);
      }
    },
    chsheetsticker() {
      this.sheetsticker = !this.sheetsticker
    },
    changelink(path) {
      return path
    },
    pushSticker(stickerid) {
      this.axios.post(process.env.APIimage + '/push_sticker', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        message: stickerid,
        type: this.typeuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            var stickerSend = response.data.data
            stickerSend['status'] = 'success'
            this.items.push(stickerSend)
            this.clearQuickreply()
          }
          this.sheetsticker = false
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
          setTimeout(this.scrollDown, 1)
        }
      })
    },
    extension (path) {
      var extension = path.split('.')[path.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['ai', 'gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'ps', 'psd', 'svg', 'tif', 'tiff']
      var media = ['mpg', 'mpeg', 'avi', 'wmv', 'mov', 'rm', 'ram', 'swf', 'flv', 'ogg', 'webm', 'mp4', 'divx', 'dat']
      var audio = ['mp3', 'wma', 'aac', 'ogg', 'm4a', 'wav', 'cda', 'flac', 'aiff', 'caf']
      if (pdf.includes(extension)) {
        return 'pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (media.includes(extension)) {
        return 'media'
      } else if (audio.includes(extension)) {
        return 'audio'
      } else {
        return 'fas fa-file-alt'
      }
    },
    pushcontact(item) {
      if (item.status === 'success') {
        if (_.find(this.items, function(o) {
            return o.tokenmessage === item.data.tokenmessage
          }) === undefined) {
          this.items.push(item.data)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
          setTimeout(this.scrollDown, 1)
        }
      } else {
        this.items.push({
          tokenuser: this.token,
          message: item.data.tokenuser,
          tokenroom: this.$route.params.roomid,
          typeofmessage: 'contact',
          timestamp: Momenttime.momenttimestamp(),
          tokenmessage: btoa(Momenttime.momenttimestamp()),
          path_pic: this.profile,
          nickname: '',
          file_name: '',
          nickname_contact: item.data.name,
          pic_contact: item.data.profilepicture,
          type_contact: item.data.type,
          status: 'no'
        })
      }
    },
    detailFriend (user) {
      // console.log(user)
      this.id = user
      this.type = 'friend'
      this.dialogopenwebsite = true
    },
    chat (tokenroom) {
      this.$router.push('/chat/room/' + tokenroom)
    },
    AcceptReq (tokenFriend) {
      this.axios.post(process.env.APInew_acceptfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'friend'
        }
      })
    },
    RemoveReq (tokenFriend) {
      this.axios.post(process.env.APImanage + '/removerequestfriend', {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.relation = 'unknown'
        }
      })
    },
    AddFriend (tokenFriend) {
      this.axios.post(process.env.APInew_addfriend, {
        tokenfriend: tokenFriend,
        tokenuser: this.token
      }).then((response) => {
        if (response.data['status'] === 'success') {
          this.$store.dispatch('sendRequest', tokenFriend)
        } else {
          alert('Error!!!')
        }
      })
    },
    unblock (tokenFriend) {
      this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {
        tokenuser: this.token
      }).then((response) => {
        var room = response.data['listBlockFriend'][this.findWithAttr(response.data['listBlockFriend'], 'tokenuser', tokenFriend)]['tokenroom']
        this.axios.post(process.env.APImanage + '/unblockfriend', {
          tokenfriend: tokenFriend,
          tokenuser: this.token,
          tokenroom: room
        }).then((response) => {
          if (response.data['status'] === 'success') {
            this.$swal(
              'Unblocked!',
              this.$t('Alert.Success.unblock'),
              'success'
            )
            this.relation = 'friend'
            this.axios.post(process.env.APImanage + '/web/getlistblockfriend', {
              tokenuser: this.token
            }).then((response) => {
              this.$store.dispatch('listFriend', 'listBlockFriend' + tokenFriend)
            })
          }
        })
      })
    },
    findWithAttr(array, attr, value) {
      for (var i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
          return i
        }
      }
      return -1
    },
    append (emoji) {
      // console.log(emoji)
      this.sendmsg += emoji
    },
    forword () {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1
      }
    },
    back () {
      if (this.currentPage !== 1) {
        this.currentPage = this.currentPage - 1
      }
    },
    other_noti (group, title, msg, pic) {
      if (Notification.permission === 'granted') {
        var notification = new Notification(title, {
          body: msg,
          icon: pic,
          silent: true
        })
        notification.onclick = function() {}
      } else {
        Notification.requestPermission().then(function(result) {
          // console.log(result)
        })
      }
    },
    ocropen (item) {
      $('#uploadpic_ocr').click()
      this.ocr_detailItem = item
    },
    uppic () {
      $('#uploadpic').click()
    },
    upfile () {
      $('#uploadfileChat').click()
      this.sheetother = false
    },
    pasteIntoInput (el, text) {
      el.focus()
      if (typeof el.selectionStart === 'number' && typeof el.selectionEnd === 'number') {
        var val = el.value
        var selStart = el.selectionStart
        el.value = val.slice(0, selStart) + text + val.slice(el.selectionEnd)
        el.selectionEnd = el.selectionStart = selStart + text.length
      } else if (typeof document.selection !== 'undefined') {
        var textRange = document.selection.createRange()
        textRange.text = text
        textRange.collapse(false)
        textRange.select()
      }
    },
    closemodal () {
      var myModalMap = document.getElementById('myModalMap')
      myModalMap.style.display = 'none'
    },
    zoomfile (file, state) {
      if (state) {
        this.DetailFile = file
        this.dialogshowfile = state
      } else {
        this.axios.get(file.message, {
          responseType: 'blob'
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', file.file_name)
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    zoom (image) {
      image['path'] = image['message']
      image['file_owner'] = image['nickname']
      image['typeuser'] = image['type']
      image['pic_pro'] = image['path_pic']
      this.DetailImage = image
      this.dialogshowimage = true
    },
    closeDialogShowFile (value) {
      this.dialogshowfile = value
      this.DetailFile = {}
    },
    closeDialogShowImage (value) {
      this.dialogshowimage = value
    },
    // sendimgonebox (tokenmessage) {
    //   this.axios.post(process.env.APIpub + '/save_onebox2', {
    //     tokenmessage: tokenmessage,
    //     tokenuser: this.token
    //   }).then((response) => {
    //     console.log(response.data)
    //     if (response.data['status'] === 'success') {
    //       this.$swal(
    //         this.$t('Alert.Success.sending'),
    //         this.$t('Alert.Success.sendFile'),
    //         'success'
    //       )
    //     }
    //   })
    // },
    sendimgonebox (tokenmessage) {
      this.dialogSaveOnebox = true
      this.tokenmessage_savebox = tokenmessage
    },
    closeSaveOnebox (value) {
      this.dialogSaveOnebox = false
    },
    scrollMaxOldSet () {
      this.scrollMaxOld = 0
    },
    scrollDown () {
      var container = this.$el.querySelector('#myscroll')
      container.scrollTop = container.scrollHeight
      this.scrollval = container.scrollTop
    },
    loadchathistory() {
      this.progressLoadChat = true
      this.temp = this.selectedForward
      this.selectedForward = []
      this.getOldMessage(this.items[0].timestamp)
    },
    getOldMessage(time) {
      this.progressLoadChat = true
      if (time === '') {
        this.progressLoadChatBox = true
      }
      this.axios.post(process.env.APInew_getdict, {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        time_in: time
      }).then((response) => {
        // this.tokenuser_friend = Decode.decodeToken(this.$cookie.get('tokenuser_friend'))
        // this.get_list_richmenu(this.$route.params.roomid)
        this.progressLoadChat = false
        this.progressLoadChatBox = false
        if (response.data['status'] === 'success') {
          // console.log(response.data)
          this.statemember = response.data.state_member
          this.items.unshift.apply(this.items, response.data['data'].reverse())
          if (response.data.data.length === 20) {
            this.statusload = true
          } else if (response.data.data.length < 20) {
            this.statusload = false
          }
          this.selectedForward = this.temp
          // setTimeout(this.scrollDown, 1)
          if (time === '') {
            setTimeout(this.scrollDown, 1)
          } else {
            var container = this.$el.querySelector('#myscroll')
            this.scrollval = container.scrollTop
            if (this.scrollval < 20) {
              var scrollMaxNew = container.scrollHeight
              container.scrollTop = scrollMaxNew - this.scrollMaxOld
              this.scrollMaxOld = scrollMaxNew
              this.scrollval = container.scrollTop
            }
          }
        } else {
          if (response.data.message === 'not member.') {
            this.$router.push('/chat/not_permission')
          }
        }
      }).catch((error) => {
        this.progressLoadChat = false
        this.progressLoadChatBox = false
        if (error.response.data.message === 'Tokenroom not found.') {
          this.$router.push('/chat/not_found')
        }
      })
    },
    get_list_richmenu (bot_id) {
      // console.log(typeroom)
      // if (typeroom !== 'group') {
      this.list_richmenu = []
      this.inforrichmenu = {}
      this.axios.post(process.env.APIgo_api + '/v1/get-richmenu-by-botid', { bot_id: bot_id }).then((response) => {
        // console.log(response.data.data)
        if (response.data.status === 'success') {
          this.list_richmenu = response.data.data.list_menu
          this.type_richmenu = parseInt(response.data.data.type_menu)
          this.inforrichmenu = response.data.data.list_menu
          this.richmenu_label = response.data.data.menu_label
          this.bot_id_richmenu = response.data.data.bot_id
          this.default_behavior = parseInt(response.data.data.default_behavior)
          if (this.default_behavior === 1) {
            this.RichmenuState = true
            this.sheetrichmenu = true
            this.RichmenuState_first = true
          } else {
            this.RichmenuState = false
            this.sheetrichmenu = false
            this.RichmenuState_first = false
          }
          // console.log(this.type_richmenu)
          // console.log(this.inforrichmenu)
        } else {
          // console.log(response.data)
          this.list_richmenu = []
        }
      }).catch((error) => {
        console.log(error)
      })
      // }
    },
    isBlank(str) {
      return (!str || /^\s*$/.test(str))
    },
    isEmpty(str) {
      return (!str || str.length === 0)
    },
    dateMoment(data) {
      return Momenttime.momentdatethai(data)
    },
    timeMoment(data) {
      return Momenttime.momenttimethai(data)
    },
    resendMessage(data) {
      _.remove(this.items, function(n) {
        return n.tokenmessage === data.tokenmessage
      })
      this.sendMessage(data.message)
    },
    resendContact(data) {
      _.remove(this.items, function(n) {
        return n.tokenmessage === data.tokenmessage
      })
      this.sendContact(data)
    },
    sendContact(data) {
      this.axios.post(process.env.APIimage + '/push_contact', {
        tokenroom: this.$route.params.roomid,
        tokenuser: this.token,
        tokencontact: data.message,
        type: this.typeuser
      }).then((response) => {
        if (response.data['status'] === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.tokenmessage
            }) === undefined) {
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
            setTimeout(this.scrollDown, 1)
          }
          this.$swal('', this.$t('Alert.Success.account'), 'success')
        } else {
          this.items.push({
            tokenuser: this.token,
            message: data.tokenuser,
            tokenroom: this.$route.params.roomid,
            typeofmessage: 'contact',
            timestamp: Momenttime.momenttimestamp(),
            tokenmessage: btoa(Momenttime.momenttimestamp()),
            path_pic: this.profile,
            nickname: '',
            file_name: '',
            nickname_contact: data.name,
            pic_contact: data.profilepicture,
            type_contact: data.type,
            status: 'no'
          })
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        }
      }, () => {
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    sendMessage (data) {
      // console.log(data)
      this.status_tag = false
      var index = 0
      for (index in this.files) {
        this.pushfile(this.files[index].file, this.files[index].name)
        if (index == (this.files.length - 1)) {
          this.files = []
          this.sendmsg = ''
        }
      }
      if (this.showmention === false) {
        try {
          if (!this.isBlank(data) && !this.isEmpty(data)) {
            // this.sendmsg = ''
            if (this.typeroom === 'group') {
              var result
              this.listfriend.map((item) => {
                // const condition = `^@${item.name}|\\s@${item.name}`
                // const regex = new RegExp(condition, "g")
                // var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
                var pattern3 = /\B@([^\u0000-\u007F]|[\a-zA-Z])+/gi
                result = data.match(pattern3)
              })
              // console.log(result)
              if(result){
                var test2 = []
                for(var i=0; i< result.length ; i++){
                  // console.log(result[i])
                  const test = this.listfriend.find(person =>
                    person.name.includes(result[i].substring(1)))
                  test2.push(test)
                  // console.log(test2)
                }
                // console.log(test2[0])
                for(var j=0 ; j<test2.length; j++){
                  if (test2[j] !== undefined) {
                    data = data.replace(('@'+ test2[j].name), '<tax>'+test2[j].tokenuser+'</tax>')
                  }
                }
              }
            }
            // console.log(data)
            this.axios.post(process.env.APInew_pushmessage, {
              tokenroom: this.$route.params.roomid,
              tokenuser: this.token,
              type: this.typeuser,
              message: data.trim()
            }).then((response) => {
              // console.log(response)
              var messageSendChat = response.data.data
              if (response.data.status === 'success') {
                messageSendChat['status'] = 'success'
                if (_.find(this.items, function(o) {
                    return o.tokenmessage === messageSendChat.tokenmessage
                  }) === undefined) {
                  this.items.push(messageSendChat)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                }
                setTimeout(this.scrollDown, 1)
                this.sendmsg = ''
              } else {
                this.items.push({
                  tokenuser: this.token,
                  message: data,
                  tokenroom: this.$route.params.roomid,
                  typeofmessage: 'message',
                  timestamp: Momenttime.momenttimestamp(),
                  tokenmessage: btoa(Momenttime.momenttimestamp()),
                  path_pic: this.profile,
                  nickname: '',
                  file_name: '',
                  status: 'no'
                })
                this.sendmsg = ''
              }
            }, (error) => {
              this.items.push({
                tokenuser: this.token,
                message: data,
                tokenroom: this.$route.params.roomid,
                typeofmessage: 'message',
                timestamp: Momenttime.momenttimestamp(),
                tokenmessage: btoa(Momenttime.momenttimestamp()),
                path_pic: this.profile,
                nickname: '',
                file_name: '',
                status: 'no'
              })
              this.sendmsg = ''
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
              console.log(error)
            })
          }
        } catch (e) {
          console.log(e)
        }
      } else {
        this.sendMessageMention(data)
      }
    },
    sendMessageMention(data) {
      this.showmention = false
      try {
        if (!this.isBlank(data) && !this.isEmpty(data)) {
          // var result
          // this.listfriend.map((item) => {
          //   var pattern3 = /\B@([\u0E00-\u0E7Fa-zA-Z'])+/gi
          //   result = data.match(pattern3)
          // })
          //   // console.log(result)
          // if(result !== null){
          //   var test2 = []
          //   for(var i=0; i< result.length ; i++){
          //     const test = this.listfriend.find(person =>
          //       person.name.includes(result[i].substring(1)))
          //       test2.push(test)
          //     }
          //     for(var j=0 ; j<test2.length; j++){
          //       data = data.replace(('@'+ test2[j].name), '<tax>'+test2[j].tokenuser+'</tax>')
          //     }
          //   }

            // console.log(data)
          this.axios.post(process.env.APIimage + '/mention_message', {
            tokenuser: this.token,
            tokenmessage: this.SelectedMessageDetail.tokenmessage,
            tokenroom: this.$route.params.roomid,
            mention_message: data
          }).then((response) => {
            var messageSendChat = response.data.data
            if (response.data.status === 'success') {
              messageSendChat['status'] = 'success'
              if (_.find(this.items, function(o) {
                  return o.tokenmessage === messageSendChat.tokenmessage
                }) === undefined) {
                this.items.push(messageSendChat)
                this.clearQuickreply()
                this.items = _.sortBy(this.items, function(dateObj) {
                  return new Date(dateObj.timestamp)
                })
                this.items = _.unionBy(this.items, 'tokenmessage')
              }
              setTimeout(this.scrollDown, 1)
              this.sendmsg = ''
            } else {
              this.items.push({
                tokenuser: this.token,
                message: data,
                tokenroom: this.$route.params.roomid,
                typeofmessage: 'mention_message',
                timestamp: Momenttime.momenttimestamp(),
                tokenmessage: btoa(Momenttime.momenttimestamp()),
                path_pic: this.profile,
                nickname: '',
                file_name: '',
                status: 'no'
              })
              this.sendmsg = ''
            }
          }, (error) => {
            this.items.push({
              tokenuser: this.token,
              message: data,
              tokenroom: this.$route.params.roomid,
              typeofmessage: 'mention_message',
              timestamp: Momenttime.momenttimestamp(),
              tokenmessage: btoa(Momenttime.momenttimestamp()),
              path_pic: this.profile,
              nickname: '',
              file_name: '',
              status: 'no'
            })
            this.sendmsg = ''
            this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            console.log(error)
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    checksen(data) {
      if (!this.isBlank(data) && !this.isEmpty(data)) {
        return true
      } else {
        return false
      }
    },
    clearQuickreply () {
      if (this.Quickreply.length !== 0) {
        // console.log('this.Quickreply')
        // console.log(this.Quickreply)
        // console.log(this.items[this.items.length - 1])
        if (this.Quickreply.timestamp < this.items[this.items.length - 1].timestamp) {
          this.Quickreply = []
        }
      }
    },
    getMessageSocket (data) {
      // console.log(data)
      // console.log(this.Quickreply)
      // console.log(this.items[this.items.length-1].timestamp)
      this.clearQuickreply()
      if (data.tokenroom === this.$route.params.roomid) {
        if (data.tokenuser !== this.token) {
          this.checkShowmessagwBottom(data)
        }
        if (_.find(this.items, function(o) {
            return o.tokenmessage === data.tokenmessage
          }) === undefined) {
          this.items.push(data)
          // console.log(this.items)
          this.clearQuickreply()
          this.items = _.sortBy(this.items, function(dateObj) {
            return new Date(dateObj.timestamp)
          })
          this.items = _.unionBy(this.items, 'tokenmessage')
          // console.log(this.items)
          // setTimeout(this.scrollDown, 1)
          if (data.typeofmessage === 'file') {
            this.socketupdate_file = data
          } else if (data.typeofmessage === 'image') {
            this.socketupdate_img = data
          }
          if (data.tokenuser !== this.token) {
            this.axios.post(process.env.APIalpine + '/api/v1/user-mark-read', {
              tokenuser: this.token,
              tokenroom: data.tokenroom
            }).then((response) => {})
          }
        }
      }
    },
    onScroll(e) {
      this.offsetTop = e.target.scrollTop
    },
    pushfile (file, filename) {
      var uploadFile = new FormData()
      uploadFile.append('file', file, filename)
      uploadFile.append('tokenroom', this.$route.params.roomid)
      uploadFile.append('tokenuser', this.token)
      uploadFile.append('type', this.typeuser)
      // this.headers = {headers: {'Authorization': this.tokenservice}}
      this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            this.socketupdate_img = response.data.data
            response.data.data.status = 'success'
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
            document.querySelector('#uploadpic').value = ''
            document.querySelector('#uploadfileChat').value = ''
          }
          setTimeout(this.scrollDown, 1)
        } else {}
      }, (error) => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    onimgSelected(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' })
      } else {
        for (let i = 0; i < uploadedFiles.length; i++) {
          if (data.target.files[i].type === 'image/jpeg' || data.target.files[i].type === 'image/png' || data.target.files[i].type === 'image/jpg') {
            this.selectFile = data.target.files[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) {
                    return o.tokenmessage === response.data.data.tokenmessage
                  }) === undefined) {
                  this.socketupdate_img = response.data.data
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadpic').value = ''
                  document.querySelector('#uploadfileChat').value = ''
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          } else {
            this.onFileSelected(data)
          }
        }
      }
    },
    onimgSelected_ocr(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      // console.log(this.ocr_detailItem)
      var me = this
      var reader = new FileReader();
      reader.readAsDataURL(data.target.files[0])
      reader.onloadend = function() {
        var body = {
          "tokenroom": me.$route.params.roomid,
          "tokenuser": me.token,
          "base64_image": reader.result,
          "multi_select": me.ocr_detailItem.multi_select
        }
        me.dialogWebviewbig_ocr = true
        // me.Webview_item = {url: "https://chat-develop.one.th/ocr_scantext?id=Ua4KAHvPEqd2wOXF28cD9", label: ''}

        me.axios.post('https://l.one.th/onechat-ocr/api/v1/send-ocr-image', body).then((response) => {
          // console.log(response.data.data.link)
          if (response.data.message === 'success') {
            // me.dialogWebviewbig = true
            me.Webview_item_ocr = {url: response.data.data.link, label: ''}
          }
        }, () => {
          me.$swal( 'ไม่สำเร็จ!', 'โปรดอัปโหลดรูปใหม่', 'warning' )
        })
      }
    },
    onimgSelected_quickreply(data) {
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenroom', this.$route.params.roomid)
      uploadFile.append('tokenuser', this.token)
      uploadFile.append('type_reply', this.itemdetail_quickreply.type)
      uploadFile.append('info_data', this.itemdetail_quickreply.payload)
      this.axios.post(process.env.APIalpine + '/api/v1/answer_quickreply', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          if (_.find(this.items, function(o) {
              return o.tokenmessage === response.data.data.tokenmessage
            }) === undefined) {
            // this.socketupdate_img = response.data.data
            // response.data.data.status = 'success'
            this.items.push(response.data.data)
            this.clearQuickreply()
            this.items = _.sortBy(this.items, function(dateObj) {
              return new Date(dateObj.timestamp)
            })
            this.items = _.unionBy(this.items, 'tokenmessage')
            document.querySelector('#uploadfile_quickreply').value = ''
            document.querySelector('#uploadpic_quickreply').value = ''
          }
          setTimeout(this.scrollDown, 1)
        } else {}
      }, (error) => {
        console.log(error)
        this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
      })
    },
    clearImage () {
      $('#uploadpic_ocr').val("")
      $('#uploadpic_quickreply').val("")
    },
    onFileSelected (data) {
      // console.log(data)
      // console.log(data.target.files)
      // console.log(this.extension(data.target.files))
      this.sheetother = false
      let uploadedFiles = data.target.files
      var lengthfile = uploadedFiles.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = uploadedFiles[i].size
      }
      // if (data.target.files.type === 'image/jpeg' || data.target.files.type === 'image/png' || data.target.files.type === 'image/jpg') {
      //   this.onimgSelected(data)
      // } else {
      if (_.sum(sizefile)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' })
      } else {
        for (let i = 0; i < uploadedFiles.length; i++) {
          if (uploadedFiles[i].type === 'image/jpeg' || uploadedFiles[i].type === 'image/png' || uploadedFiles[i].type === 'image/jpg') {
            var datas = []
            datas.push(uploadedFiles[i])
            this.onimgDrag(datas)
          } else if (this.extension(uploadedFiles[i].name) === 'media') {
            var file_video = []
            file_video.push(uploadedFiles[i])
            this.push_video(file_video)
          } else {
            this.selectFile = uploadedFiles[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_file', uploadFile).then((response) => {
              // console.log(response.data)
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) {
                    return o.tokenmessage === response.data.data.tokenmessage
                  }) === undefined) {
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadfileChat').value = ''
                  this.socketupdate_file = response.data.data
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          }
        }
        // }
      }
    },
    playvideo () {
      if (Hls.isSupported()) {
        var video2 = document.getElementById('livevideo');
        var hls = new Hls();
        hls.loadSource(video2.src); // GC GET VIDEO SRC
        hls.attachMedia(video2);
        hls.on(Hls.Events.MANIFEST_PARSED, function() {
          //video2.play();
        })
      }
    },
    push_video (data) {
      this.sheetother = false
      var lengthfile = data.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' })
      } else {
        for (let i = 0; i < data.length; i++) {
          // if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            this.axios.post(process.env.APInew_pushvideo, uploadFile).then((response) => {
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                  this.socketupdate_file = response.data.data
                  // console.log(response.data.data)
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadpic').value = ''
                  document.querySelector('#uploadfileChat').value = ''
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          // } else {
          // }
        }
      }
    },
    onimgDrag(data) {
      this.sheetother = false
      var lengthfile = data.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 100) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile100'), type: 'warning' })
      } else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
            // console.log('it image')
            this.selectFile = data[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_image', uploadFile).then((response) => {
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) { return o.tokenmessage === response.data.data.tokenmessage }) === undefined) {
                  this.socketupdate_img = response.data.data
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadpic').value = ''
                  document.querySelector('#uploadfileChat').value = ''
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          } else {
          }
        }
      }
    },
    onFileDrag(data) {
      this.sheetother = false
      var lengthfile = data.length
      var sizefile = []
      for (var i = 0; i < lengthfile; i++) {
        sizefile[i] = data[i].size
      }
      if (_.sum(sizefile)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Chat.maxSizeFile'), type: 'warning' })
      } else {
        for (let i = 0; i < data.length; i++) {
          if (data[i].type === 'image/jpeg' || data[i].type === 'image/png' || data[i].type === 'image/jpg') {
            var datas = []
            datas.push(data[i])
            this.onimgDrag(datas)
          } else {
            this.selectFile = data[i]
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenroom', this.$route.params.roomid)
            uploadFile.append('tokenuser', this.token)
            uploadFile.append('type', this.typeuser)
            this.axios.post(process.env.APIimage + '/push_file', uploadFile).then((response) => {
              if (response.data.status === 'success') {
                if (_.find(this.items, function(o) {
                    return o.tokenmessage === response.data.data.tokenmessage
                  }) === undefined) {
                  response.data.data.status = 'success'
                  this.items.push(response.data.data)
                  this.clearQuickreply()
                  this.items = _.sortBy(this.items, function(dateObj) {
                    return new Date(dateObj.timestamp)
                  })
                  this.items = _.unionBy(this.items, 'tokenmessage')
                  document.querySelector('#uploadfileChat').value = ''
                  this.socketupdate_file = response.data.data
                }
                setTimeout(this.scrollDown, 1)
              } else {}
            }, (error) => {
              console.log(error)
              this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
            })
          }
        }
        // }
      }
    },
    send_location(lat, long, address) {
      // console.log(lat, long, address)
      if (lat !== '' && long !== '') {
        this.axios.post(process.env.APIpub + '/push_map', {
          'tokenroom': this.$route.params.roomid,
          'tokenuser': this.token,
          'lat': lat + '',
          'long': long + '',
          'address': address
        }).then((response) => {
          // console.log(response.data)
          if (response.data.status === 'success') {
            if (_.find(this.items, function(o) {
                return o.tokenmessage === response.data.data.tokenmessage
              }) === undefined) {
              response.data.data.status = 'success'
              this.items.push(response.data.data)
              this.clearQuickreply()
              this.items = _.sortBy(this.items, function(dateObj) {
                return new Date(dateObj.timestamp)
              })
              this.items = _.unionBy(this.items, 'tokenmessage')
            }
            setTimeout(this.scrollDown, 1)
          } else {}
        }, (error) => {
          console.log(error)
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    closeNote(value) {
      this.dialogNote = value
    },
    closeAlbums(value) {
      this.dialogAlbums = value
    },
    closeDetailTask (value) {
      this.dialogDetailTask = value
    },
    closeAddImage (value) {
      this.dialogAddImage = value
    },
    closeApprove(value) {
      this.dialogApprove = value
    },
    closeAccount(value) {
      this.dialogAccount = value
    },
    closeSendMap(value) {
      this.dialogSendMap = value
    },
    closeLoginDialog (value) {
      this.dialogLogin = value
    },
    closeWebview(value) {
      // console.log("closeWebview")
      // console.log(value)
      this.Webview_item = {}
      this.dialogWebview = value
      this.dialogWebviewbig = value
      this.dialogWebviewbig_ocr = value
    },
    closeForward(value) {
      this.ForwardState = value
      this.dialogForward = value
      this.selectedForward = []
    },
    detailNote(id) {
      this.dialogNote = true
      this.note_id = id
    },
    detailAlbums(id) {
      // console.log(id)
      this.dialogAlbums = true
      this.albums_id = id
    },
    convertMention(msg){
      msg = msg.replace(/\<tax>/g,'<span style="color:#1976d2; cursor:pointer;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    convertMentionAnnounce(msg){
      msg = msg.replace(/\<tax>/g,'<span style="color:white;">@');
      msg = msg.replace(/<\/tax>/g,'</span>');
      // console.log(msg)
      return msg
    },
    convert(msg) {
      // var linkifyStr = require('linkifyjs/string')
      // var str = msg
      // var processedContent = linkifyStr(str)
      // processedContent = processedContent.replace('&lt;tax&gt;', '<b style="color:#1976d2;">@')
      // processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
      // return processedContent
      var linkifyStr = require('linkifyjs/string')
      var str = msg
      var processedContent = linkifyStr(str)
      var regex = /\s|<tax>+[\u0E00-\u0E7Fa-zA-Z'|/^\S+@\S+\.\S+$/]+<\/tax>/g
      // var word = msg.match(regex)
      // console.log(word)
      if (msg.match(regex)) {
        for (var i = 0; i < msg.match(regex).length; i++) {
          // var word = msg.match(regex)
          // @click.native.capture=method
          processedContent = processedContent.replace('&lt;tax&gt;', `<b style="color:#1976d2; cursor:pointer;" >@`)
          processedContent = processedContent.replace('&lt;/tax&gt;', '</b>')
        }
      }
      return processedContent
    },
    convertURL (msg) {
      var urlRegex = /\bhttps?:\/\/\S+/gi;
      var linkmsg = msg.match(urlRegex)
      if (linkmsg !== null) {
        if (linkmsg.length !== 0 ) {
          // console.log(linkmsg.slice(0,5))
          linkmsg.length = 1
          return linkmsg
        }
        return ''
      } else {
        return ''
      }
      // console.log(msg.match(urlRegex) !== null);
    },
    clicklink_website (url) {
      // window.open(url)
      this.checkBrowser(url, '')
    },
    testtag() {
      // console.log(this.sendmsg)
    },
    filterlistfriend () {
      if (this.showmention === false && this.typeroom === 'group') {
        // const sectionMsg = this.sendmsg.split(' ')
        // const lastSection = sectionMsg[sectionMsg.length - 1]
        // // console.log(lastSection)
        // const isTag = lastSection.charAt(0) === '@'
        // // console.log(isTag)
        // if(lastSection.charAt(0) === '@' && this.listfriend.length > 1){
        //   var textToSearch = lastSection.slice(1)
        //   this.listfriend_filter = this.listfriend.filter(friend =>
        //     friend.name.toLowerCase().includes(textToSearch.toLowerCase())
        //   )
        //   this.status_tag = true
        //   // console.log(this.listfriend_filter)
        // } else {
        //   this.status_tag = false
        // }
        const sectionMsg = this.sendmsg.split(' ')
        const lastSection = sectionMsg[sectionMsg.length - 1]
        // console.log(lastSection)
        const isTag = lastSection.charAt(0) === '@'
        // console.log(isTag)
        if(isTag){
          // var textToSearch = lastSection.slice(1)
          this.text_search = lastSection.slice(1)
          // console.log(this.listfriend)
          this.listfriend_filter = this.listfriend.filter(friend =>
            friend.name.toLowerCase().includes(this.text_search.toLowerCase())
          )
          // console.log(textToSearch)
          this.status_tag = true
        } else {
          this.status_tag = false
        }
      }
    },
    tagFriend (nametag) {
      this.status_tag = false
      if(this.text_search == ''){
        this.sendmsg = this.sendmsg + nametag + " "
      }else{
        if(nametag.toLowerCase().includes(this.text_search)){
          // console.log()
          this.sendmsg = this.sendmsg.replace(this.text_search , nametag)
        }
      }

      // this.sendmsg = this.sendmsg + nametag + " "
      this.$refs.textareaChat.focus()
    },
    identifyMentionUsers() {
        this.listfriend.map((item) => {
          const condition = `^@${item.name}|\\s@${item.name}`
          const regex = new RegExp(condition, "g")
          var x = []
          this.mentionUsers = this.sendmsg.match(regex)
          x.push(this.mentionUser)
          console.log(x)
        })
    },
  }
}
</script>

<style type="text/css" scoped>
.scrolling-wrapper-template {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper-template::-webkit-scrollbar {
  height: 8px;
  width: 8px;
  /* cursor: pointer; */
}
.scrolling-wrapper-template::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
>>>.vplayer video {
  width: 100% !important;
  max-height: 250px !important;
}
.scrolling-wrapper-y {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper-y::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper-y::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.chat-messages-richmenu {
  padding: 9px !important;
  height: 60px !important;
  width: 75% !important;
  background: #062F64 !important;
  bottom: 0 !important;
  position: fixed !important;
}
.chat-messages-richmenu-sheet {
  padding: 9px !important;
  height: 310px !important;
  width: 75% !important;
  background: #062F64 !important;
  bottom: 0 !important;
  position: fixed !important;
}
.chat-messages-richmenu-sheet-row {
  padding: 9px !important;
  height: 185px !important;
  width: 75% !important;
  background: #062F64 !important;
  bottom: 0 !important;
  position: fixed !important;
}
.text-overflow-quickreply {
  display: block;
  max-width: 20em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text-task-detail {
  color: black !important;
  margin-bottom: 5px !important;
  text-align: left !important;
  overflow: hidden !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
}
.test-overflow-chip {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: 100px !important;
}
.p-announce {
  cursor: pointer !important;
  padding-left: 15px !important;
  padding-right: 15px !important;
}
.p-announce:hover {
  color: #1b232c !important;
}
.list-announce {
  height: 50px;
  cursor: pointer !important;
}
.list-announce:hover {
  cursor: pointer !important;
  background: #b4d1f478 !important;
}
>>>.v-list {
    /* min-width: 210px !important; */
    max-width: 100% !important;
}
.boxself_createablums {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-right: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 25vw;
  cursor: pointer;
  /* height: 250px; */
}
.boxother_createablums {
  cursor: pointer;
  text-align: left;
  /* margin: 20px auto; */
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*margin-top: 0px !important;*/
  float: left;
  max-width: 25vw;
}
.showmention {
  background: #1b232d63 !important;
  margin: 0 !important;
  bottom: 122px !important;
  position: fixed !important;
  width: 50% !important;
  height: 55px !important;
  padding: 5px !important;
}

.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}

.scrolling-wrapper::-webkit-scrollbar {
  height: 5px;
}

.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}

.boxself_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  /*max-width: 170px;*/
  min-height: 18px;
  max-width: 175px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.boxother_unsend {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  min-height: 18px;
  max-width: 225px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.boxother_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  /*font-size: 13px;*/
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;

}

.boxself_system {
  border-radius: 10px;
  background-color: #80808021;
  border-width: thin;
  text-align: center;
  font-size: 13px;
  max-width: 300px;
  padding-left: 5px;
  padding-right: 5px;
  word-break: break-all;
  color: #797979 !important;
  font-size: 11px !important;
}

.text2 {
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}*/

.chatbox {
  width: 100%;
  min-width: 10vw;
  height: calc(100% - 120px);
  /*height: 65vh;*/
  /*font-family: 'CS ChatThaiUI' !important;*/
  background-color: #062e63 !important;
  /*padding: 25px;*/
  /*box-shadow: 0 3px #ccc;*/
}

.centerbox {
  /*font-family: 'CS ChatThaiUI' !important;*/
  /*height: 93vh;*/
  height: calc(100vh - 64px);
  /*background-color: white;*/
  /*background-color: #92959e;*/
  background: #062e63 !important;
}

.chatlogs {
  /* padding: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 10px;
  margin-bottom: 0.5vh;
  background: #fdfdfd;
  border-radius: 5px; */
  padding: 15px;
  padding-top: 5px;
  padding-bottom: 45px !important;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  margin: 10px;
  background: #fdfdfd;
  border-radius: 5px;
}

.chatlogs::-webkit-scrollbar {
  width: 10px;
}

.chatlogs::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}


.chat {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
  height: 100%;
  /*margin-bottom: -2vh;*/
  /*margin-bottom: 10px;*/

}

.chat .user-photo {
  width: 60px;
  height: 60px;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.chat .user-photo img {
  width: 100%
}

.centerimage {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}

.chat .chat-message {
  font-size: 16px;
  position: relative;
  display: inline-block;
  clear: both;
  margin-bottom: 8px;
  padding: 13px 14px;
  vertical-align: top;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 5px;
}

.chat .chat-message:before {
  position: absolute;
  top: 19px;
  display: block;
  width: 8px;
  height: 6px;
  content: '\00a0';
  -moz-transform: rotate(29deg) skew(-35deg);
  -ms-transform: rotate(29deg) skew(-35deg);
  -webkit-transform: rotate(29deg) skew(-35deg);
  transform: rotate(29deg) skew(-35deg);
}

/*.boxfriend{*/
/*background: #C4E0F9;
 text-align: left;
 padding: 10px;
 margin: 5px 10px 0;
 margin-right: 7vw;
 max-width: 22em;*/
/* float: left;
  color: #fff;
  background-color: #00b0ff;
  -webkit-align-self: flex-start;
  align-self: flex-start;
  -moz-animation-name: slideFromLeft;
  -webkit-animation-name: slideFromLeft;
  animation-name: slideFromLeft;
}
.boxfriend:before{
  left: -3px;
  background-color: #00b0ff;
}*/
/*.boxself{*/
/*max-width: 22em;
 padding: 10px;
 margin: 5px 10px 0;
 margin-left: 7vw;
 background: #1da1f2;
 text-align: right;
 order: -1;*/
/*  float: right;
  color: #1a1a1a;
  background-color: #eceff1;
  -webkit-align-self: flex-end;
  align-self: flex-end;
  -moz-animation-name: slideFromRight;
  -webkit-animation-name: slideFromRight;
  animation-name: slideFromRight;
}
.boxself:before {
  right: -3px;
  background-color: #eceff1;
}*/

.chat-form {
  display: flex;
  align-items: flex-start;
  /*background-color: red;*/
  /*margin-top: 1vh;*/
  margin-bottom: 1vh;
}

.chat-form textarea {
  background: #fbfbfb;
  width: 90% !important;
  height: 50px;
  border: 2px solid rgb(155, 155, 155);
  border-radius: 3px;
  resize: none;
  padding: 10px;
  font-size: 18px;
  color: #333;
}

.chat-form textarea:focus {
  background: #fff;
  /*background-color: red;*/
}

.chat-form textarea::-webkit-scrollbar {
  width: 2px;
}

.chat-form textarea::-webkit-scrollbar-thumb {
  /*border-radius: 5px;*/
  background: rgba(0, 0, 0, .1);
}

p .chat-message {
  max-width: 40em;
  /*border: 1px solid #000000;*/
  word-wrap: break-word;
}

.inputWrapper {
  height: 35px;
  width: 40px;
  overflow: hidden;
  position: relative;
  cursor: pointer;
  /*Using a background color, but you can use a background image to represent a button*/
  background-color: #2196f3;
  margin: 5px 10px 0;
  border-radius: 5px;

}

.fileInput {
  cursor: pointer;
  /*height: 100%;*/
  position: absolute;
  /*top: 0;*/
  /*right: 0;*/
  z-index: 99;
  /*This makes the button huge. If you want a bigger button, increase the font size*/
  /*font-size:50px;*/
  /*Opacity settings for all browsers*/
  opacity: 0;
  -moz-opacity: 0;
  filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0)
}

.word-wrap {
  word-wrap: break-word;
}




.thumbnail {
  max-width: 40%;
}

.italic {
  font-style: italic;
}

.small {
  font-size: 0.8em;
}

/** LIGHTBOX MARKUP **/

.lightbox {
  /** Default lightbox to hidden */
  display: none;

  /** Position and style */
  position: fixed;
  z-index: 999;
  width: 100%;
  height: 100%;
  text-align: center;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.8);
}

.lightbox img {
  /** Pad the lightbox image */
  max-width: 90%;
  max-height: 80%;
  margin-top: 2%;

}

.lightbox:target {
  /** Remove default browser outline */
  outline: none;

  /** Unhide lightbox **/
  display: block;
}

/** {
  margin: 0px;
  padding: 0px;
}*/
.boxselfsticker {
  text-align: right;
  /*margin: 20px auto;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  padding: 10px;
  float: right;
  max-width: 15vw;
}

.boxfriendsticker {
  text-align: left;
  /* margin: 20px auto; */
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  /*border-radius: 20px;*/
  /*background: #efefef;*/
  padding: 10px;
  /*position: relative;
  word-wrap: break-word;*/
  /*margin-top: 0px !important;*/
  float: left;
  max-width: 15vw;
}

.boxselffile {
  text-align: right;
  /*margin: 20px auto;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 15px;
  /*padding: 10px;*/
  font-weight: 300;
  color: black;
  text-align: right;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: right;
  max-width: 25vw;
}

.boxfriendfile {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  /*background: #efefef;*/
  color: black;
  /*padding: 10px;*/
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  float: left;
  max-width: 25vw;
}

.boxself {
  text-align: left;
  /*margin: 20px auto;*/
  /*margin-right: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  /*text-align: right;*/
  /*margin-right: 1.5vw;*/
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: right;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 25vw;
}

.boxfriend {
  text-align: left;
  /* margin: 20px auto; */
  /*margin-left: 10px !important;*/
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  /*margin-top: 0px !important;*/
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: left;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 25vw;
}

.boxfriendquestion {
  text-align: left;
  /* margin: 20px auto; */
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  /*display: table-cell;*/
  /*display: inline-block;*/
  float: left;
  /*margin: 5px 45px 5px 20px;*/
  max-width: 40vw;
}
.boxfriendcarousel {
  text-align: left;
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #efefef;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: left;
  max-width: 39vw;
}

.boxselfquestion {
  text-align: left;
  margin-top: 2vh !important;
  margin-bottom: 0 !important;
  border-radius: 20px;
  background: #b4d1f5;
  padding: 10px;
  font-weight: 300;
  color: black;
  font-size: 13px;
  position: relative;
  word-wrap: break-word;
  margin-top: 0px !important;
  float: right;
  max-width: 40vw;
}
/* speech bubble 13 */

.sbself:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid #53ceff;
  border-right: 15px solid transparent;
  border-top: 15px solid #53ceff;
  border-bottom: 15px solid transparent;
  right: -20px;
  top: 14px;


  /*content: "\00a0";
  display: block;
  height: 16px;
  position: absolute;
  top: 11px;
  transform:             rotate( 29deg ) skew( -35deg );
      -moz-transform:    rotate( 29deg ) skew( -35deg );
      -ms-transform:     rotate( 29deg ) skew( -35deg );
      -o-transform:      rotate( 29deg ) skew( -35deg );
      -webkit-transform: rotate( 29deg ) skew( -35deg );
  width:  20px;

  box-shadow: -2px 2px 2px 0 rgba( 178, 178, 178, .4 );
  left: -9px;*/

}


/*.boxfriend  {
  margin-top: 0px !important;
}*/
/* speech bubble 14 */

.sbfriend:before {
  content: "";
  width: 0px;
  height: 0px;
  position: absolute;
  border-left: 15px solid transparent;
  border-right: 15px solid #d4d7d8;
  border-top: 15px solid #d4d7d8;
  border-bottom: 15px solid transparent;
  left: -20px;
  top: 13px;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.imgmessage {
  cursor: pointer;
}

.imgmessage:hover {
  opacity: 0.8;
}

.text {
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 5vh;
  padding-right: 10px;
  padding-top: 0px;
  font-family: 'CSChatThai', sans-serif !important;
}

.chat-messages {
  padding: 9px;
  height: 120px;
  width: 75% !important;
  background: #062F64;
  bottom: 0;
  position: fixed;
}

.chat-messages textarea {
  width: 100%;
  border: none;
  padding: 10px 20px;
  font: 14px/22px "Lato", Arial, sans-serif;
  margin-bottom: 0px;
  border-radius: 5px;
  resize: none;
}

.chat-messages .buttonsend {
  float: right;
  /*color: blue;*/
  font-size: 16px;
  text-transform: none;
  border: none;
  cursor: pointer;
  /*font-weight: bold;*/
  background: none;
  color: white;
  border-radius: 5px;
}

.chat-messages .buttonsend :hover {
  color: darken($blue, 7%);
  /*color: red;
    background: white;*/
}

.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: " ";
  clear: both;
  height: 0;
}

.chat-messages .textareabg {
  background: white;
  width: 100% !important;
  height: 70px !important;
  overflow-y:auto;
}

/*.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}
.conversation-start span {
  font-size: 10px;
  display: inline-block;
  color: #999;
}
.conversation-start span:before, .conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 33vh;
  height: 1px;
  content: '';
  background-color: #e6e6e6;
}
.conversation-start span:before {
  left: 0;
}
..conversation-start span:after {
  right: 0;
}*/

.conversation-start {
  position: relative;
  width: 100%;
  margin-bottom: 2vh;
  text-align: center;
}

.conversation-start span {
  border-style: solid;
  font-size: 10px;
  display: inline-block;
  color: #777777;
  border-width: thin;
  border-radius: 10px;
  width: 80px;
}

.conversation-start span:before,
.conversation-start span:after {
  position: absolute;
  top: 12px;
  display: inline-block;
  width: 120px;
  height: 1px;
  content: '';
}

.conversation-start span:before {
  left: 0;
}

.conversation-start span:after {
  right: 0;
}

.fixed-content {
  min-height: 100%;
  overflow: hidden;
  top: 0;
  bottom: 0;
}

.iconchat:hover {
  color: #52ceff;
}

.chip.chip--outline:hover {
  background: #52ceff40;
}

.icon {
  font-size: 20px !important;
}

.application a {
  color: #1976d2;
}

/* The Modal (background) */
.modalc {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 9;
  /* Sit on top */
  /*padding-top: 20vh;  Location of the box */
  left: 0;
  top: 0;
  width: 100vw;
  /* Full width */
  height: 100vh;
  /* Full height */
  overflow: auto;
  /* Enable scroll if needed */
  /* background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.9);
  /* Black w/ opacity */
  /*background-color: white;*/
}

/* Modal Content (Image) */
.modal-contentc {
  padding-top: 10vh;
  margin: auto;
  display: block;
  /*width: 80%;*/
  /*width: auto;
  height: 70vh;*/
  max-width: 90vw !important;
  max-height: 70vh !important;
}

/* Caption of Modal Image (Image Text) - Same Width as the Image */
#caption {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 100vw;
  text-align: center;
  color: #ccc;
  padding: 10px 0;
  height: 150px;
}

#headcaption {
  margin: auto;
  display: block;

  /*width: 80%;*/
  /*max-width: 100vw;*/
  text-align: left;
  color: white;
  /*padding-left: 15vw ;*/
  padding-top: 1vh;
  padding-bottom: 1vh;
  /*background-color: white;*/
  background-color: #1b232d;
  /*height: 150px;*/
}

/* Add Animation - Zoom in the Modal */
/*.modal-contentc {
    animation-name: zoom;
    animation-duration: 0.6s;
}*/

@keyframes zoom {
  from {
    transform: scale(0)
  }

  to {
    transform: scale(1)
  }
}

/* The Close Button */
.close {
  position: absolute;
  top: 0vh;
  right: 35px;
  color: white;
  font-size: 35px;
  /*font-weight: bold;*/
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px) {
  .modal-contentc {
    width: 100vw;
  }
}


.wrapper {
  position: relative;
  /*display: inline-block;*/
}

/*
.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
}*/

.emoji-invoker {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}


.emoji-invoker:hover {
  transform: scale(1.1);
}

.emoji-invoker>svg {
  fill: white;
}



.emoji-picker {
  position: absolute;
  z-index: 1;
  font-family: Montserrat;
  border: 1px solid #ccc;
  width: 100%;
  height: 20vh;
  /*overflow: scroll;*/
  padding-left: 1rem;
  padding-right: 1rem;
  box-sizing: border-box;
  border-radius: 0.5rem;
  background: #ffffffe6;
  box-shadow: 1px 1px 8px #c7dbe6;
}

.emoji-picker__search {
  display: flex;
}

.emoji-picker__search>input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}

.emoji-picker h5 {
  margin-bottom: 0;
  color: #1b232d;
  /*text-transform: uppercase;*/
  font-size: 0.8rem;
  cursor: default;
  font-family: 'CS ChatThaiUI' !important;
}

.emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.emojis:after {
  content: "";
  flex: auto;
}

.emojis span {
  padding: 0.2rem;
  cursor: pointer;
  border-radius: 5px;
  font-size: 30px;
}

.emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

.menuchat {
  font-size: 30px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}

.menuchatword {
  font-size: 16px !important;
  color: black !important;
  cursor: pointer;
  text-align: center;
}

.textemo {
  color: white;
  text-transform: none !important;
  margin-top: 2vh;
  font-size: 13px;
}

.bgsearchcontact {
  background-color: #232a35 !important;
  color: white !important;
  border-radius: 100px !important;
  font-size: 12px !important;
  margin-top: 2vh !important;
  margin-bottom: 2vh !important;
  width: 50% !important;
}

.btnallow {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #1a75d2 !important;
  color: white !important;
}

.btncancel {
  font-size: 9px !important;
  border-radius: 5px;
  margin-left: 0.2vw !important;
  background: #242b36 !important;
  color: white !important;
}

.EndpointUrl {
  display: block;
  color: #fff;
}

.EndpointUrl:hover .urlcopymessage {
  display: inline !important;
}

.urlcopymessage {
  display: none !important;
}



input[type=texteditgroup] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 10px 10px 10px 10px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}

.sidebar-menu {
  margin: 0;
  padding: 0;
}

.sidebar-menu ul {
  margin: 0;
  padding: 5px;
}

.sidebar-menu li {
  text-align: center;
  /*width: 32.8%;*/
  width: 20%;
  margin-bottom: 3px !important;
  /*background-color: #b4d2f5;*/
  /*border: 1px solid #eee;*/
  display: inline-block;
  padding: 0;
}

.sidebar-menu i {
  display: block;
  margin: 0 auto 10px auto;
  width: 32px;
  height: 32px;
  margin: 10px auto 0;
  line-height: 32px;
  text-align: center;
  font-size: 20px;
  color: #444444;
  margin-top: 0;
  /*padding-top: 5px;*/
}

.sidebar-menu a {
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  margin: 0;
  padding: 0;
  font-size: 13px !important;
  /*border: #2662af solid 1px;*/
  /*background-color: #b4d2f5;*/
  border-radius: 10px;
}

.sidebar-menu a span {
  color: #fdfdfd;
  /*font-size: 10px !important;*/
  padding: 5px 0 10px 0;
  display: block;
  text-transform: uppercase;
  /*font-family:'Josefin Sans';*/
  letter-spacing: 1px;
}
.sidebar-menu a:hover span {
  color: #062e63;
}

.sidebar-menu a:hover i {
  color: #2562ae;
}

.sidebar-menu a:hover {
  font-size: 13px !important;
  background: #ededed;
}


.sidebar-menu li:hover {
  /*width: 25%;*/
}

/*>>> .v-item-group.v-bottom-nav .v-btn:not(.v-btn--active)::before {
    color: red !important;
  }*/
.text-transform {
  text-transform: none;
}
.quick_reply {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: #2160b0 1px solid;
  color: #2160b0;
}

.quick_reply:hover {
  background: #1976d240 !important;
}

.quick_replydis {
  background: white !important;
  text-transform: none;
  font-weight: 200;
  border: lightgrey 1px solid;
  color: #2160b0;
}

.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.THSarabun{
  font-family: 'THSarabun', sans-serif !important;
}
.Maitree{
  font-family: 'Maitree', sans-serif !important;
}
.CSChatThai{
  font-family: 'CS ChatThaiUI', sans-serif !important;
}
>>>.v-tabs__container {
  height: 25px;
  background: #062e63 !important;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 85px !important;
  height: 83px !important;
  position: relative;
  background: white;
}


.listfile {
  overflow-x: scroll !important;
  overflow-y: hidden !important;
  height: 90px !important;
  display: -webkit-inline-box !important;
  background: #afafaf3d !important;
  padding-top: 3px !important;
  border-radius: 4px !important;
  width: 100% !important;
  /*margin-bottom: 15px !important;*/
}
[class*='close-'] {
  color: #777;
  font: 14px/100% arial, sans-serif;
  position: absolute;
  right: 5px;
  text-decoration: none;
  text-shadow: 0 1px 0 #fff;
  top: 5px;
}
.close-classic:after {
  content: '×'; /* ANSI X letter */
}
.border_website {
  border-left: #153c6d 2px solid;
  padding-left: 5px;
}
.description_website {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #556579;
}
.title_website {
  margin: 0 !important;
  font-weight: 600;
  color: #2562af;
}
.img_website {
    height: 50px;
    width: 50px;
    margin: auto;
}
.centerimg_website {
  justify-content: center;
  display: flex;
}

.joinBtn {
  margin-top: 15px;
  border-radius: 20px !important;
  background: #294071 !important;
  color: white !important;
  text-transform: none !important;
}

.scrolling-wrapper {
  display: flex;
  overflow-x: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 7px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: rgba(0, 0, 0, .1);
}
.friendList {
  position: absolute;
  bottom: 100px;
  max-height: 200px;
  overflow-y:auto;
  max-width: 350px;
  /* left: 20px; */
}



.friendList::-webkit-scrollbar {
  width: 4px;
}

.friendList::-webkit-scrollbar-thumb {

  background: rgba(0, 0, 0, .1);
}
.atsign {
    /* background-color: green; */
    color: blue;
    padding: 0px 2px;
}

>>>.atwho-view {
    position: absolute;
    bottom: 0;
    left: -.8em;
    cursor: default;
    background-color: hsla(0,0%,100%,.94);
    min-width: 400px;
    /* min-height: 100px; */
    /* max-width: 180px; */
    /* max-height: 200px; */
    overflow-y: auto;
}

>>>.atwho-li {
    box-sizing: border-box;
    height: 50px;
    padding: 0 12px;
    white-space: nowrap;
    display: flex;
    align-items: center;
    cursor: pointer;
}
.atwho-ul {
    /* max-height: 135px; */
    padding: 0;
    margin: 0;
}
>>>.atwho-li span {
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
}

/* div[contenteditable] {
  border: 1px solid black;
  text-align: left;
  padding: 5px 10px;
  border-radius: 4px;
}
div[contentEditable]:empty:before {
  content: attr(placeholder);
  color: grey;
} */

 .highlights__content {
  position: relative;
}

.highlights__placeholder {
  color: #ccc;
  position: relative;
  top: 16px;
  left: 16px;
  z-index: -1;
}

.highlights__body-container {
  border-radius: 5px;
  border: 1px solid #eaeaea;
  padding: 16px;
}

/* .highlights__body {
  min-height: 60px;
} */
/*
.highlights {
  color: #ff3b8e;
} */

>>>.highlights.username{
  color: #ff3b8e !important;
}

#content{
  border: 1px solid black;
}
</style>



// WEBPACK FOOTER //
// src/components/chat/onemeet/ChatSideOnemeet.vue